var items = {
  "block.minecraft.acacia_button": "بوتڠ اکاسيا",
  "block.minecraft.acacia_door": "ڤينتو کايو اکاسيا",
  "block.minecraft.acacia_fence": "ڤاݢر اکاسيا",
  "block.minecraft.acacia_fence_gate": "ڤينتو ڤاݢر اکاسيا",
  "block.minecraft.acacia_hanging_sign": "ڤاڤن تندا برݢنتوڠ اکاسيا",
  "block.minecraft.acacia_leaves": "داٴون اکاسيا",
  "block.minecraft.acacia_log": "کايو بالق اکاسيا",
  "block.minecraft.acacia_planks": "ڤاڤن کايو اکاسيا",
  "block.minecraft.acacia_pressure_plate": "ڤلت تکنن اکاسيا",
  "block.minecraft.acacia_sapling": "انق ڤوکوق اکاسيا",
  "block.minecraft.acacia_shelf": "رق اکاسيا",
  "block.minecraft.acacia_sign": "ڤاڤن تندا اکاسيا",
  "block.minecraft.acacia_slab": "ڤاڤق اکاسيا",
  "block.minecraft.acacia_stairs": "تڠݢ اکاسيا",
  "block.minecraft.acacia_trapdoor": "ڤينتو کولوڠ اکاسيا",
  "block.minecraft.acacia_wall_hanging_sign": "ڤاڤن تندا دينديڠ برݢنتوڠ اکاسيا",
  "block.minecraft.acacia_wall_sign": "ڤاڤن تندا دينديڠ اکاسيا",
  "block.minecraft.acacia_wood": "کايو اکاسيا",
  "block.minecraft.activator_rail": "لندسن ڤڠاکتيف",
  "block.minecraft.air": "اودارا",
  "block.minecraft.allium": "اليوم",
  "block.minecraft.amethyst_block": "بلوک باتو کچوبوڠ",
  "block.minecraft.amethyst_cluster": "ݢوݢوسن باتو کچوبوڠ",
  "block.minecraft.ancient_debris": "ڤوٴيڠ ڤوربا",
  "block.minecraft.andesite": "اندسيت",
  "block.minecraft.andesite_slab": "ڤاڤق اندسيت",
  "block.minecraft.andesite_stairs": "تڠݢ اندسيت",
  "block.minecraft.andesite_wall": "تيمبوق اندسيت",
  "block.minecraft.anvil": "اندس",
  "block.minecraft.attached_melon_stem": "باتڠ تمبيکاي ترهوبوڠ",
  "block.minecraft.attached_pumpkin_stem": "باتڠ لابو ترهوبوڠ",
  "block.minecraft.azalea": "ازاليا",
  "block.minecraft.azalea_leaves": "داٴون ازاليا",
  "block.minecraft.azure_bluet": "ايزور بلوٴيت",
  "block.minecraft.bamboo": "بولوه",
  "block.minecraft.bamboo_block": "بلوک بولوه",
  "block.minecraft.bamboo_button": "بوتڠ بولوه",
  "block.minecraft.bamboo_door": "ڤينتو بولوه",
  "block.minecraft.bamboo_fence": "ڤاݢر بولوه",
  "block.minecraft.bamboo_fence_gate": "ڤينتو ڤاݢر بولوه",
  "block.minecraft.bamboo_hanging_sign": "ڤاڤن تندا برݢنتوڠ بولوه",
  "block.minecraft.bamboo_mosaic": "اڽمن بولوه",
  "block.minecraft.bamboo_mosaic_slab": "ڤاڤق اڽمن بولوه",
  "block.minecraft.bamboo_mosaic_stairs": "تڠݢ اڽمن بولوه",
  "block.minecraft.bamboo_planks": "ڤاڤن بولوه",
  "block.minecraft.bamboo_pressure_plate": "ڤلت تکنن بولوه",
  "block.minecraft.bamboo_sapling": "ربوڠ",
  "block.minecraft.bamboo_shelf": "رق بولوه",
  "block.minecraft.bamboo_sign": "ڤاڤن تندا بولوه",
  "block.minecraft.bamboo_slab": "ڤاڤق بولوه",
  "block.minecraft.bamboo_stairs": "تڠݢ بولوه",
  "block.minecraft.bamboo_trapdoor": "ڤينتو کولوڠ بولوه",
  "block.minecraft.bamboo_wall_hanging_sign": "ڤاڤن تندا دينديڠ برݢنتوڠ بولوه",
  "block.minecraft.bamboo_wall_sign": "ڤاڤن تندا دينديڠ بولوه",
  "block.minecraft.banner.base.black": "لاتر هيتم ڤنوه",
  "block.minecraft.banner.base.blue": "لاتر بيرو ڤنوه",
  "block.minecraft.banner.base.brown": "لاتر ڤيرڠ ڤنوه",
  "block.minecraft.banner.base.cyan": "لاتر سيان ڤنوه",
  "block.minecraft.banner.base.gray": "لاتر کلابو ڤنوه",
  "block.minecraft.banner.base.green": "لاتر هيجاو ڤنوه",
  "block.minecraft.banner.base.light_blue": "لاتر بيرو مودا ڤنوه",
  "block.minecraft.banner.base.light_gray": "لاتر کلابو مودا ڤنوه",
  "block.minecraft.banner.base.lime": "لاتر هيجاو مودا ڤنوه",
  "block.minecraft.banner.base.magenta": "لاتر ماݢينتا ڤنوه",
  "block.minecraft.banner.base.orange": "لاتر جيڠݢ ڤنوه",
  "block.minecraft.banner.base.pink": "لاتر ميره جمبو ڤنوه",
  "block.minecraft.banner.base.purple": "لاتر اوڠو ڤنوه",
  "block.minecraft.banner.base.red": "لاتر ميره ڤنوه",
  "block.minecraft.banner.base.white": "لاتر ڤوتيه ڤنوه",
  "block.minecraft.banner.base.yellow": "لاتر کونيڠ ڤنوه",
  "block.minecraft.banner.border.black": "بيڠکاي هيتم",
  "block.minecraft.banner.border.blue": "بيڠکاي بيرو",
  "block.minecraft.banner.border.brown": "بيڠکاي ڤيرڠ",
  "block.minecraft.banner.border.cyan": "بيڠکاي سيان",
  "block.minecraft.banner.border.gray": "بيڠکاي کلابو",
  "block.minecraft.banner.border.green": "بيڠکاي هيجاو",
  "block.minecraft.banner.border.light_blue": "بيڠکاي بيرو مودا",
  "block.minecraft.banner.border.light_gray": "بيڠکاي کلابو مودا",
  "block.minecraft.banner.border.lime": "بيڠکاي هيجاو مودا",
  "block.minecraft.banner.border.magenta": "بيڠکاي ماݢينتا",
  "block.minecraft.banner.border.orange": "بيڠکاي جيڠݢ",
  "block.minecraft.banner.border.pink": "بيڠکاي ميره جمبو",
  "block.minecraft.banner.border.purple": "بيڠکاي اوڠو",
  "block.minecraft.banner.border.red": "بيڠکاي ميره",
  "block.minecraft.banner.border.white": "بيڠکاي ڤوتيه",
  "block.minecraft.banner.border.yellow": "بيڠکاي کونيڠ",
  "block.minecraft.banner.bricks.black": "باتاٴن هيتم",
  "block.minecraft.banner.bricks.blue": "باتاٴن بيرو",
  "block.minecraft.banner.bricks.brown": "باتاٴن ڤيرڠ",
  "block.minecraft.banner.bricks.cyan": "باتاٴن سيان",
  "block.minecraft.banner.bricks.gray": "باتاٴن کلابو",
  "block.minecraft.banner.bricks.green": "باتاٴن هيجاو",
  "block.minecraft.banner.bricks.light_blue": "باتاٴن بيرو مودا",
  "block.minecraft.banner.bricks.light_gray": "باتاٴن کلابو مودا",
  "block.minecraft.banner.bricks.lime": "باتاٴن هيجاو مودا",
  "block.minecraft.banner.bricks.magenta": "باتاٴن ماݢينتا",
  "block.minecraft.banner.bricks.orange": "باتاٴن جيڠݢ",
  "block.minecraft.banner.bricks.pink": "باتاٴن ميره جمبو",
  "block.minecraft.banner.bricks.purple": "باتاٴن اوڠو",
  "block.minecraft.banner.bricks.red": "باتاٴن ميره",
  "block.minecraft.banner.bricks.white": "باتاٴن ڤوتيه",
  "block.minecraft.banner.bricks.yellow": "باتاٴن کونيڠ",
  "block.minecraft.banner.circle.black": "بولتن هيتم",
  "block.minecraft.banner.circle.blue": "بولتن بيرو",
  "block.minecraft.banner.circle.brown": "بولتن ڤيرڠ",
  "block.minecraft.banner.circle.cyan": "بولتن سيان",
  "block.minecraft.banner.circle.gray": "بولتن کلابو",
  "block.minecraft.banner.circle.green": "بولتن هيجاو",
  "block.minecraft.banner.circle.light_blue": "بولتن بيرو مودا",
  "block.minecraft.banner.circle.light_gray": "بولتن کلابو مودا",
  "block.minecraft.banner.circle.lime": "بولتن هيجاو مودا",
  "block.minecraft.banner.circle.magenta": "بولتن ماݢينتا",
  "block.minecraft.banner.circle.orange": "بولتن جيڠݢ",
  "block.minecraft.banner.circle.pink": "بولتن ميره جمبو",
  "block.minecraft.banner.circle.purple": "بولتن اوڠو",
  "block.minecraft.banner.circle.red": "بولتن ميره",
  "block.minecraft.banner.circle.white": "بولتن ڤوتيه",
  "block.minecraft.banner.circle.yellow": "بولتن کونيڠ",
  "block.minecraft.banner.creeper.black": "لامبڠ کريڤر هيتم",
  "block.minecraft.banner.creeper.blue": "لامبڠ کريڤر بيرو",
  "block.minecraft.banner.creeper.brown": "لامبڠ کريڤر ڤيرڠ",
  "block.minecraft.banner.creeper.cyan": "لامبڠ کريڤر سيان",
  "block.minecraft.banner.creeper.gray": "لامبڠ کريڤر کلابو",
  "block.minecraft.banner.creeper.green": "لامبڠ کريڤر هيجاو",
  "block.minecraft.banner.creeper.light_blue": "لامبڠ کريڤر بيرو مودا",
  "block.minecraft.banner.creeper.light_gray": "لامبڠ کريڤر کلابو مودا",
  "block.minecraft.banner.creeper.lime": "لامبڠ کريڤر هيجاو مودا",
  "block.minecraft.banner.creeper.magenta": "لامبڠ کريڤر ماݢينتا",
  "block.minecraft.banner.creeper.orange": "لامبڠ کريڤر جيڠݢ",
  "block.minecraft.banner.creeper.pink": "لامبڠ کريڤر ميره جمبو",
  "block.minecraft.banner.creeper.purple": "لامبڠ کريڤر اوڠو",
  "block.minecraft.banner.creeper.red": "لامبڠ کريڤر ميره",
  "block.minecraft.banner.creeper.white": "لامبڠ کريڤر ڤوتيه",
  "block.minecraft.banner.creeper.yellow": "لامبڠ کريڤر کونيڠ",
  "block.minecraft.banner.cross.black": "ڤالڠ سيروڠ هيتم",
  "block.minecraft.banner.cross.blue": "ڤالڠ سيروڠ بيرو",
  "block.minecraft.banner.cross.brown": "ڤالڠ سيروڠ ڤيرڠ",
  "block.minecraft.banner.cross.cyan": "ڤالڠ سيروڠ سيان",
  "block.minecraft.banner.cross.gray": "ڤالڠ سيروڠ کلابو",
  "block.minecraft.banner.cross.green": "ڤالڠ سيروڠ هيجاو",
  "block.minecraft.banner.cross.light_blue": "ڤالڠ سيروڠ بيرو مودا",
  "block.minecraft.banner.cross.light_gray": "ڤالڠ سيروڠ کلابو مودا",
  "block.minecraft.banner.cross.lime": "ڤالڠ سيروڠ هيجاو مودا",
  "block.minecraft.banner.cross.magenta": "ڤالڠ سيروڠ ماݢينتا",
  "block.minecraft.banner.cross.orange": "ڤالڠ سيروڠ جيڠݢ",
  "block.minecraft.banner.cross.pink": "ڤالڠ سيروڠ ميره جمبو",
  "block.minecraft.banner.cross.purple": "ڤالڠ سيروڠ اوڠو",
  "block.minecraft.banner.cross.red": "ڤالڠ سيروڠ ميره",
  "block.minecraft.banner.cross.white": "ڤالڠ سيروڠ ڤوتيه",
  "block.minecraft.banner.cross.yellow": "ڤالڠ سيروڠ کونيڠ",
  "block.minecraft.banner.curly_border.black": "بيڠکاي برݢريݢي هيتم",
  "block.minecraft.banner.curly_border.blue": "بيڠکاي برݢريݢي بيرو",
  "block.minecraft.banner.curly_border.brown": "بيڠکاي برݢريݢي ڤيرڠ",
  "block.minecraft.banner.curly_border.cyan": "بيڠکاي برݢريݢي سيان",
  "block.minecraft.banner.curly_border.gray": "بيڠکاي برݢريݢي کلابو",
  "block.minecraft.banner.curly_border.green": "بيڠکاي برݢريݢي هيجاو",
  "block.minecraft.banner.curly_border.light_blue": "بيڠکاي برݢريݢي بيرو مودا",
  "block.minecraft.banner.curly_border.light_gray": "بيڠکاي برݢريݢي کلابو مودا",
  "block.minecraft.banner.curly_border.lime": "بيڠکاي برݢريݢي هيجاو مودا",
  "block.minecraft.banner.curly_border.magenta": "بيڠکاي برݢريݢي ماݢينتا",
  "block.minecraft.banner.curly_border.orange": "بيڠکاي برݢريݢي جيڠݢ",
  "block.minecraft.banner.curly_border.pink": "بيڠکاي برݢريݢي ميره جمبو",
  "block.minecraft.banner.curly_border.purple": "بيڠکاي برݢريݢي اوڠو",
  "block.minecraft.banner.curly_border.red": "بيڠکاي برݢريݢي ميره",
  "block.minecraft.banner.curly_border.white": "بيڠکاي برݢريݢي ڤوتيه",
  "block.minecraft.banner.curly_border.yellow": "بيڠکاي برݢريݢي کونيڠ",
  "block.minecraft.banner.diagonal_left.black": "بلهن سيروڠ کيري هيتم",
  "block.minecraft.banner.diagonal_left.blue": "بلهن سيروڠ کيري بيرو",
  "block.minecraft.banner.diagonal_left.brown": "بلهن سيروڠ کيري ڤيرڠ",
  "block.minecraft.banner.diagonal_left.cyan": "بلهن سيروڠ کيري سيان",
  "block.minecraft.banner.diagonal_left.gray": "بلهن سيروڠ کيري کلابو",
  "block.minecraft.banner.diagonal_left.green": "بلهن سيروڠ کيري هيجاو",
  "block.minecraft.banner.diagonal_left.light_blue": "بلهن سيروڠ کيري بيرو مودا",
  "block.minecraft.banner.diagonal_left.light_gray": "بلهن سيروڠ کيري کلابو مودا",
  "block.minecraft.banner.diagonal_left.lime": "بلهن سيروڠ کيري هيجاو مودا",
  "block.minecraft.banner.diagonal_left.magenta": "بلهن سيروڠ کيري ماݢينتا",
  "block.minecraft.banner.diagonal_left.orange": "بلهن سيروڠ کيري جيڠݢ",
  "block.minecraft.banner.diagonal_left.pink": "بلهن سيروڠ کيري ميره جمبو",
  "block.minecraft.banner.diagonal_left.purple": "بلهن سيروڠ کيري اوڠو",
  "block.minecraft.banner.diagonal_left.red": "بلهن سيروڠ کيري ميره",
  "block.minecraft.banner.diagonal_left.white": "بلهن سيروڠ کيري ڤوتيه",
  "block.minecraft.banner.diagonal_left.yellow": "بلهن سيروڠ کيري کونيڠ",
  "block.minecraft.banner.diagonal_right.black": "بلهن سيروڠ هيتم",
  "block.minecraft.banner.diagonal_right.blue": "بلهن سيروڠ بيرو",
  "block.minecraft.banner.diagonal_right.brown": "بلهن سيروڠ ڤيرڠ",
  "block.minecraft.banner.diagonal_right.cyan": "بلهن سيروڠ سيان",
  "block.minecraft.banner.diagonal_right.gray": "بلهن سيروڠ کلابو",
  "block.minecraft.banner.diagonal_right.green": "بلهن سيروڠ هيجاو",
  "block.minecraft.banner.diagonal_right.light_blue": "بلهن سيروڠ بيرو مودا",
  "block.minecraft.banner.diagonal_right.light_gray": "بلهن سيروڠ کلابو مودا",
  "block.minecraft.banner.diagonal_right.lime": "بلهن سيروڠ هيجاو مودا",
  "block.minecraft.banner.diagonal_right.magenta": "بلهن سيروڠ ماݢينتا",
  "block.minecraft.banner.diagonal_right.orange": "بلهن سيروڠ جيڠݢ",
  "block.minecraft.banner.diagonal_right.pink": "بلهن سيروڠ ميره جمبو",
  "block.minecraft.banner.diagonal_right.purple": "بلهن سيروڠ اوڠو",
  "block.minecraft.banner.diagonal_right.red": "بلهن سيروڠ ميره",
  "block.minecraft.banner.diagonal_right.white": "بلهن سيروڠ ڤوتيه",
  "block.minecraft.banner.diagonal_right.yellow": "بلهن سيروڠ کونيڠ",
  "block.minecraft.banner.diagonal_up_left.black": "بلهن سيروڠ سوڠسڠ هيتم",
  "block.minecraft.banner.diagonal_up_left.blue": "بلهن سيروڠ سوڠسڠ بيرو",
  "block.minecraft.banner.diagonal_up_left.brown": "بلهن سيروڠ سوڠسڠ ڤيرڠ",
  "block.minecraft.banner.diagonal_up_left.cyan": "بلهن سيروڠ سوڠسڠ سيان",
  "block.minecraft.banner.diagonal_up_left.gray": "بلهن سيروڠ سوڠسڠ کلابو",
  "block.minecraft.banner.diagonal_up_left.green": "بلهن سيروڠ سوڠسڠ هيجاو",
  "block.minecraft.banner.diagonal_up_left.light_blue": "بلهن سيروڠ سوڠسڠ بيرو مودا",
  "block.minecraft.banner.diagonal_up_left.light_gray": "بلهن سيروڠ سوڠسڠ کلابو مودا",
  "block.minecraft.banner.diagonal_up_left.lime": "بلهن سيروڠ سوڠسڠ هيجاو مودا",
  "block.minecraft.banner.diagonal_up_left.magenta": "بلهن سيروڠ سوڠسڠ ماݢينتا",
  "block.minecraft.banner.diagonal_up_left.orange": "بلهن سيروڠ سوڠسڠ جيڠݢ",
  "block.minecraft.banner.diagonal_up_left.pink": "بلهن سيروڠ سوڠسڠ ميره جمبو",
  "block.minecraft.banner.diagonal_up_left.purple": "بلهن سيروڠ سوڠسڠ اوڠو",
  "block.minecraft.banner.diagonal_up_left.red": "بلهن سيروڠ سوڠسڠ ميره",
  "block.minecraft.banner.diagonal_up_left.white": "بلهن سيروڠ سوڠسڠ ڤوتيه",
  "block.minecraft.banner.diagonal_up_left.yellow": "بلهن سيروڠ سوڠسڠ کونيڠ",
  "block.minecraft.banner.diagonal_up_right.black": "بلهن سيروڠ کيري سوڠسڠ هيتم",
  "block.minecraft.banner.diagonal_up_right.blue": "بلهن سيروڠ کيري سوڠسڠ بيرو",
  "block.minecraft.banner.diagonal_up_right.brown": "بلهن سيروڠ کيري سوڠسڠ ڤيرڠ",
  "block.minecraft.banner.diagonal_up_right.cyan": "بلهن سيروڠ کيري سوڠسڠ سيان",
  "block.minecraft.banner.diagonal_up_right.gray": "بلهن سيروڠ کيري سوڠسڠ کلابو",
  "block.minecraft.banner.diagonal_up_right.green": "بلهن سيروڠ کيري سوڠسڠ هيجاو",
  "block.minecraft.banner.diagonal_up_right.light_blue": "بلهن سيروڠ کيري سوڠسڠ بيرو مودا",
  "block.minecraft.banner.diagonal_up_right.light_gray": "بلهن سيروڠ کيري سوڠسڠ کلابو مودا",
  "block.minecraft.banner.diagonal_up_right.lime": "بلهن سيروڠ کيري سوڠسڠ هيجاو مودا",
  "block.minecraft.banner.diagonal_up_right.magenta": "بلهن سيروڠ کيري سوڠسڠ ماݢينتا",
  "block.minecraft.banner.diagonal_up_right.orange": "بلهن سيروڠ کيري سوڠسڠ جيڠݢ",
  "block.minecraft.banner.diagonal_up_right.pink": "بلهن سيروڠ کيري سوڠسڠ ميره جمبو",
  "block.minecraft.banner.diagonal_up_right.purple": "بلهن سيروڠ کيري سوڠسڠ اوڠو",
  "block.minecraft.banner.diagonal_up_right.red": "بلهن سيروڠ کيري سوڠسڠ ميره",
  "block.minecraft.banner.diagonal_up_right.white": "بلهن سيروڠ کيري سوڠسڠ ڤوتيه",
  "block.minecraft.banner.diagonal_up_right.yellow": "بلهن سيروڠ کيري سوڠسڠ کونيڠ",
  "block.minecraft.banner.flow.black": "اليرن هيتم",
  "block.minecraft.banner.flow.blue": "اليرن بيرو",
  "block.minecraft.banner.flow.brown": "اليرن ڤيرڠ",
  "block.minecraft.banner.flow.cyan": "اليرن سيان",
  "block.minecraft.banner.flow.gray": "اليرن کلابو",
  "block.minecraft.banner.flow.green": "اليرن هيجاو",
  "block.minecraft.banner.flow.light_blue": "اليرن بيرو مودا",
  "block.minecraft.banner.flow.light_gray": "اليرن کلابو مودا",
  "block.minecraft.banner.flow.lime": "اليرن هيجاو مودا",
  "block.minecraft.banner.flow.magenta": "اليرن ماݢينتا",
  "block.minecraft.banner.flow.orange": "اليرن جيڠݢ",
  "block.minecraft.banner.flow.pink": "اليرن ميره جمبو",
  "block.minecraft.banner.flow.purple": "اليرن اوڠو",
  "block.minecraft.banner.flow.red": "اليرن ميره",
  "block.minecraft.banner.flow.white": "اليرن ڤوتيه",
  "block.minecraft.banner.flow.yellow": "اليرن کونيڠ",
  "block.minecraft.banner.flower.black": "لامبڠ بوڠا هيتم",
  "block.minecraft.banner.flower.blue": "لامبڠ بوڠا بيرو",
  "block.minecraft.banner.flower.brown": "لامبڠ بوڠا ڤيرڠ",
  "block.minecraft.banner.flower.cyan": "لامبڠ بوڠا سيان",
  "block.minecraft.banner.flower.gray": "لامبڠ بوڠا کلابو",
  "block.minecraft.banner.flower.green": "لامبڠ بوڠا هيجاو",
  "block.minecraft.banner.flower.light_blue": "لامبڠ بوڠا بيرو مودا",
  "block.minecraft.banner.flower.light_gray": "لامبڠ بوڠا کلابو مودا",
  "block.minecraft.banner.flower.lime": "لامبڠ بوڠا هيجاو مودا",
  "block.minecraft.banner.flower.magenta": "لامبڠ بوڠا ماݢينتا",
  "block.minecraft.banner.flower.orange": "لامبڠ بوڠا جيڠݢ",
  "block.minecraft.banner.flower.pink": "لامبڠ بوڠا ميره جمبو",
  "block.minecraft.banner.flower.purple": "لامبڠ بوڠا اوڠو",
  "block.minecraft.banner.flower.red": "لامبڠ بوڠا ميره",
  "block.minecraft.banner.flower.white": "لامبڠ بوڠا ڤوتيه",
  "block.minecraft.banner.flower.yellow": "لامبڠ بوڠا کونيڠ",
  "block.minecraft.banner.globe.black": "ݢلوب هيتم",
  "block.minecraft.banner.globe.blue": "ݢلوب بيرو",
  "block.minecraft.banner.globe.brown": "ݢلوب ڤيرڠ",
  "block.minecraft.banner.globe.cyan": "ݢلوب بيرو",
  "block.minecraft.banner.globe.gray": "ݢلوب کلابو",
  "block.minecraft.banner.globe.green": "ݢلوب هيجاو",
  "block.minecraft.banner.globe.light_blue": "ݢلوب بيرو مودا",
  "block.minecraft.banner.globe.light_gray": "ݢلوب کلابو مودا",
  "block.minecraft.banner.globe.lime": "ݢلوب هيجاو مودا",
  "block.minecraft.banner.globe.magenta": "ݢلوب ماݢينتا",
  "block.minecraft.banner.globe.orange": "ݢلوب جيڠݢ",
  "block.minecraft.banner.globe.pink": "ݢلوب ميره جمبو",
  "block.minecraft.banner.globe.purple": "ݢلوب اوڠو",
  "block.minecraft.banner.globe.red": "ݢلوب ميره",
  "block.minecraft.banner.globe.white": "ݢلوب ڤوتيه",
  "block.minecraft.banner.globe.yellow": "ݢلوب کونيڠ",
  "block.minecraft.banner.gradient.black": "ݢرادين هيتم",
  "block.minecraft.banner.gradient.blue": "ݢرادين بيرو",
  "block.minecraft.banner.gradient.brown": "ݢرادين ڤيرڠ",
  "block.minecraft.banner.gradient.cyan": "ݢرادين سيان",
  "block.minecraft.banner.gradient.gray": "ݢرادين کلابو",
  "block.minecraft.banner.gradient.green": "ݢرادين هيجاو",
  "block.minecraft.banner.gradient.light_blue": "ݢرادين بيرو مودا",
  "block.minecraft.banner.gradient.light_gray": "ݢرادين کلابو مودا",
  "block.minecraft.banner.gradient.lime": "ݢرادين هيجاو مودا",
  "block.minecraft.banner.gradient.magenta": "ݢرادين ماݢينتا",
  "block.minecraft.banner.gradient.orange": "ݢرادين جيڠݢ",
  "block.minecraft.banner.gradient.pink": "ݢرادين ميره جمبو",
  "block.minecraft.banner.gradient.purple": "ݢرادين اوڠو",
  "block.minecraft.banner.gradient.red": "ݢرادين ميره",
  "block.minecraft.banner.gradient.white": "ݢرادين ڤوتيه",
  "block.minecraft.banner.gradient.yellow": "ݢرادين کونيڠ",
  "block.minecraft.banner.gradient_up.black": "ݢرادين ڤڠاکي هيتم",
  "block.minecraft.banner.gradient_up.blue": "ݢرادين ڤڠاکي بيرو",
  "block.minecraft.banner.gradient_up.brown": "ݢرادين ڤڠاکي ڤيرڠ",
  "block.minecraft.banner.gradient_up.cyan": "ݢرادين ڤڠاکي سيان",
  "block.minecraft.banner.gradient_up.gray": "ݢرادين ڤڠاکي کلابو",
  "block.minecraft.banner.gradient_up.green": "ݢرادين ڤڠاکي هيجاو",
  "block.minecraft.banner.gradient_up.light_blue": "ݢرادين ڤڠاکي بيرو مودا",
  "block.minecraft.banner.gradient_up.light_gray": "ݢرادين ڤڠاکي کلابو مودا",
  "block.minecraft.banner.gradient_up.lime": "ݢرادين ڤڠاکي هيجاو مودا",
  "block.minecraft.banner.gradient_up.magenta": "ݢرادين ڤڠاکي ماݢينتا",
  "block.minecraft.banner.gradient_up.orange": "ݢرادين ڤڠاکي جيڠݢ",
  "block.minecraft.banner.gradient_up.pink": "ݢرادين ڤڠاکي ميره جمبو",
  "block.minecraft.banner.gradient_up.purple": "ݢرادين ڤڠاکي اوڠو",
  "block.minecraft.banner.gradient_up.red": "ݢرادين ڤڠاکي ميره",
  "block.minecraft.banner.gradient_up.white": "ݢرادين ڤڠاکي ڤوتيه",
  "block.minecraft.banner.gradient_up.yellow": "ݢرادين ڤڠاکي کونيڠ",
  "block.minecraft.banner.guster.black": "ڤموسر هيتم",
  "block.minecraft.banner.guster.blue": "ڤموسر بيرو",
  "block.minecraft.banner.guster.brown": "ڤموسر ڤيرڠ",
  "block.minecraft.banner.guster.cyan": "ڤموسر سيان",
  "block.minecraft.banner.guster.gray": "ڤموسر کلابو",
  "block.minecraft.banner.guster.green": "ڤموسر هيجاو",
  "block.minecraft.banner.guster.light_blue": "ڤموسر بيرو مودا",
  "block.minecraft.banner.guster.light_gray": "ڤموسر کلابو مودا",
  "block.minecraft.banner.guster.lime": "ڤموسر هيجاو مودا",
  "block.minecraft.banner.guster.magenta": "ڤموسر ماݢينتا",
  "block.minecraft.banner.guster.orange": "ڤموسر جيڠݢ",
  "block.minecraft.banner.guster.pink": "ڤموسر ميره جمبو",
  "block.minecraft.banner.guster.purple": "ڤموسر اوڠو",
  "block.minecraft.banner.guster.red": "ڤموسر ميره",
  "block.minecraft.banner.guster.white": "ڤموسر ڤوتيه",
  "block.minecraft.banner.guster.yellow": "ڤموسر کونيڠ",
  "block.minecraft.banner.half_horizontal.black": "بلهن مڠوفوق هيتم",
  "block.minecraft.banner.half_horizontal.blue": "بلهن مڠوفوق بيرو",
  "block.minecraft.banner.half_horizontal.brown": "بلهن مڠوفوق ڤيرڠ",
  "block.minecraft.banner.half_horizontal.cyan": "بلهن مڠوفوق سيان",
  "block.minecraft.banner.half_horizontal.gray": "بلهن مڠوفوق کلابو",
  "block.minecraft.banner.half_horizontal.green": "بلهن مڠوفوق هيجاو",
  "block.minecraft.banner.half_horizontal.light_blue": "بلهن مڠوفوق بيرو مودا",
  "block.minecraft.banner.half_horizontal.light_gray": "بلهن مڠوفوق کلابو مودا",
  "block.minecraft.banner.half_horizontal.lime": "بلهن مڠوفوق هيجاو مودا",
  "block.minecraft.banner.half_horizontal.magenta": "بلهن مڠوفوق ماݢينتا",
  "block.minecraft.banner.half_horizontal.orange": "بلهن مڠوفوق جيڠݢ",
  "block.minecraft.banner.half_horizontal.pink": "بلهن مڠوفوق ميره جمبو",
  "block.minecraft.banner.half_horizontal.purple": "بلهن مڠوفوق اوڠو",
  "block.minecraft.banner.half_horizontal.red": "بلهن مڠوفوق ميره",
  "block.minecraft.banner.half_horizontal.white": "بلهن مڠوفوق ڤوتيه",
  "block.minecraft.banner.half_horizontal.yellow": "بلهن مڠوفوق کونيڠ",
  "block.minecraft.banner.half_horizontal_bottom.black": "بلهن مڠوفوق سوڠسڠ هيتم",
  "block.minecraft.banner.half_horizontal_bottom.blue": "بلهن مڠوفوق سوڠسڠ بيرو",
  "block.minecraft.banner.half_horizontal_bottom.brown": "بلهن مڠوفوق سوڠسڠ ڤيرڠ",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "بلهن مڠوفوق سوڠسڠ سيان",
  "block.minecraft.banner.half_horizontal_bottom.gray": "بلهن مڠوفوق سوڠسڠ کلابو",
  "block.minecraft.banner.half_horizontal_bottom.green": "بلهن مڠوفوق سوڠسڠ هيجاو",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "بلهن مڠوفوق سوڠسڠ بيرو مودا",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "بلهن مڠوفوق سوڠسڠ کلابو مودا",
  "block.minecraft.banner.half_horizontal_bottom.lime": "بلهن مڠوفوق سوڠسڠ ميره جمبو",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "بلهن مڠوفوق سوڠسڠ ماݢينتا",
  "block.minecraft.banner.half_horizontal_bottom.orange": "بلهن مڠوفوق سوڠسڠ جيڠݢ",
  "block.minecraft.banner.half_horizontal_bottom.pink": "بلهن مڠوفوق سوڠسڠ ميره جمبو",
  "block.minecraft.banner.half_horizontal_bottom.purple": "بلهن مڠوفوق سوڠسڠ اوڠو",
  "block.minecraft.banner.half_horizontal_bottom.red": "بلهن مڠوفوق سوڠسڠ ميره",
  "block.minecraft.banner.half_horizontal_bottom.white": "بلهن مڠوفوق سوڠسڠ ڤوتيه",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "بلهن مڠوفوق سوڠسڠ کونيڠ",
  "block.minecraft.banner.half_vertical.black": "بلهن منچانچڠ هيتم",
  "block.minecraft.banner.half_vertical.blue": "بلهن منچانچڠ بيرو",
  "block.minecraft.banner.half_vertical.brown": "بلهن منچانچڠ ڤيرڠ",
  "block.minecraft.banner.half_vertical.cyan": "بلهن منچانچڠ سيان",
  "block.minecraft.banner.half_vertical.gray": "بلهن منچانچڠ کلابو",
  "block.minecraft.banner.half_vertical.green": "بلهن منچانچڠ هيجاو",
  "block.minecraft.banner.half_vertical.light_blue": "بلهن منچانچڠ بيرو مودا",
  "block.minecraft.banner.half_vertical.light_gray": "بلهن منچانچڠ کلابو مودا",
  "block.minecraft.banner.half_vertical.lime": "بلهن منچانچڠ هيجاو مودا",
  "block.minecraft.banner.half_vertical.magenta": "بلهن منچانچڠ ماݢينتا",
  "block.minecraft.banner.half_vertical.orange": "بلهن منچانچڠ جيڠݢ",
  "block.minecraft.banner.half_vertical.pink": "بلهن منچانچڠ ميره جمبو",
  "block.minecraft.banner.half_vertical.purple": "بلهن منچانچڠ اوڠو",
  "block.minecraft.banner.half_vertical.red": "بلهن منچانچڠ ميره",
  "block.minecraft.banner.half_vertical.white": "بلهن منچانچڠ ڤوتيه",
  "block.minecraft.banner.half_vertical.yellow": "بلهن منچانچڠ کونيڠ",
  "block.minecraft.banner.half_vertical_right.black": "بلهن منچانچڠ سوڠسڠ هيتم",
  "block.minecraft.banner.half_vertical_right.blue": "بلهن منچانچڠ سوڠسڠ بيرو",
  "block.minecraft.banner.half_vertical_right.brown": "بلهن منچانچڠ سوڠسڠ ڤيرڠ",
  "block.minecraft.banner.half_vertical_right.cyan": "بلهن منچانچڠ سوڠسڠ سيان",
  "block.minecraft.banner.half_vertical_right.gray": "بلهن منچانچڠ سوڠسڠ کلابو",
  "block.minecraft.banner.half_vertical_right.green": "بلهن منچانچڠ سوڠسڠ هيجاو",
  "block.minecraft.banner.half_vertical_right.light_blue": "بلهن منچانچڠ سوڠسڠ بيرو مودا",
  "block.minecraft.banner.half_vertical_right.light_gray": "بلهن منچانچڠ سوڠسڠ کلابو مودا",
  "block.minecraft.banner.half_vertical_right.lime": "بلهن منچانچڠ سوڠسڠ هيجاو مودا",
  "block.minecraft.banner.half_vertical_right.magenta": "بلهن منچانچڠ سوڠسڠ ماݢينتا",
  "block.minecraft.banner.half_vertical_right.orange": "بلهن منچانچڠ سوڠسڠ جيڠݢ",
  "block.minecraft.banner.half_vertical_right.pink": "بلهن منچانچڠ سوڠسڠ ميره جمبو",
  "block.minecraft.banner.half_vertical_right.purple": "بلهن منچانچڠ سوڠسڠ اوڠو",
  "block.minecraft.banner.half_vertical_right.red": "بلهن منچانچڠ سوڠسڠ ميره",
  "block.minecraft.banner.half_vertical_right.white": "بلهن منچانچڠ سوڠسڠ ڤوتيه",
  "block.minecraft.banner.half_vertical_right.yellow": "بلهن منچانچڠ سوڠسڠ کونيڠ",
  "block.minecraft.banner.mojang.black": "بندا هيتم",
  "block.minecraft.banner.mojang.blue": "بندا بيرو",
  "block.minecraft.banner.mojang.brown": "بندا ڤيرڠ",
  "block.minecraft.banner.mojang.cyan": "بندا سيان",
  "block.minecraft.banner.mojang.gray": "بندا کلابو",
  "block.minecraft.banner.mojang.green": "بندا هيجاو",
  "block.minecraft.banner.mojang.light_blue": "بندا بيرو مودا",
  "block.minecraft.banner.mojang.light_gray": "بندا کلابو مودا",
  "block.minecraft.banner.mojang.lime": "بندا هيجاو مودا",
  "block.minecraft.banner.mojang.magenta": "بندا ماݢينتا",
  "block.minecraft.banner.mojang.orange": "بندا جيڠݢ",
  "block.minecraft.banner.mojang.pink": "بندا ميره جمبو",
  "block.minecraft.banner.mojang.purple": "بندا اوڠو",
  "block.minecraft.banner.mojang.red": "بندا ميره",
  "block.minecraft.banner.mojang.white": "بندا ڤوتيه",
  "block.minecraft.banner.mojang.yellow": "بندا کونيڠ",
  "block.minecraft.banner.piglin.black": "مونچوڠ هيتم",
  "block.minecraft.banner.piglin.blue": "مونچوڠ بيرو",
  "block.minecraft.banner.piglin.brown": "مونچوڠ ڤيرڠ",
  "block.minecraft.banner.piglin.cyan": "مونچوڠ سيان",
  "block.minecraft.banner.piglin.gray": "مونچوڠ کلابو",
  "block.minecraft.banner.piglin.green": "مونچوڠ هيجاو",
  "block.minecraft.banner.piglin.light_blue": "مونچوڠ بيرو مودا",
  "block.minecraft.banner.piglin.light_gray": "مونچوڠ کلابو مودا",
  "block.minecraft.banner.piglin.lime": "مونچوڠ هيجاو مودا",
  "block.minecraft.banner.piglin.magenta": "مونچوڠ ماݢينتا",
  "block.minecraft.banner.piglin.orange": "مونچوڠ جيڠݢ",
  "block.minecraft.banner.piglin.pink": "مونچوڠ ميره جمبو",
  "block.minecraft.banner.piglin.purple": "مونچوڠ اوڠو",
  "block.minecraft.banner.piglin.red": "مونچوڠ ميره",
  "block.minecraft.banner.piglin.white": "مونچوڠ ڤوتيه",
  "block.minecraft.banner.piglin.yellow": "مونچوڠ کونيڠ",
  "block.minecraft.banner.rhombus.black": "رومبوس هيتم",
  "block.minecraft.banner.rhombus.blue": "رومبوس بيرو",
  "block.minecraft.banner.rhombus.brown": "رومبوس ڤيرڠ",
  "block.minecraft.banner.rhombus.cyan": "رومبوس سيان",
  "block.minecraft.banner.rhombus.gray": "رومبوس کلابو",
  "block.minecraft.banner.rhombus.green": "رومبوس هيجاو",
  "block.minecraft.banner.rhombus.light_blue": "رومبوس بيرو مودا",
  "block.minecraft.banner.rhombus.light_gray": "رومبوس کلابو مودا",
  "block.minecraft.banner.rhombus.lime": "رومبوس هيجاو مودا",
  "block.minecraft.banner.rhombus.magenta": "رومبوس ماݢينتا",
  "block.minecraft.banner.rhombus.orange": "رومبوس جيڠݢ",
  "block.minecraft.banner.rhombus.pink": "رومبوس ميره جمبو",
  "block.minecraft.banner.rhombus.purple": "رومبوس اوڠو",
  "block.minecraft.banner.rhombus.red": "رومبوس ميره",
  "block.minecraft.banner.rhombus.white": "رومبوس ڤوتيه",
  "block.minecraft.banner.rhombus.yellow": "رومبوس کونيڠ",
  "block.minecraft.banner.skull.black": "لامبڠ تڠکورق هيتم",
  "block.minecraft.banner.skull.blue": "لامبڠ تڠکورق بيرو",
  "block.minecraft.banner.skull.brown": "لامبڠ تڠکورق ڤيرڠ",
  "block.minecraft.banner.skull.cyan": "لامبڠ تڠکورق سيان",
  "block.minecraft.banner.skull.gray": "لامبڠ تڠکورق کلابو",
  "block.minecraft.banner.skull.green": "لامبڠ تڠکورق هيجاو",
  "block.minecraft.banner.skull.light_blue": "لامبڠ تڠکورق بيرو مودا",
  "block.minecraft.banner.skull.light_gray": "لامبڠ تڠکورق کلابو مودا",
  "block.minecraft.banner.skull.lime": "لامبڠ تڠکورق هيجاو مودا",
  "block.minecraft.banner.skull.magenta": "لامبڠ تڠکورق ماݢينتا",
  "block.minecraft.banner.skull.orange": "لامبڠ تڠکورق جيڠݢ",
  "block.minecraft.banner.skull.pink": "لامبڠ تڠکورق ميره جمبو",
  "block.minecraft.banner.skull.purple": "لامبڠ تڠکورق اوڠو",
  "block.minecraft.banner.skull.red": "لامبڠ تڠکورق ميره",
  "block.minecraft.banner.skull.white": "لامبڠ تڠکورق ڤوتيه",
  "block.minecraft.banner.skull.yellow": "لامبڠ تڠکورق کونيڠ",
  "block.minecraft.banner.small_stripes.black": "ججلور هيتم",
  "block.minecraft.banner.small_stripes.blue": "ججلور بيرو",
  "block.minecraft.banner.small_stripes.brown": "ججلور ڤيرڠ",
  "block.minecraft.banner.small_stripes.cyan": "ججلور سيان",
  "block.minecraft.banner.small_stripes.gray": "ججلور کلابو",
  "block.minecraft.banner.small_stripes.green": "ججلور هيجاو",
  "block.minecraft.banner.small_stripes.light_blue": "ججلور بيرو مودا",
  "block.minecraft.banner.small_stripes.light_gray": "ججلور کلابو مودا",
  "block.minecraft.banner.small_stripes.lime": "ججلور هيجاو مودا",
  "block.minecraft.banner.small_stripes.magenta": "ججلور ماݢينتا",
  "block.minecraft.banner.small_stripes.orange": "ججلور جيڠݢ",
  "block.minecraft.banner.small_stripes.pink": "ججلور ميره جمبو",
  "block.minecraft.banner.small_stripes.purple": "ججلور اوڠو",
  "block.minecraft.banner.small_stripes.red": "ججلور ميره",
  "block.minecraft.banner.small_stripes.white": "ججلور ڤوتيه",
  "block.minecraft.banner.small_stripes.yellow": "ججلور کونيڠ",
  "block.minecraft.banner.square_bottom_left.black": "کنتون کيري باوه هيتم",
  "block.minecraft.banner.square_bottom_left.blue": "کنتون کيري باوه بيرو",
  "block.minecraft.banner.square_bottom_left.brown": "کنتون کيري باوه ڤيرڠ",
  "block.minecraft.banner.square_bottom_left.cyan": "کنتون کيري باوه سيان",
  "block.minecraft.banner.square_bottom_left.gray": "کنتون کيري باوه کلابو",
  "block.minecraft.banner.square_bottom_left.green": "کنتون کيري باوه هيجاو",
  "block.minecraft.banner.square_bottom_left.light_blue": "کنتون کيري باوه بيرو مودا",
  "block.minecraft.banner.square_bottom_left.light_gray": "کنتون کيري باوه کلابو مودا",
  "block.minecraft.banner.square_bottom_left.lime": "کنتون کيري باوه هيجاو مودا",
  "block.minecraft.banner.square_bottom_left.magenta": "کنتون کيري باوه ماݢينتا",
  "block.minecraft.banner.square_bottom_left.orange": "کنتون کيري باوه جيڠݢ",
  "block.minecraft.banner.square_bottom_left.pink": "کنتون کيري باوه ميره جمبو",
  "block.minecraft.banner.square_bottom_left.purple": "کنتون کيري باوه اوڠو",
  "block.minecraft.banner.square_bottom_left.red": "کنتون کيري باوه ميره",
  "block.minecraft.banner.square_bottom_left.white": "کنتون کيري باوه ڤوتيه",
  "block.minecraft.banner.square_bottom_left.yellow": "کنتون کيري باوه کونيڠ",
  "block.minecraft.banner.square_bottom_right.black": "کنتون کانن باوه هيتم",
  "block.minecraft.banner.square_bottom_right.blue": "کنتون کانن باوه بيرو",
  "block.minecraft.banner.square_bottom_right.brown": "کنتون کانن باوه ڤيرڠ",
  "block.minecraft.banner.square_bottom_right.cyan": "کنتون کانن باوه سيان",
  "block.minecraft.banner.square_bottom_right.gray": "کنتون کانن باوه کلابو",
  "block.minecraft.banner.square_bottom_right.green": "کنتون کانن باوه هيجاو",
  "block.minecraft.banner.square_bottom_right.light_blue": "کنتون کانن باوه بيرو مودا",
  "block.minecraft.banner.square_bottom_right.light_gray": "کنتون کانن باوه کلابو مودا",
  "block.minecraft.banner.square_bottom_right.lime": "کنتون کانن باوه هيجاو مودا",
  "block.minecraft.banner.square_bottom_right.magenta": "کنتون کانن باوه ماݢينتا",
  "block.minecraft.banner.square_bottom_right.orange": "کنتون کانن باوه جيڠݢ",
  "block.minecraft.banner.square_bottom_right.pink": "کنتون کانن باوه ميره جمبو",
  "block.minecraft.banner.square_bottom_right.purple": "کنتون کانن باوه اوڠو",
  "block.minecraft.banner.square_bottom_right.red": "کنتون کانن باوه ميره",
  "block.minecraft.banner.square_bottom_right.white": "کنتون کانن باوه ڤوتيه",
  "block.minecraft.banner.square_bottom_right.yellow": "کنتون کانن باوه کونيڠ",
  "block.minecraft.banner.square_top_left.black": "کنتون کيري اتس هيتم",
  "block.minecraft.banner.square_top_left.blue": "کنتون کيري اتس بيرو",
  "block.minecraft.banner.square_top_left.brown": "کنتون کيري اتس ڤيرڠ",
  "block.minecraft.banner.square_top_left.cyan": "کنتون کيري اتس سيان",
  "block.minecraft.banner.square_top_left.gray": "کنتون کيري اتس کلابو",
  "block.minecraft.banner.square_top_left.green": "کنتون کيري اتس هيجاو",
  "block.minecraft.banner.square_top_left.light_blue": "کنتون کيري اتس بيرو مودا",
  "block.minecraft.banner.square_top_left.light_gray": "کنتون کيري اتس کلابو مودا",
  "block.minecraft.banner.square_top_left.lime": "کنتون کيري اتس هيجاو مودا",
  "block.minecraft.banner.square_top_left.magenta": "کنتون کيري اتس ماݢينتا",
  "block.minecraft.banner.square_top_left.orange": "کنتون کيري اتس جيڠݢ",
  "block.minecraft.banner.square_top_left.pink": "کنتون کيري اتس ميره جمبو",
  "block.minecraft.banner.square_top_left.purple": "کنتون کيري اتس اوڠو",
  "block.minecraft.banner.square_top_left.red": "کنتون کيري اتس ميره",
  "block.minecraft.banner.square_top_left.white": "کنتون کيري اتس ڤوتيه",
  "block.minecraft.banner.square_top_left.yellow": "کنتون کيري اتس کونيڠ",
  "block.minecraft.banner.square_top_right.black": "کنتون کانن اتس هيتم",
  "block.minecraft.banner.square_top_right.blue": "کنتون کانن اتس بيرو",
  "block.minecraft.banner.square_top_right.brown": "کنتون کانن اتس ڤيرڠ",
  "block.minecraft.banner.square_top_right.cyan": "کنتون کانن اتس سيان",
  "block.minecraft.banner.square_top_right.gray": "کنتون کانن اتس کلابو",
  "block.minecraft.banner.square_top_right.green": "کنتون کانن اتس هيجاو",
  "block.minecraft.banner.square_top_right.light_blue": "کنتون کانن اتس بيرو مودا",
  "block.minecraft.banner.square_top_right.light_gray": "کنتون کانن اتس کلابو مودا",
  "block.minecraft.banner.square_top_right.lime": "کنتون کانن اتس هيجاو مودا",
  "block.minecraft.banner.square_top_right.magenta": "کنتون کانن اتس ماݢينتا",
  "block.minecraft.banner.square_top_right.orange": "کنتون کانن اتس جيڠݢ",
  "block.minecraft.banner.square_top_right.pink": "کنتون کانن اتس ميره جمبو",
  "block.minecraft.banner.square_top_right.purple": "کنتون کانن اتس اوڠو",
  "block.minecraft.banner.square_top_right.red": "کنتون کانن اتس ميره",
  "block.minecraft.banner.square_top_right.white": "کنتون کانن اتس ڤوتيه",
  "block.minecraft.banner.square_top_right.yellow": "کنتون کانن اتس کونيڠ",
  "block.minecraft.banner.straight_cross.black": "ڤالڠ هيتم",
  "block.minecraft.banner.straight_cross.blue": "ڤالڠ بيرو",
  "block.minecraft.banner.straight_cross.brown": "ڤالڠ ڤيرڠ",
  "block.minecraft.banner.straight_cross.cyan": "ڤالڠ سيان",
  "block.minecraft.banner.straight_cross.gray": "ڤالڠ کلابو",
  "block.minecraft.banner.straight_cross.green": "ڤالڠ هيجاو",
  "block.minecraft.banner.straight_cross.light_blue": "ڤالڠ بيرو مودا",
  "block.minecraft.banner.straight_cross.light_gray": "ڤالڠ کلابو مودا",
  "block.minecraft.banner.straight_cross.lime": "ڤالڠ هيجاو مودا",
  "block.minecraft.banner.straight_cross.magenta": "ڤالڠ ماݢينتا",
  "block.minecraft.banner.straight_cross.orange": "ڤالڠ جيڠݢ",
  "block.minecraft.banner.straight_cross.pink": "ڤالڠ ميره جمبو",
  "block.minecraft.banner.straight_cross.purple": "ڤالڠ اوڠو",
  "block.minecraft.banner.straight_cross.red": "ڤالڠ ميره",
  "block.minecraft.banner.straight_cross.white": "ڤالڠ ڤوتيه",
  "block.minecraft.banner.straight_cross.yellow": "ڤالڠ کونيڠ",
  "block.minecraft.banner.stripe_bottom.black": "ڤڠاکي هيتم",
  "block.minecraft.banner.stripe_bottom.blue": "ڤڠاکي بيرو",
  "block.minecraft.banner.stripe_bottom.brown": "ڤڠاکي ڤيرڠ",
  "block.minecraft.banner.stripe_bottom.cyan": "ڤڠاکي سيان",
  "block.minecraft.banner.stripe_bottom.gray": "ڤڠاکي کلابو",
  "block.minecraft.banner.stripe_bottom.green": "ڤڠاکي هيجاو",
  "block.minecraft.banner.stripe_bottom.light_blue": "ڤڠاکي بيرو مودا",
  "block.minecraft.banner.stripe_bottom.light_gray": "ڤڠاکي کلابو مودا",
  "block.minecraft.banner.stripe_bottom.lime": "ڤڠاکي هيجاو مودا",
  "block.minecraft.banner.stripe_bottom.magenta": "ڤڠاکي ماݢينتا",
  "block.minecraft.banner.stripe_bottom.orange": "ڤڠاکي جيڠݢ",
  "block.minecraft.banner.stripe_bottom.pink": "ڤڠاکي ميره جمبو",
  "block.minecraft.banner.stripe_bottom.purple": "ڤڠاکي اوڠو",
  "block.minecraft.banner.stripe_bottom.red": "ڤڠاکي ميره",
  "block.minecraft.banner.stripe_bottom.white": "ڤڠاکي ڤوتيه",
  "block.minecraft.banner.stripe_bottom.yellow": "ڤڠاکي کونيڠ",
  "block.minecraft.banner.stripe_center.black": "جلور منچانچڠ هيتم",
  "block.minecraft.banner.stripe_center.blue": "جلور منچانچڠ بيرو",
  "block.minecraft.banner.stripe_center.brown": "جلور منچانچڠ ڤيرڠ",
  "block.minecraft.banner.stripe_center.cyan": "جلور منچانچڠ سيان",
  "block.minecraft.banner.stripe_center.gray": "جلور منچانچڠ کلابو",
  "block.minecraft.banner.stripe_center.green": "جلور منچانچڠ هيجاو",
  "block.minecraft.banner.stripe_center.light_blue": "جلور منچانچڠ بيرو مودا",
  "block.minecraft.banner.stripe_center.light_gray": "جلور منچانچڠ کلابو مودا",
  "block.minecraft.banner.stripe_center.lime": "جلور منچانچڠ هيجاو مودا",
  "block.minecraft.banner.stripe_center.magenta": "جلور منچانچڠ ماݢينتا",
  "block.minecraft.banner.stripe_center.orange": "جلور منچانچڠ جيڠݢ",
  "block.minecraft.banner.stripe_center.pink": "جلور منچانچڠ ميره جمبو",
  "block.minecraft.banner.stripe_center.purple": "جلور منچانچڠ اوڠو",
  "block.minecraft.banner.stripe_center.red": "جلور منچانچڠ ميره",
  "block.minecraft.banner.stripe_center.white": "جلور منچانچڠ ڤوتيه",
  "block.minecraft.banner.stripe_center.yellow": "جلور منچانچڠ کونيڠ",
  "block.minecraft.banner.stripe_downleft.black": "جلور سيروڠ کيري هيتم",
  "block.minecraft.banner.stripe_downleft.blue": "جلور سيروڠ کيري بيرو",
  "block.minecraft.banner.stripe_downleft.brown": "جلور سيروڠ کيري ڤيرڠ",
  "block.minecraft.banner.stripe_downleft.cyan": "جلور سيروڠ کيري سيان",
  "block.minecraft.banner.stripe_downleft.gray": "جلور سيروڠ کيري کلابو",
  "block.minecraft.banner.stripe_downleft.green": "جلور سيروڠ کيري هيجاو",
  "block.minecraft.banner.stripe_downleft.light_blue": "جلور سيروڠ کيري بيرو مودا",
  "block.minecraft.banner.stripe_downleft.light_gray": "جلور سيروڠ کيري کلابو مودا",
  "block.minecraft.banner.stripe_downleft.lime": "جلور سيروڠ کيري هيجاو مودا",
  "block.minecraft.banner.stripe_downleft.magenta": "جلور سيروڠ کيري ماݢينتا",
  "block.minecraft.banner.stripe_downleft.orange": "جلور سيروڠ کيري جيڠݢ",
  "block.minecraft.banner.stripe_downleft.pink": "جلور سيروڠ کيري ميره جمبو",
  "block.minecraft.banner.stripe_downleft.purple": "جلور سيروڠ کيري اوڠو",
  "block.minecraft.banner.stripe_downleft.red": "جلور سيروڠ کيري ميره",
  "block.minecraft.banner.stripe_downleft.white": "جلور سيروڠ کيري ڤوتيه",
  "block.minecraft.banner.stripe_downleft.yellow": "جلور سيروڠ کيري کونيڠ",
  "block.minecraft.banner.stripe_downright.black": "جلور سيروڠ هيتم",
  "block.minecraft.banner.stripe_downright.blue": "جلور سيروڠ بيرو",
  "block.minecraft.banner.stripe_downright.brown": "جلور سيروڠ ڤيرڠ",
  "block.minecraft.banner.stripe_downright.cyan": "جلور سيروڠ سيان",
  "block.minecraft.banner.stripe_downright.gray": "جلور سيروڠ کلابو",
  "block.minecraft.banner.stripe_downright.green": "جلور سيروڠ هيجاو",
  "block.minecraft.banner.stripe_downright.light_blue": "جلور سيروڠ بيرو مودا",
  "block.minecraft.banner.stripe_downright.light_gray": "جلور سيروڠ کلابو مودا",
  "block.minecraft.banner.stripe_downright.lime": "جلور سيروڠ هيجاو مودا",
  "block.minecraft.banner.stripe_downright.magenta": "جلور سيروڠ ماݢينتا",
  "block.minecraft.banner.stripe_downright.orange": "جلور سيروڠ جيڠݢ",
  "block.minecraft.banner.stripe_downright.pink": "جلور سيروڠ ميره جمبو",
  "block.minecraft.banner.stripe_downright.purple": "جلور سيروڠ اوڠو",
  "block.minecraft.banner.stripe_downright.red": "جلور سيروڠ ميره",
  "block.minecraft.banner.stripe_downright.white": "جلور سيروڠ ڤوتيه",
  "block.minecraft.banner.stripe_downright.yellow": "جلور سيروڠ کونيڠ",
  "block.minecraft.banner.stripe_left.black": "جلور منچانچڠ کيري هيتم",
  "block.minecraft.banner.stripe_left.blue": "جلور منچانچڠ کيري بيرو",
  "block.minecraft.banner.stripe_left.brown": "جلور منچانچڠ کيري ڤيرڠ",
  "block.minecraft.banner.stripe_left.cyan": "جلور منچانچڠ کيري سيان",
  "block.minecraft.banner.stripe_left.gray": "جلور منچانچڠ کيري کلابو",
  "block.minecraft.banner.stripe_left.green": "جلور منچانچڠ کيري هيجاو",
  "block.minecraft.banner.stripe_left.light_blue": "جلور منچانچڠ کيري بيرو مودا",
  "block.minecraft.banner.stripe_left.light_gray": "جلور منچانچڠ کيري کلابو مودا",
  "block.minecraft.banner.stripe_left.lime": "جلور منچانچڠ کيري هيجاو مودا",
  "block.minecraft.banner.stripe_left.magenta": "جلور منچانچڠ کيري ماݢينتا",
  "block.minecraft.banner.stripe_left.orange": "جلور منچانچڠ کيري جيڠݢ",
  "block.minecraft.banner.stripe_left.pink": "جلور منچانچڠ کيري ميره جمبو",
  "block.minecraft.banner.stripe_left.purple": "جلور منچانچڠ کيري اوڠو",
  "block.minecraft.banner.stripe_left.red": "جلور منچانچڠ کيري ميره",
  "block.minecraft.banner.stripe_left.white": "جلور منچانچڠ کيري ڤوتيه",
  "block.minecraft.banner.stripe_left.yellow": "جلور منچانچڠ کيري کونيڠ",
  "block.minecraft.banner.stripe_middle.black": "جلور مڠوفوق هيتم",
  "block.minecraft.banner.stripe_middle.blue": "جلور مڠوفوق بيرو",
  "block.minecraft.banner.stripe_middle.brown": "جلور مڠوفوق ڤيرڠ",
  "block.minecraft.banner.stripe_middle.cyan": "جلور مڠوفوق سيان",
  "block.minecraft.banner.stripe_middle.gray": "جلور مڠوفوق کلابو",
  "block.minecraft.banner.stripe_middle.green": "جلور مڠوفوق هيجاو",
  "block.minecraft.banner.stripe_middle.light_blue": "جلور مڠوفوق بيرو مودا",
  "block.minecraft.banner.stripe_middle.light_gray": "جلور مڠوفوق کلابو مودا",
  "block.minecraft.banner.stripe_middle.lime": "جلور مڠوفوق هيجاو مودا",
  "block.minecraft.banner.stripe_middle.magenta": "جلور مڠوفوق ماݢينتا",
  "block.minecraft.banner.stripe_middle.orange": "جلور مڠوفوق جيڠݢ",
  "block.minecraft.banner.stripe_middle.pink": "جلور مڠوفوق ميره جمبو",
  "block.minecraft.banner.stripe_middle.purple": "جلور مڠوفوق اوڠو",
  "block.minecraft.banner.stripe_middle.red": "جلور مڠوفوق ميره",
  "block.minecraft.banner.stripe_middle.white": "جلور مڠوفوق ڤوتيه",
  "block.minecraft.banner.stripe_middle.yellow": "جلور مڠوفوق کونيڠ",
  "block.minecraft.banner.stripe_right.black": "جلور منچانچڠ کانن هيتم",
  "block.minecraft.banner.stripe_right.blue": "جلور منچانچڠ کانن بيرو",
  "block.minecraft.banner.stripe_right.brown": "جلور منچانچڠ کانن ڤيرڠ",
  "block.minecraft.banner.stripe_right.cyan": "جلور منچانچڠ کانن سيان",
  "block.minecraft.banner.stripe_right.gray": "جلور منچانچڠ کانن کلابو",
  "block.minecraft.banner.stripe_right.green": "جلور منچانچڠ کانن هيجاو",
  "block.minecraft.banner.stripe_right.light_blue": "جلور منچانچڠ کانن بيرو مودا",
  "block.minecraft.banner.stripe_right.light_gray": "جلور منچانچڠ کانن کلابو مودا",
  "block.minecraft.banner.stripe_right.lime": "جلور منچانچڠ کانن ميره جمبو",
  "block.minecraft.banner.stripe_right.magenta": "جلور منچانچڠ کانن ماݢينتا",
  "block.minecraft.banner.stripe_right.orange": "جلور منچانچڠ کانن جيڠݢ",
  "block.minecraft.banner.stripe_right.pink": "جلور منچانچڠ کانن ميره جمبو",
  "block.minecraft.banner.stripe_right.purple": "جلور منچانچڠ کانن اوڠو",
  "block.minecraft.banner.stripe_right.red": "جلور منچانچڠ کانن ميره",
  "block.minecraft.banner.stripe_right.white": "جلور منچانچڠ کانن ڤوتيه",
  "block.minecraft.banner.stripe_right.yellow": "جلور منچانچڠ کانن کونيڠ",
  "block.minecraft.banner.stripe_top.black": "ڤڠڤالا هيتم",
  "block.minecraft.banner.stripe_top.blue": "ڤڠڤالا بيرو",
  "block.minecraft.banner.stripe_top.brown": "ڤڠڤالا ڤيرڠ",
  "block.minecraft.banner.stripe_top.cyan": "ڤڠڤالا سيان",
  "block.minecraft.banner.stripe_top.gray": "ڤڠڤالا کلابو",
  "block.minecraft.banner.stripe_top.green": "ڤڠڤالا هيجاو",
  "block.minecraft.banner.stripe_top.light_blue": "ڤڠڤالا بيرو مودا",
  "block.minecraft.banner.stripe_top.light_gray": "ڤڠڤالا کلابو مودا",
  "block.minecraft.banner.stripe_top.lime": "ڤڠڤالا هيجاو مودا",
  "block.minecraft.banner.stripe_top.magenta": "ڤڠڤالا ماݢينتا",
  "block.minecraft.banner.stripe_top.orange": "ڤڠڤالا جيڠݢ",
  "block.minecraft.banner.stripe_top.pink": "ڤڠڤالا ميره جمبو",
  "block.minecraft.banner.stripe_top.purple": "ڤڠڤالا اوڠو",
  "block.minecraft.banner.stripe_top.red": "ڤڠڤالا ميره",
  "block.minecraft.banner.stripe_top.white": "ڤڠڤالا ڤوتيه",
  "block.minecraft.banner.stripe_top.yellow": "ڤڠڤالا کونيڠ",
  "block.minecraft.banner.triangle_bottom.black": "سيۏرون هيتم",
  "block.minecraft.banner.triangle_bottom.blue": "سيۏرون بيرو",
  "block.minecraft.banner.triangle_bottom.brown": "سيۏرون ڤيرڠ",
  "block.minecraft.banner.triangle_bottom.cyan": "سيۏرون سيان",
  "block.minecraft.banner.triangle_bottom.gray": "سيۏرون کلابو",
  "block.minecraft.banner.triangle_bottom.green": "سيۏرون هيجاو",
  "block.minecraft.banner.triangle_bottom.light_blue": "سيۏرون بيرو مودا",
  "block.minecraft.banner.triangle_bottom.light_gray": "سيۏرون کلابو مودا",
  "block.minecraft.banner.triangle_bottom.lime": "سيۏرون هيجاو مودا",
  "block.minecraft.banner.triangle_bottom.magenta": "سيۏرون ماݢينتا",
  "block.minecraft.banner.triangle_bottom.orange": "سيۏرون جيڠݢ",
  "block.minecraft.banner.triangle_bottom.pink": "سيۏرون ميره جمبو",
  "block.minecraft.banner.triangle_bottom.purple": "سيۏرون اوڠو",
  "block.minecraft.banner.triangle_bottom.red": "سيۏرون ميره",
  "block.minecraft.banner.triangle_bottom.white": "سيۏرون ڤوتيه",
  "block.minecraft.banner.triangle_bottom.yellow": "سيۏرون کونيڠ",
  "block.minecraft.banner.triangle_top.black": "سيۏرون سوڠسڠ هيتم",
  "block.minecraft.banner.triangle_top.blue": "سيۏرون سوڠسڠ بيرو",
  "block.minecraft.banner.triangle_top.brown": "سيۏرون سوڠسڠ ڤيرڠ",
  "block.minecraft.banner.triangle_top.cyan": "سيۏرون سوڠسڠ سيان",
  "block.minecraft.banner.triangle_top.gray": "سيۏرون سوڠسڠ کلابو",
  "block.minecraft.banner.triangle_top.green": "سيۏرون سوڠسڠ هيجاو",
  "block.minecraft.banner.triangle_top.light_blue": "سيۏرون سوڠسڠ هيجاو مودا",
  "block.minecraft.banner.triangle_top.light_gray": "سيۏرون سوڠسڠ کلابو مودا",
  "block.minecraft.banner.triangle_top.lime": "سيۏرون سوڠسڠ هيجاو مودا",
  "block.minecraft.banner.triangle_top.magenta": "سيۏرون سوڠسڠ ماݢينتا",
  "block.minecraft.banner.triangle_top.orange": "سيۏرون سوڠسڠ جيڠݢ",
  "block.minecraft.banner.triangle_top.pink": "سيۏرون سوڠسڠ ميره جمبو",
  "block.minecraft.banner.triangle_top.purple": "سيۏرون سوڠسڠ اوڠو",
  "block.minecraft.banner.triangle_top.red": "سيۏرون سوڠسڠ ميره",
  "block.minecraft.banner.triangle_top.white": "سيۏرون سوڠسڠ ڤوتيه",
  "block.minecraft.banner.triangle_top.yellow": "سيۏرون سوڠسڠ کونيڠ",
  "block.minecraft.banner.triangles_bottom.black": "ڤڠاکي برݢريݢي هيتم",
  "block.minecraft.banner.triangles_bottom.blue": "ڤڠاکي برݢريݢي بيرو",
  "block.minecraft.banner.triangles_bottom.brown": "ڤڠاکي برݢريݢي ڤيرڠ",
  "block.minecraft.banner.triangles_bottom.cyan": "ڤڠاکي برݢريݢي سيان",
  "block.minecraft.banner.triangles_bottom.gray": "ڤڠاکي برݢريݢي کلابو",
  "block.minecraft.banner.triangles_bottom.green": "ڤڠاکي برݢريݢي هيجاو",
  "block.minecraft.banner.triangles_bottom.light_blue": "ڤڠاکي برݢريݢي بيرو مودا",
  "block.minecraft.banner.triangles_bottom.light_gray": "ڤڠاکي برݢريݢي کلابو مودا",
  "block.minecraft.banner.triangles_bottom.lime": "ڤڠاکي برݢريݢي هيجاو مودا",
  "block.minecraft.banner.triangles_bottom.magenta": "ڤڠاکي برݢريݢي ماݢينتا",
  "block.minecraft.banner.triangles_bottom.orange": "ڤڠاکي برݢريݢي جيڠݢ",
  "block.minecraft.banner.triangles_bottom.pink": "ڤڠاکي برݢريݢي ميره جمبو",
  "block.minecraft.banner.triangles_bottom.purple": "ڤڠاکي برݢريݢي اوڠو",
  "block.minecraft.banner.triangles_bottom.red": "ڤڠاکي برݢريݢي ميره",
  "block.minecraft.banner.triangles_bottom.white": "ڤڠاکي برݢريݢي ڤوتيه",
  "block.minecraft.banner.triangles_bottom.yellow": "ڤڠاکي برݢريݢي کونيڠ",
  "block.minecraft.banner.triangles_top.black": "ڤڠڤالا برݢريݢي هيتم",
  "block.minecraft.banner.triangles_top.blue": "ڤڠڤالا برݢريݢي بيرو",
  "block.minecraft.banner.triangles_top.brown": "ڤڠڤالا برݢريݢي ڤيرڠ",
  "block.minecraft.banner.triangles_top.cyan": "ڤڠڤالا برݢريݢي سيان",
  "block.minecraft.banner.triangles_top.gray": "ڤڠڤالا برݢريݢي کلابو",
  "block.minecraft.banner.triangles_top.green": "ڤڠڤالا برݢريݢي هيجاو",
  "block.minecraft.banner.triangles_top.light_blue": "ڤڠڤالا برݢريݢي بيرو مودا",
  "block.minecraft.banner.triangles_top.light_gray": "ڤڠڤالا برݢريݢي کلابو مودا",
  "block.minecraft.banner.triangles_top.lime": "ڤڠڤالا برݢريݢي هيجاو مودا",
  "block.minecraft.banner.triangles_top.magenta": "ڤڠڤالا برݢريݢي ماݢينتا",
  "block.minecraft.banner.triangles_top.orange": "ڤڠڤالا برݢريݢي جيڠݢ",
  "block.minecraft.banner.triangles_top.pink": "ڤڠڤالا برݢريݢي ميره جمبو",
  "block.minecraft.banner.triangles_top.purple": "ڤڠڤالا برݢريݢي اوڠو",
  "block.minecraft.banner.triangles_top.red": "ڤڠڤالا برݢريݢي ميره",
  "block.minecraft.banner.triangles_top.white": "ڤڠڤالا برݢريݢي ڤوتيه",
  "block.minecraft.banner.triangles_top.yellow": "ڤڠڤالا برݢريݢي کونيڠ",
  "block.minecraft.barrel": "تاهڠ",
  "block.minecraft.barrier": "هالڠن",
  "block.minecraft.basalt": "باسل‌ت",
  "block.minecraft.beacon": "سوار",
  "block.minecraft.beacon.primary": "کواس اوتام",
  "block.minecraft.beacon.secondary": "کواس منڠه",
  "block.minecraft.bed.no_sleep": "اندا هاڽ بوليه تيدور ڤد وقتو مالم اتاو سماس ريبوت ڤتير",
  "block.minecraft.bed.not_safe": "اندا تيدق بوليه بريحت سکارڠ⁏ ترداڤت رقساس برهمڤيرن",
  "block.minecraft.bed.obstructed": "کاتيل اين ترسکت",
  "block.minecraft.bed.occupied": "کاتيل اين تله ددودوقي",
  "block.minecraft.bed.too_far_away": "اندا تيدق بوليه بريحت سکارڠ⁏ کاتيل اندا ترلالو جاٴوه",
  "block.minecraft.bedrock": "باتو داسر",
  "block.minecraft.bee_nest": "سارڠ لبه",
  "block.minecraft.beehive": "سارڠ لبه بواتن",
  "block.minecraft.beetroots": "اوبي بيت",
  "block.minecraft.bell": "ݢنتا",
  "block.minecraft.big_dripleaf": "داٴون تيتيس بسر",
  "block.minecraft.big_dripleaf_stem": "باتڠ داٴون تيتيس بسر",
  "block.minecraft.birch_button": "بوتڠ برچ",
  "block.minecraft.birch_door": "ڤينتو کايو برچ",
  "block.minecraft.birch_fence": "ڤاݢر برچ",
  "block.minecraft.birch_fence_gate": "ڤينتو ڤاݢر برچ",
  "block.minecraft.birch_hanging_sign": "ڤاڤن تندا برݢنتوڠ برچ",
  "block.minecraft.birch_leaves": "داٴون برچ",
  "block.minecraft.birch_log": "کايو بالق برچ",
  "block.minecraft.birch_planks": "ڤاڤن کايو برچ",
  "block.minecraft.birch_pressure_plate": "ڤلت تکنن برچ",
  "block.minecraft.birch_sapling": "انق ڤوکوق برچ",
  "block.minecraft.birch_shelf": "رق برچ",
  "block.minecraft.birch_sign": "ڤاڤن تندا برچ",
  "block.minecraft.birch_slab": "ڤاڤق برچ",
  "block.minecraft.birch_stairs": "تڠݢ برچ",
  "block.minecraft.birch_trapdoor": "ڤينتو کولوڠ برچ",
  "block.minecraft.birch_wall_hanging_sign": "ڤاڤن تندا دينديڠ برݢنتوڠ برچ",
  "block.minecraft.birch_wall_sign": "ڤاڤن تندا دينديڠ برچ",
  "block.minecraft.birch_wood": "کايو برچ",
  "block.minecraft.black_banner": "ڤنجي هيتم",
  "block.minecraft.black_bed": "کاتيل هيتم",
  "block.minecraft.black_candle": "ديان هيتم",
  "block.minecraft.black_candle_cake": "کيک برديان هيتم",
  "block.minecraft.black_carpet": "ڤرماٴيداني هيتم",
  "block.minecraft.black_concrete": "کونکريت هيتم",
  "block.minecraft.black_concrete_powder": "سربوق کونکريت هيتم",
  "block.minecraft.black_glazed_terracotta": "تيراکوتا ليچاو هيتم",
  "block.minecraft.black_shulker_box": "کوتق شلکر هيتم",
  "block.minecraft.black_stained_glass": "کاچ برورنا هيتم",
  "block.minecraft.black_stained_glass_pane": "انق کاچ برورنا هيتم",
  "block.minecraft.black_terracotta": "تيراکوتا هيتم",
  "block.minecraft.black_wool": "بولو هيتم",
  "block.minecraft.blackstone": "باتو هيتم",
  "block.minecraft.blackstone_slab": "ڤاڤق باتو هيتم",
  "block.minecraft.blackstone_stairs": "تڠݢ باتو هيتم",
  "block.minecraft.blackstone_wall": "تيمبوق باتو هيتم",
  "block.minecraft.blast_furnace": "رلاو باݢس",
  "block.minecraft.blue_banner": "ڤنجي بيرو",
  "block.minecraft.blue_bed": "کاتيل بيرو",
  "block.minecraft.blue_candle": "ديان بيرو",
  "block.minecraft.blue_candle_cake": "کيک برديان بيرو",
  "block.minecraft.blue_carpet": "ڤرماٴيداني بيرو",
  "block.minecraft.blue_concrete": "کونکريت بيرو",
  "block.minecraft.blue_concrete_powder": "سربوق کونکريت بيرو",
  "block.minecraft.blue_glazed_terracotta": "تيراکوتا ليچاو بيرو",
  "block.minecraft.blue_ice": "اٴيس بيرو",
  "block.minecraft.blue_orchid": "اورکيد بيرو",
  "block.minecraft.blue_shulker_box": "کوتق شلکر بيرو",
  "block.minecraft.blue_stained_glass": "کاچ برورنا بيرو",
  "block.minecraft.blue_stained_glass_pane": "انق کاچ برورنا بيرو",
  "block.minecraft.blue_terracotta": "تيراکوتا بيرو",
  "block.minecraft.blue_wool": "بولو بيرو",
  "block.minecraft.bone_block": "بلوک تولڠ",
  "block.minecraft.bookshelf": "رق بوکو",
  "block.minecraft.brain_coral": "کارڠ اوتق",
  "block.minecraft.brain_coral_block": "بلوک کارڠ اوتق",
  "block.minecraft.brain_coral_fan": "اکر باهر اوتق",
  "block.minecraft.brain_coral_wall_fan": "اکر باهر دينديڠ اوتق",
  "block.minecraft.brewing_stand": "تاڤق ممبرو",
  "block.minecraft.brick_slab": "ڤاڤق بات",
  "block.minecraft.brick_stairs": "تڠݢ بات",
  "block.minecraft.brick_wall": "تيمبوق بات",
  "block.minecraft.bricks": "بات",
  "block.minecraft.brown_banner": "ڤنجي ڤيرڠ",
  "block.minecraft.brown_bed": "کاتيل ڤيرڠ",
  "block.minecraft.brown_candle": "ديان ڤيرڠ",
  "block.minecraft.brown_candle_cake": "کيک برديان ڤيرڠ",
  "block.minecraft.brown_carpet": "ڤرماٴيداني ڤيرڠ",
  "block.minecraft.brown_concrete": "کونکريت ڤيرڠ",
  "block.minecraft.brown_concrete_powder": "سربوق کونکريت ڤيرڠ",
  "block.minecraft.brown_glazed_terracotta": "تيراکوتا ليچاو ڤيرڠ",
  "block.minecraft.brown_mushroom": "چنداون ڤيرڠ",
  "block.minecraft.brown_mushroom_block": "بلوک چنداون ڤيرڠ",
  "block.minecraft.brown_shulker_box": "کوتق شلکر ڤيرڠ",
  "block.minecraft.brown_stained_glass": "کاچ برورنا ڤيرڠ",
  "block.minecraft.brown_stained_glass_pane": "انق کاچ برورنا ڤيرڠ",
  "block.minecraft.brown_terracotta": "تيراکوتا ڤيرڠ",
  "block.minecraft.brown_wool": "بولو ڤيرڠ",
  "block.minecraft.bubble_column": "کڤولن بوٴيه",
  "block.minecraft.bubble_coral": "کارڠ بوٴيه",
  "block.minecraft.bubble_coral_block": "بلوک کارڠ بوٴيه",
  "block.minecraft.bubble_coral_fan": "اکر باهر بوٴيه",
  "block.minecraft.bubble_coral_wall_fan": "اکر باهر دينديڠ بوٴيه",
  "block.minecraft.budding_amethyst": "باتو کچوبوڠ منوناس",
  "block.minecraft.bush": "سمق",
  "block.minecraft.cactus": "ککتوس",
  "block.minecraft.cactus_flower": "بوڠا ککتوس",
  "block.minecraft.cake": "کيک",
  "block.minecraft.calcite": "کلسيت",
  "block.minecraft.calibrated_sculk_sensor": "ڤندريا سکل‌ک ترتنتوکور",
  "block.minecraft.campfire": "اوڠݢون اڤي",
  "block.minecraft.candle": "ديان",
  "block.minecraft.candle_cake": "کيک برديان",
  "block.minecraft.carrots": "لوبق",
  "block.minecraft.cartography_table": "ڤرتوکڠن ڤتا",
  "block.minecraft.carved_pumpkin": "لابو دأوکير",
  "block.minecraft.cauldron": "کاوه",
  "block.minecraft.cave_air": "اودارا ݢوا",
  "block.minecraft.cave_vines": "ڤنجالر ݢوا",
  "block.minecraft.cave_vines_plant": "ڤوکوق ڤنجالر ݢوا",
  "block.minecraft.chain": "رنتاي",
  "block.minecraft.chain_command_block": "بلوک ڤرينته برنتاي",
  "block.minecraft.cherry_button": "بوتڠ ساکورا",
  "block.minecraft.cherry_door": "ڤينتو ساکورا",
  "block.minecraft.cherry_fence": "ڤاݢر ساکورا",
  "block.minecraft.cherry_fence_gate": "ڤينتو ڤاݢر ساکورا",
  "block.minecraft.cherry_hanging_sign": "ڤاڤن تندا برݢنتوڠ ساکورا",
  "block.minecraft.cherry_leaves": "داٴون ساکورا",
  "block.minecraft.cherry_log": "کايو بالق ساکورا",
  "block.minecraft.cherry_planks": "ڤاڤن ساکورا",
  "block.minecraft.cherry_pressure_plate": "ڤلت تکنن ساکورا",
  "block.minecraft.cherry_sapling": "انق ڤوکوق ساکورا",
  "block.minecraft.cherry_shelf": "رق ساکورا",
  "block.minecraft.cherry_sign": "ڤاڤن تندا ساکورا",
  "block.minecraft.cherry_slab": "ڤاڤق ساکورا",
  "block.minecraft.cherry_stairs": "تڠݢ ساکورا",
  "block.minecraft.cherry_trapdoor": "ڤينتو کولوڠ ساکورا",
  "block.minecraft.cherry_wall_hanging_sign": "ڤاڤن تندا برتمݢنتوڠ دينديڠ ساکورا",
  "block.minecraft.cherry_wall_sign": "ڤاڤن تندا دينديڠ ساکورا",
  "block.minecraft.cherry_wood": "کايو ساکورا",
  "block.minecraft.chest": "ڤتي",
  "block.minecraft.chipped_anvil": "اندس سومبيڠ",
  "block.minecraft.chiseled_bookshelf": "رق بوکو ترڤاهت",
  "block.minecraft.chiseled_copper": "تمباݢ ترڤاهت",
  "block.minecraft.chiseled_deepslate": "باتو لوه ترڤاهت",
  "block.minecraft.chiseled_nether_bricks": "بات نيذر براوکير",
  "block.minecraft.chiseled_polished_blackstone": "باتو هيتم دݢيلڤ ترڤاهت",
  "block.minecraft.chiseled_quartz_block": "بلوک کوارزا دڤاهت",
  "block.minecraft.chiseled_red_sandstone": "باتو ڤاسير ميره ترڤاهت",
  "block.minecraft.chiseled_resin_bricks": "بات دامر ترڤاهت",
  "block.minecraft.chiseled_sandstone": "باتو ڤاسير ترڤاهت",
  "block.minecraft.chiseled_stone_bricks": "بات باتو ترڤاهت",
  "block.minecraft.chiseled_tuff": "توف ترڤاهت",
  "block.minecraft.chiseled_tuff_bricks": "بات توف ترڤاهت",
  "block.minecraft.chorus_flower": "بوڠا کوروس",
  "block.minecraft.chorus_plant": "ڤوکوق کوروس",
  "block.minecraft.clay": "تانه ليات",
  "block.minecraft.closed_eyeblossom": "ڤوسڤا مات ترتوتوڤ",
  "block.minecraft.coal_block": "بلوک ارڠ باتو",
  "block.minecraft.coal_ore": "بيجيه ارڠ باتو",
  "block.minecraft.coarse_dirt": "تانه کاسر",
  "block.minecraft.cobbled_deepslate": "باتو بونتر لوه",
  "block.minecraft.cobbled_deepslate_slab": "ڤاڤق باتو بونتر لوه",
  "block.minecraft.cobbled_deepslate_stairs": "تڠݢ باتو بونتر لوه",
  "block.minecraft.cobbled_deepslate_wall": "تيمبوق باتو بونتر لوه",
  "block.minecraft.cobblestone": "باتو بونتر",
  "block.minecraft.cobblestone_slab": "ڤاڤق باتو بونتر",
  "block.minecraft.cobblestone_stairs": "تڠݢ باتو بونتر",
  "block.minecraft.cobblestone_wall": "تيمبوق باتو بونتر",
  "block.minecraft.cobweb": "سارڠ لابه٢",
  "block.minecraft.cocoa": "کوکو",
  "block.minecraft.command_block": "بلوک ڤرينته",
  "block.minecraft.comparator": "ڤمبنديڠ ريدستون",
  "block.minecraft.composter": "ڤمبوات کومڤوس",
  "block.minecraft.conduit": "ڤمبولوه",
  "block.minecraft.copper_bars": "ڤالڠ تمباݢ",
  "block.minecraft.copper_block": "بلوک تمباݢ",
  "block.minecraft.copper_bulb": "مينتول تمباݢ",
  "block.minecraft.copper_chain": "رنتاي تمباݢ",
  "block.minecraft.copper_chest": "ڤتي تمباݢ",
  "block.minecraft.copper_door": "ڤينتو تمباݢ",
  "block.minecraft.copper_golem_statue": "ڤاتوڠ ݢولم تمباݢ",
  "block.minecraft.copper_grate": "جريجي تمباݢ",
  "block.minecraft.copper_lantern": "تڠلوڠ تمباݢ",
  "block.minecraft.copper_ore": "بيجيه تمباݢ",
  "block.minecraft.copper_torch": "اوبور تمباݢ",
  "block.minecraft.copper_trapdoor": "ڤينتو کولوڠ تمباݢ",
  "block.minecraft.copper_wall_torch": "اوبور دينديڠ تمباݢ",
  "block.minecraft.cornflower": "کورنفلاور",
  "block.minecraft.cracked_deepslate_bricks": "بات لوه رکه",
  "block.minecraft.cracked_deepslate_tiles": "ݢنتيڠ لوه رکه",
  "block.minecraft.cracked_nether_bricks": "بات نيذر رکه",
  "block.minecraft.cracked_polished_blackstone_bricks": "بات باتو هيتم دݢيلڤ رکه",
  "block.minecraft.cracked_stone_bricks": "بات باتو رکه",
  "block.minecraft.crafter": "ڤنوکڠ",
  "block.minecraft.crafting_table": "ڤرتوکڠن",
  "block.minecraft.creaking_heart": "جنتوڠ دريتن",
  "block.minecraft.creeper_head": "کڤالا کريڤر",
  "block.minecraft.creeper_wall_head": "کڤالا دينديڠ کريڤر",
  "block.minecraft.crimson_button": "بوتڠ کيرميزي",
  "block.minecraft.crimson_door": "ڤينتو کيرميزي",
  "block.minecraft.crimson_fence": "ڤاݢر کيرميزي",
  "block.minecraft.crimson_fence_gate": "ڤينتو ڤاݢر کيرميزي",
  "block.minecraft.crimson_fungus": "کولت کيرميزي",
  "block.minecraft.crimson_hanging_sign": "ڤاڤن تندا برݢنتوڠ کيرميزي",
  "block.minecraft.crimson_hyphae": "هيفا کيرميزي",
  "block.minecraft.crimson_nylium": "نيليوم کيرميزي",
  "block.minecraft.crimson_planks": "ڤاڤن کيرميزي",
  "block.minecraft.crimson_pressure_plate": "ڤلت تکنن کيرميزي",
  "block.minecraft.crimson_roots": "اکر کيرميزي",
  "block.minecraft.crimson_shelf": "رق کيرميزي",
  "block.minecraft.crimson_sign": "ڤاڤن تندا کيرميزي",
  "block.minecraft.crimson_slab": "ڤاڤق کيرميزي",
  "block.minecraft.crimson_stairs": "تڠݢ کيرميزي",
  "block.minecraft.crimson_stem": "باتڠ کيرميزي",
  "block.minecraft.crimson_trapdoor": "ڤينتو کولوڠ کيرميزي",
  "block.minecraft.crimson_wall_hanging_sign": "ڤاڤن تندا دينديڠ برݢنتوڠ کيرميزي",
  "block.minecraft.crimson_wall_sign": "ڤاڤن تندا دينديڠ کيرميزي",
  "block.minecraft.crying_obsidian": "اوبسيديان مناڠيس",
  "block.minecraft.cut_copper": "تمباݢ ترڤوتوڠ",
  "block.minecraft.cut_copper_slab": "ڤاڤق تمباݢ ترڤوتوڠ",
  "block.minecraft.cut_copper_stairs": "تڠݢ تمباݢ ترڤوتوڠ",
  "block.minecraft.cut_red_sandstone": "باتو ڤاسير ميره دڤوتوڠ",
  "block.minecraft.cut_red_sandstone_slab": "ڤاڤق باتو ڤاسير ميره دڤوتوڠ",
  "block.minecraft.cut_sandstone": "باتو ڤاسير دڤوتوڠ",
  "block.minecraft.cut_sandstone_slab": "ڤاڤق باتو ڤاسير دڤوتوڠ",
  "block.minecraft.cyan_banner": "ڤنجي سيان",
  "block.minecraft.cyan_bed": "کاتيل سيان",
  "block.minecraft.cyan_candle": "ديان سيان",
  "block.minecraft.cyan_candle_cake": "کيک برديان سيان",
  "block.minecraft.cyan_carpet": "ڤرماٴيداني سيان",
  "block.minecraft.cyan_concrete": "کونکريت سيان",
  "block.minecraft.cyan_concrete_powder": "سربوق کونکريت سيان",
  "block.minecraft.cyan_glazed_terracotta": "تيراکوتا ليچاو سيان",
  "block.minecraft.cyan_shulker_box": "کوتق شلکر سيان",
  "block.minecraft.cyan_stained_glass": "کاچ برورنا سيان",
  "block.minecraft.cyan_stained_glass_pane": "انق کاچ برورنا سيان",
  "block.minecraft.cyan_terracotta": "تيراکوتا سيان",
  "block.minecraft.cyan_wool": "بولو سيان",
  "block.minecraft.damaged_anvil": "اندس روسق",
  "block.minecraft.dandelion": "بوڠا ڤليمن",
  "block.minecraft.dark_oak_button": "بوتڠ اوک ݢلڤ",
  "block.minecraft.dark_oak_door": "ڤينتو کايو اوک ݢلڤ",
  "block.minecraft.dark_oak_fence": "ڤاݢر اوک ݢلڤ",
  "block.minecraft.dark_oak_fence_gate": "ڤينتو ڤاݢر اوک ݢلڤ",
  "block.minecraft.dark_oak_hanging_sign": "ڤاڤن تندا برݢنتوڠ اوک ݢلڤ",
  "block.minecraft.dark_oak_leaves": "داٴون اوک ݢلڤ",
  "block.minecraft.dark_oak_log": "کايو بالق اوک ݢلڤ",
  "block.minecraft.dark_oak_planks": "ڤاڤن کايو اوک ݢلڤ",
  "block.minecraft.dark_oak_pressure_plate": "ڤلت تکنن اوک ݢلڤ",
  "block.minecraft.dark_oak_sapling": "انق ڤوکوق اوک ݢلڤ",
  "block.minecraft.dark_oak_shelf": "رق اوک ݢلڤ",
  "block.minecraft.dark_oak_sign": "ڤاڤن تندا اوک ݢلڤ",
  "block.minecraft.dark_oak_slab": "ڤاڤق اوک ݢلڤ",
  "block.minecraft.dark_oak_stairs": "تڠݢ اوک ݢلڤ",
  "block.minecraft.dark_oak_trapdoor": "ڤينتو کولوڠ اوک ݢلڤ",
  "block.minecraft.dark_oak_wall_hanging_sign": "ڤاڤن تندا دينديڠ برݢنتوڠ اوک ݢلڤ",
  "block.minecraft.dark_oak_wall_sign": "ڤاڤن تندا دينديڠ اوک ݢلڤ",
  "block.minecraft.dark_oak_wood": "کايو اوک ݢلڤ",
  "block.minecraft.dark_prismarine": "ڤريسمارين ݢلڤ",
  "block.minecraft.dark_prismarine_slab": "ڤاڤق ڤريسمارين ݢلڤ",
  "block.minecraft.dark_prismarine_stairs": "تڠݢ ڤريسمارين ݢلڤ",
  "block.minecraft.daylight_detector": "ڤڠسن چهاي لاڠيت",
  "block.minecraft.dead_brain_coral": "کارڠ اوتق ماتي",
  "block.minecraft.dead_brain_coral_block": "بلوک کارڠ اوتق ماتي",
  "block.minecraft.dead_brain_coral_fan": "اکر باهر اوتق ماتي",
  "block.minecraft.dead_brain_coral_wall_fan": "اکر باهر دينديڠ اوتق ماتي",
  "block.minecraft.dead_bubble_coral": "کارڠ بوٴيه ماتي",
  "block.minecraft.dead_bubble_coral_block": "بلوک کارڠ بوٴيه ماتي",
  "block.minecraft.dead_bubble_coral_fan": "اکر باهر بوٴيه ماتي",
  "block.minecraft.dead_bubble_coral_wall_fan": "اکر باهر دينديڠ بوٴيه ماتي",
  "block.minecraft.dead_bush": "سمق ماتي",
  "block.minecraft.dead_fire_coral": "کارڠ اڤي ماتي",
  "block.minecraft.dead_fire_coral_block": "بلوک کارڠ اڤي ماتي",
  "block.minecraft.dead_fire_coral_fan": "اکر باهر اڤي ماتي",
  "block.minecraft.dead_fire_coral_wall_fan": "اکر باهر دينديڠ اڤي ماتي",
  "block.minecraft.dead_horn_coral": "کارڠ تندوق ماتي",
  "block.minecraft.dead_horn_coral_block": "بلوک کارڠ تندوق ماتي",
  "block.minecraft.dead_horn_coral_fan": "اکر باهر تندوق ماتي",
  "block.minecraft.dead_horn_coral_wall_fan": "اکر باهر دينديڠ تندوق ماتي",
  "block.minecraft.dead_tube_coral": "کارڠ تيوب ماتي",
  "block.minecraft.dead_tube_coral_block": "بلوک کارڠ تيوب ماتي",
  "block.minecraft.dead_tube_coral_fan": "اکر باهر تيوب ماتي",
  "block.minecraft.dead_tube_coral_wall_fan": "اکر باهر دينديڠ تيوب ماتي",
  "block.minecraft.decorated_pot": "ڤاسو برهياس",
  "block.minecraft.deepslate": "باتو لوه",
  "block.minecraft.deepslate_brick_slab": "ڤاڤق باتو بات لوه",
  "block.minecraft.deepslate_brick_stairs": "تڠݢ باتو بات لوه",
  "block.minecraft.deepslate_brick_wall": "تيمبوق باتو بات لوه",
  "block.minecraft.deepslate_bricks": "بات لوه",
  "block.minecraft.deepslate_coal_ore": "بيجيه ارڠ باتو لوه",
  "block.minecraft.deepslate_copper_ore": "بيجيه تمباݢ لوه",
  "block.minecraft.deepslate_diamond_ore": "بيجيه برليان لوه",
  "block.minecraft.deepslate_emerald_ore": "بيجيه زمرود لوه",
  "block.minecraft.deepslate_gold_ore": "بيجيه امس لوه",
  "block.minecraft.deepslate_iron_ore": "بيجيه بسي لوه",
  "block.minecraft.deepslate_lapis_ore": "بيجيه لاڤيس لازولي لوه",
  "block.minecraft.deepslate_redstone_ore": "بيجيه ريدستون لوه",
  "block.minecraft.deepslate_tile_slab": "ڤاڤق ݢنتيڠ لوه",
  "block.minecraft.deepslate_tile_stairs": "تڠݢ ݢنتيڠ لوه",
  "block.minecraft.deepslate_tile_wall": "تيمبوق ݢنتيڠ لوه",
  "block.minecraft.deepslate_tiles": "ݢنتيڠ لوه",
  "block.minecraft.detector_rail": "لندسن ڤڠسن",
  "block.minecraft.diamond_block": "بلوک برليان",
  "block.minecraft.diamond_ore": "بيجيه برليان",
  "block.minecraft.diorite": "ديوريت",
  "block.minecraft.diorite_slab": "ڤاڤق ديوريت",
  "block.minecraft.diorite_stairs": "تڠݢ ديوريت",
  "block.minecraft.diorite_wall": "تيمبوق ديوريت",
  "block.minecraft.dirt": "تانه",
  "block.minecraft.dirt_path": "بلوک لالوان تانه",
  "block.minecraft.dispenser": "ڤڠاݢيه",
  "block.minecraft.dragon_egg": "تلور ناݢ",
  "block.minecraft.dragon_head": "کڤالا ناݢ",
  "block.minecraft.dragon_wall_head": "کڤالا دينديڠ ناݢ",
  "block.minecraft.dried_ghast": "ݢس‌ت کريڠ",
  "block.minecraft.dried_kelp_block": "بلوک کيل‌ڤ کريڠ",
  "block.minecraft.dripstone_block": "بلوک باتو تيتيس",
  "block.minecraft.dropper": "ڤنيتيس",
  "block.minecraft.emerald_block": "بلوک زمرود",
  "block.minecraft.emerald_ore": "بيجيه زمرود",
  "block.minecraft.enchanting_table": "ڤرتوکڠن سيحير",
  "block.minecraft.end_gateway": "ڤينتو ݢربڠ ٴين‌د",
  "block.minecraft.end_portal": "ݢربڠ ٴين‌د",
  "block.minecraft.end_portal_frame": "بيڠکاي ݢربڠ ٴين‌د",
  "block.minecraft.end_rod": "باتڠ ٴين‌د",
  "block.minecraft.end_stone": "باتو ٴين‌د",
  "block.minecraft.end_stone_brick_slab": "ڤاڤق باتو بات ٴين‌د",
  "block.minecraft.end_stone_brick_stairs": "تڠݢ بات باتو ٴين‌د",
  "block.minecraft.end_stone_brick_wall": "تيمبوق بات باتو ٴين‌د",
  "block.minecraft.end_stone_bricks": "بات باتو ٴين‌د",
  "block.minecraft.ender_chest": "ڤتي ٴين‌د",
  "block.minecraft.exposed_chiseled_copper": "تمباݢ ترڤاهت تردده",
  "block.minecraft.exposed_copper": "تمباݢ تردده",
  "block.minecraft.exposed_copper_bars": "ڤالڠ تمباݢ تردده",
  "block.minecraft.exposed_copper_bulb": "مينتول تمباݢ تردده",
  "block.minecraft.exposed_copper_chain": "رنتاي تمباݢ تردده",
  "block.minecraft.exposed_copper_chest": "ڤتي تمباݢ تردده",
  "block.minecraft.exposed_copper_door": "ڤينتو تمباݢ تردده",
  "block.minecraft.exposed_copper_golem_statue": "ڤاتوڠ ݢولم تمباݢ تردده",
  "block.minecraft.exposed_copper_grate": "جريجي تمباݢ تردده",
  "block.minecraft.exposed_copper_lantern": "تڠلوڠ تمباݢ تردده",
  "block.minecraft.exposed_copper_trapdoor": "ڤينتو کولوڠ تمباݢ تردده",
  "block.minecraft.exposed_cut_copper": "تمباݢ ترڤوتوڠ تردده",
  "block.minecraft.exposed_cut_copper_slab": "ڤاڤق تمباݢ ترڤوتوڠ تردده",
  "block.minecraft.exposed_cut_copper_stairs": "تڠݢ تمباݢ ترڤوتوڠ تردده",
  "block.minecraft.exposed_lightning_rod": "ڤڠالير کيلت تردده",
  "block.minecraft.farmland": "تانه لادڠ",
  "block.minecraft.fern": "ڤاکو ڤاکيس",
  "block.minecraft.fire": "اڤي",
  "block.minecraft.fire_coral": "کارڠ اڤي",
  "block.minecraft.fire_coral_block": "بلوک کارڠ اڤي",
  "block.minecraft.fire_coral_fan": "اکر باهر اڤي",
  "block.minecraft.fire_coral_wall_fan": "اکر باهر دينديڠ اڤي",
  "block.minecraft.firefly_bush": "سمق کليڤ٢",
  "block.minecraft.fletching_table": "ڤرتوکڠن ڤانه",
  "block.minecraft.flower_pot": "ڤاسو بوڠا",
  "block.minecraft.flowering_azalea": "ازاليا برمکر",
  "block.minecraft.flowering_azalea_leaves": "داٴون ازاليا برمکر",
  "block.minecraft.frogspawn": "تلور کاتق",
  "block.minecraft.frosted_ice": "اٴيس بکو",
  "block.minecraft.furnace": "رلاو",
  "block.minecraft.gilded_blackstone": "باتو هيتم برسڤوه",
  "block.minecraft.glass": "کاچ",
  "block.minecraft.glass_pane": "انق کاچ",
  "block.minecraft.glow_lichen": "ليکن برسينر",
  "block.minecraft.glowstone": "باتو مڽالا",
  "block.minecraft.gold_block": "بلوک امس",
  "block.minecraft.gold_ore": "بيجيه امس",
  "block.minecraft.golden_dandelion": "بوڠا ڤليمن امس",
  "block.minecraft.granite": "ݢرانيت",
  "block.minecraft.granite_slab": "ڤاڤق ݢرانيت",
  "block.minecraft.granite_stairs": "تڠݢ ݢرانيت",
  "block.minecraft.granite_wall": "تيمبوق ݢرانيت",
  "block.minecraft.grass": "رومڤوت",
  "block.minecraft.grass_block": "بلوک رومڤوت",
  "block.minecraft.gravel": "باتو کليکير",
  "block.minecraft.gray_banner": "ڤنجي کلابو",
  "block.minecraft.gray_bed": "کاتيل کلابو",
  "block.minecraft.gray_candle": "ديان کلابو",
  "block.minecraft.gray_candle_cake": "کيک برديان کلابو",
  "block.minecraft.gray_carpet": "ڤرماٴيداني کلابو",
  "block.minecraft.gray_concrete": "کونکريت کلابو",
  "block.minecraft.gray_concrete_powder": "سربوق کونکريت کلابو",
  "block.minecraft.gray_glazed_terracotta": "تيراکوتا ليچاو کلابو",
  "block.minecraft.gray_shulker_box": "کوتق شلکر کلابو",
  "block.minecraft.gray_stained_glass": "کاچ برورنا کلابو",
  "block.minecraft.gray_stained_glass_pane": "انق کاچ برورنا کلابو",
  "block.minecraft.gray_terracotta": "تيراکوتا کلابو",
  "block.minecraft.gray_wool": "بولو کلابو",
  "block.minecraft.green_banner": "ڤنجي هيجاو",
  "block.minecraft.green_bed": "کاتيل هيجاو",
  "block.minecraft.green_candle": "ديان هيجاو",
  "block.minecraft.green_candle_cake": "کيک برديان هيجاو",
  "block.minecraft.green_carpet": "ڤرماٴيداني هيجاو",
  "block.minecraft.green_concrete": "کونکريت هيجاو",
  "block.minecraft.green_concrete_powder": "سربوق کونکريت هيجاو",
  "block.minecraft.green_glazed_terracotta": "تيراکوتا ليچاو هيجاو",
  "block.minecraft.green_shulker_box": "کوتق شلکر هيجاو",
  "block.minecraft.green_stained_glass": "کاچ برورنا هيجاو",
  "block.minecraft.green_stained_glass_pane": "انق کاچ برورنا هيجاو",
  "block.minecraft.green_terracotta": "تيراکوتا هيجاو",
  "block.minecraft.green_wool": "بولو هيجاو",
  "block.minecraft.grindstone": "باتو ڤڠاسه",
  "block.minecraft.hanging_roots": "اکر ترݢنتوڠ",
  "block.minecraft.hay_block": "بندلا جرامي",
  "block.minecraft.heavy_core": "ترس برت",
  "block.minecraft.heavy_weighted_pressure_plate": "ڤلت تکنن برت",
  "block.minecraft.honey_block": "بلوک مادو",
  "block.minecraft.honeycomb_block": "بلوک ايندوڠ مادو",
  "block.minecraft.hopper": "چوروڠ تواڠ",
  "block.minecraft.horn_coral": "کارڠ تندوق",
  "block.minecraft.horn_coral_block": "بلوک کارڠ تندوق",
  "block.minecraft.horn_coral_fan": "اکر باهر تندوق",
  "block.minecraft.horn_coral_wall_fan": "اکر باهر دينديڠ تندوق",
  "block.minecraft.ice": "اٴيس",
  "block.minecraft.infested_chiseled_stone_bricks": "بات باتو ترڤاهت ترموت",
  "block.minecraft.infested_cobblestone": "باتو بونتر ترموت",
  "block.minecraft.infested_cracked_stone_bricks": "بات باتو رکه ترموت",
  "block.minecraft.infested_deepslate": "باتو لوه ترايموت",
  "block.minecraft.infested_mossy_stone_bricks": "بات باتو برلوموت ترموت",
  "block.minecraft.infested_stone": "باتو ترموت",
  "block.minecraft.infested_stone_bricks": "بات باتو ترموت",
  "block.minecraft.iron_bars": "ڤالڠ بسي",
  "block.minecraft.iron_block": "بلوک بسي",
  "block.minecraft.iron_chain": "رنتاي بسي",
  "block.minecraft.iron_door": "ڤينتو بسي",
  "block.minecraft.iron_ore": "بيجيه بسي",
  "block.minecraft.iron_trapdoor": "ڤينتو کولوڠ بسي",
  "block.minecraft.jack_o_lantern": "تڠلوڠ لابو",
  "block.minecraft.jigsaw": "بلوک سواي-جودوه",
  "block.minecraft.jukebox": "ڤتي لاݢو",
  "block.minecraft.jungle_button": "بوتڠ ريمبا",
  "block.minecraft.jungle_door": "ڤينتو کايو ريمبا",
  "block.minecraft.jungle_fence": "ڤاݢر ريمبا",
  "block.minecraft.jungle_fence_gate": "ڤينتو ڤاݢر ريمبا",
  "block.minecraft.jungle_hanging_sign": "ڤاڤن تندا برݢنتوڠ ريمبا",
  "block.minecraft.jungle_leaves": "داٴون ريمبا",
  "block.minecraft.jungle_log": "کايو بالق ريمبا",
  "block.minecraft.jungle_planks": "ڤاڤن کايو ريمبا",
  "block.minecraft.jungle_pressure_plate": "ڤلت تکنن ريمبا",
  "block.minecraft.jungle_sapling": "انق ڤوکوق ريمبا",
  "block.minecraft.jungle_shelf": "رق ريمبا",
  "block.minecraft.jungle_sign": "ڤاڤن تندا ريمبا",
  "block.minecraft.jungle_slab": "ڤاڤق ريمبا",
  "block.minecraft.jungle_stairs": "تڠݢ ريمبا",
  "block.minecraft.jungle_trapdoor": "ڤينتو کولوڠ ريمبا",
  "block.minecraft.jungle_wall_hanging_sign": "ڤاڤن تندا دينديڠ برݢنتوڠ ريمبا",
  "block.minecraft.jungle_wall_sign": "ڤاڤن تندا دينديڠ ريمبا",
  "block.minecraft.jungle_wood": "کايو ريمبا",
  "block.minecraft.kelp": "کيل‌ڤ",
  "block.minecraft.kelp_plant": "تومبوهن کيل‌ڤ",
  "block.minecraft.ladder": "تڠݢ",
  "block.minecraft.lantern": "تڠلوڠ",
  "block.minecraft.lapis_block": "بلوک لاڤيس لازولي",
  "block.minecraft.lapis_ore": "بيجيه لاڤيس لازولي",
  "block.minecraft.large_amethyst_bud": "تونس باتو کچوبوڠ بسر",
  "block.minecraft.large_fern": "ڤاکو ڤاکيس بسر",
  "block.minecraft.lava": "لاهر",
  "block.minecraft.lava_cauldron": "کاوه لاهر",
  "block.minecraft.leaf_litter": "داٴون کريڠ",
  "block.minecraft.lectern": "ميجا شرحن",
  "block.minecraft.lever": "تواس",
  "block.minecraft.light": "بلوک چهاي",
  "block.minecraft.light_blue_banner": "ڤنجي بيرو مودا",
  "block.minecraft.light_blue_bed": "کاتيل بيرو مودا",
  "block.minecraft.light_blue_candle": "ديان بيرو مودا",
  "block.minecraft.light_blue_candle_cake": "کيک برديان بيرو مودا",
  "block.minecraft.light_blue_carpet": "ڤرماٴيداني بيرو مودا",
  "block.minecraft.light_blue_concrete": "کونکريت بيرو مودا",
  "block.minecraft.light_blue_concrete_powder": "سربوق کونکريت بيرو مودا",
  "block.minecraft.light_blue_glazed_terracotta": "تيراکوتا ليچاو بيرو مودا",
  "block.minecraft.light_blue_shulker_box": "کوتق شلکر بيرو مودا",
  "block.minecraft.light_blue_stained_glass": "کاچ برورنا بيرو مودا",
  "block.minecraft.light_blue_stained_glass_pane": "انق کاچ برورنا بيرو مودا",
  "block.minecraft.light_blue_terracotta": "تيراکوتا بيرو مودا",
  "block.minecraft.light_blue_wool": "بولو بيرو مودا",
  "block.minecraft.light_gray_banner": "ڤنجي کلابو مودا",
  "block.minecraft.light_gray_bed": "کاتيل کلابو مودا",
  "block.minecraft.light_gray_candle": "ديان کلابو مودا",
  "block.minecraft.light_gray_candle_cake": "کيک برديان کلابو مودا",
  "block.minecraft.light_gray_carpet": "ڤرماٴيداني کلابو مودا",
  "block.minecraft.light_gray_concrete": "کونکريت کلابو مودا",
  "block.minecraft.light_gray_concrete_powder": "سربوق کونکريت کلابو مودا",
  "block.minecraft.light_gray_glazed_terracotta": "تيراکوتا ليچاو کلابو مودا",
  "block.minecraft.light_gray_shulker_box": "کوتق شلکر کلابو مودا",
  "block.minecraft.light_gray_stained_glass": "کاچ برورنا کلابو مودا",
  "block.minecraft.light_gray_stained_glass_pane": "انق کاچ برورنا کلابو مودا",
  "block.minecraft.light_gray_terracotta": "تيراکوتا کلابو مودا",
  "block.minecraft.light_gray_wool": "بولو کلابو مودا",
  "block.minecraft.light_weighted_pressure_plate": "ڤلت تکنن ريڠن",
  "block.minecraft.lightning_rod": "ڤڠالير کيلت",
  "block.minecraft.lilac": "لاٴيليک",
  "block.minecraft.lily_of_the_valley": "باکوڠ لمبه",
  "block.minecraft.lily_pad": "تاڤق تراتاي",
  "block.minecraft.lime_banner": "ڤنجي هيجاو مودا",
  "block.minecraft.lime_bed": "کاتيل هيجاو مودا",
  "block.minecraft.lime_candle": "ديان هيجاو مودا",
  "block.minecraft.lime_candle_cake": "کيک برديان هيجاو مودا",
  "block.minecraft.lime_carpet": "ڤرماٴيداني هيجاو مودا",
  "block.minecraft.lime_concrete": "کونکريت هيجاو مودا",
  "block.minecraft.lime_concrete_powder": "سربوق کونکريت هيجاو مودا",
  "block.minecraft.lime_glazed_terracotta": "تيراکوتا ليچاو هيجاو مودا",
  "block.minecraft.lime_shulker_box": "کوتق شلکر هيجاو مودا",
  "block.minecraft.lime_stained_glass": "کاچ برورنا هيجاو مودا",
  "block.minecraft.lime_stained_glass_pane": "انق کاچ برورنا هيجاو مودا",
  "block.minecraft.lime_terracotta": "تيراکوتا هيجاو مودا",
  "block.minecraft.lime_wool": "بولو هيجاو مودا",
  "block.minecraft.lodestone": "باتو مݢنيت",
  "block.minecraft.loom": "الت تنون",
  "block.minecraft.magenta_banner": "ڤنجي ماݢينتا",
  "block.minecraft.magenta_bed": "کاتيل ماݢينتا",
  "block.minecraft.magenta_candle": "ديان ماݢينتا",
  "block.minecraft.magenta_candle_cake": "کيک برديان ماݢينتا",
  "block.minecraft.magenta_carpet": "ڤرماٴيداني ماݢينتا",
  "block.minecraft.magenta_concrete": "کونکريت ماݢينتا",
  "block.minecraft.magenta_concrete_powder": "سربوق کونکريت ماݢينتا",
  "block.minecraft.magenta_glazed_terracotta": "تيراکوتا ليچاو ماݢينتا",
  "block.minecraft.magenta_shulker_box": "کوتق شلکر ماݢينتا",
  "block.minecraft.magenta_stained_glass": "کاچ برورنا ماݢينتا",
  "block.minecraft.magenta_stained_glass_pane": "انق کاچ برورنا ماݢينتا",
  "block.minecraft.magenta_terracotta": "تيراکوتا ماݢينتا",
  "block.minecraft.magenta_wool": "بولو ماݢينتا",
  "block.minecraft.magma_block": "بلوک مݢما",
  "block.minecraft.mangrove_button": "بوتڠ باکاو",
  "block.minecraft.mangrove_door": "ڤينتو باکاو",
  "block.minecraft.mangrove_fence": "ڤاݢر باکاو",
  "block.minecraft.mangrove_fence_gate": "ڤينتو ڤاݢر باکاو",
  "block.minecraft.mangrove_hanging_sign": "ڤاڤن تندا برݢنتوڠ باکاو",
  "block.minecraft.mangrove_leaves": "داٴون باکاو",
  "block.minecraft.mangrove_log": "کايو بالق باکاو",
  "block.minecraft.mangrove_planks": "ڤاڤن باکاو",
  "block.minecraft.mangrove_pressure_plate": "ڤلت تکنن باکاو",
  "block.minecraft.mangrove_propagule": "ڤروڤاݢول باکاو",
  "block.minecraft.mangrove_roots": "اکر باکاو",
  "block.minecraft.mangrove_shelf": "رق باکاو",
  "block.minecraft.mangrove_sign": "ڤاڤن تندا باکاو",
  "block.minecraft.mangrove_slab": "ڤاڤق باکاو",
  "block.minecraft.mangrove_stairs": "تڠݢ باکاو",
  "block.minecraft.mangrove_trapdoor": "ڤينتو کولوڠ باکاو",
  "block.minecraft.mangrove_wall_hanging_sign": "ڤاڤن تندا دينديڠ برݢنتوڠ باکاو",
  "block.minecraft.mangrove_wall_sign": "ڤاڤن تندا دينديڠ باکاو",
  "block.minecraft.mangrove_wood": "کايو باکاو",
  "block.minecraft.medium_amethyst_bud": "تونس باتو کچوبوڠ سدرهان",
  "block.minecraft.melon": "تمبيکاي",
  "block.minecraft.melon_stem": "باتڠ تمبيکاي",
  "block.minecraft.moss_block": "بلوک لوموت",
  "block.minecraft.moss_carpet": "ليتوڤن لوموت",
  "block.minecraft.mossy_cobblestone": "باتو بونتق برلوموت",
  "block.minecraft.mossy_cobblestone_slab": "ڤاڤق باتو بونتر برلوموت",
  "block.minecraft.mossy_cobblestone_stairs": "تڠݢ باتو بونتر برلوموت",
  "block.minecraft.mossy_cobblestone_wall": "تيمبوق باتو بونتر برلوموت",
  "block.minecraft.mossy_stone_brick_slab": "ڤاڤق بات باتو برلوموت",
  "block.minecraft.mossy_stone_brick_stairs": "تڠݢ باتو بات برلوموت",
  "block.minecraft.mossy_stone_brick_wall": "تيمبوق باتو بات برلوموت",
  "block.minecraft.mossy_stone_bricks": "بات باتو برلوموت",
  "block.minecraft.moving_piston": "اومبوه برݢرق",
  "block.minecraft.mud": "لومڤور",
  "block.minecraft.mud_brick_slab": "ڤاڤق بات لومڤور",
  "block.minecraft.mud_brick_stairs": "تڠݢ بات لومڤور",
  "block.minecraft.mud_brick_wall": "تيمبوق بات لومڤور",
  "block.minecraft.mud_bricks": "بات لومڤور",
  "block.minecraft.muddy_mangrove_roots": "اکر باکاو برلومڤور",
  "block.minecraft.mushroom_stem": "باتڠ چنداون",
  "block.minecraft.mycelium": "ميسيليوم",
  "block.minecraft.nether_brick_fence": "ڤاݢر بات نيذر",
  "block.minecraft.nether_brick_slab": "ڤاڤق بات نيذر",
  "block.minecraft.nether_brick_stairs": "تڠݢ بات نيذر",
  "block.minecraft.nether_brick_wall": "تيمبوق بات نيذر",
  "block.minecraft.nether_bricks": "بات نيذر",
  "block.minecraft.nether_gold_ore": "بيجيه امس نيذر",
  "block.minecraft.nether_portal": "ݢربڠ نيذر",
  "block.minecraft.nether_quartz_ore": "بيجيه کوارزا نيذر",
  "block.minecraft.nether_sprouts": "ڤوچوق نيذر",
  "block.minecraft.nether_wart": "کتوات نيذر",
  "block.minecraft.nether_wart_block": "بلوک کتوات نيذر",
  "block.minecraft.netherite_block": "بلوک نيذريت",
  "block.minecraft.netherrack": "نيذريک",
  "block.minecraft.note_block": "بلوک نوت",
  "block.minecraft.oak_button": "بوتڠ اوک",
  "block.minecraft.oak_door": "ڤينتو کايو اوک",
  "block.minecraft.oak_fence": "ڤاݢر اوک",
  "block.minecraft.oak_fence_gate": "ڤينتو ڤاݢر اوک",
  "block.minecraft.oak_hanging_sign": "ڤاڤن تندا برݢنتوڠ اوک",
  "block.minecraft.oak_leaves": "داٴون اوک",
  "block.minecraft.oak_log": "کايو بالق اوک",
  "block.minecraft.oak_planks": "ڤاڤن کايو اوک",
  "block.minecraft.oak_pressure_plate": "ڤلت تکنن اوک",
  "block.minecraft.oak_sapling": "انق ڤوکوق اوک",
  "block.minecraft.oak_shelf": "رق اوک",
  "block.minecraft.oak_sign": "ڤاڤن تندا اوک",
  "block.minecraft.oak_slab": "ڤاڤق اوک",
  "block.minecraft.oak_stairs": "تڠݢ اوک",
  "block.minecraft.oak_trapdoor": "ڤينتو کولوڠ اوک",
  "block.minecraft.oak_wall_hanging_sign": "ڤاڤن تندا دينديڠ برݢنتوڠ اوک",
  "block.minecraft.oak_wall_sign": "ڤاڤن تندا دينديڠ اوک",
  "block.minecraft.oak_wood": "کايو اوک",
  "block.minecraft.observer": "ڤمرهاتي",
  "block.minecraft.obsidian": "اوبسيديان",
  "block.minecraft.ochre_froglight": "لمڤو کاتق کهرتلن",
  "block.minecraft.ominous_banner": "ڤنجي مڠريکن",
  "block.minecraft.open_eyeblossom": "ڤوسڤا مات تربوک",
  "block.minecraft.orange_banner": "ڤنجي جيڠݢ",
  "block.minecraft.orange_bed": "کاتيل جيڠݢ",
  "block.minecraft.orange_candle": "ديان جيڠݢ",
  "block.minecraft.orange_candle_cake": "کيک برديان جيڠݢ",
  "block.minecraft.orange_carpet": "ڤرماٴيداني جيڠݢ",
  "block.minecraft.orange_concrete": "کونکريت جيڠݢ",
  "block.minecraft.orange_concrete_powder": "سربوق کونکريت جيڠݢ",
  "block.minecraft.orange_glazed_terracotta": "تيراکوتا ليچاو جيڠݢ",
  "block.minecraft.orange_shulker_box": "کوتق شلکر جيڠݢ",
  "block.minecraft.orange_stained_glass": "کاچ برورنا جيڠݢ",
  "block.minecraft.orange_stained_glass_pane": "انق کاچ برورنا جيڠݢ",
  "block.minecraft.orange_terracotta": "تيراکوتا جيڠݢ",
  "block.minecraft.orange_tulip": "توليڤ جيڠݢ",
  "block.minecraft.orange_wool": "بولو جيڠݢ",
  "block.minecraft.oxeye_daisy": "داٴيسي اوکساي",
  "block.minecraft.oxidized_chiseled_copper": "تمباݢ ترڤاهت ترأوکسيدا",
  "block.minecraft.oxidized_copper": "تمباݢ ترأوکسيدا",
  "block.minecraft.oxidized_copper_bars": "ڤالڠ تمباݢ ترأوکسيدا",
  "block.minecraft.oxidized_copper_bulb": "مينتول تمباݢ ترأوکسيدا",
  "block.minecraft.oxidized_copper_chain": "رنتاي تمباݢ ترأوکسيدا",
  "block.minecraft.oxidized_copper_chest": "ڤتي تمباݢ ترأوکسيدا",
  "block.minecraft.oxidized_copper_door": "ڤينتو تمباݢ ترأوکسيدا",
  "block.minecraft.oxidized_copper_golem_statue": "ڤاتوڠ ݢولم تمباݢ ترأوکسيدا",
  "block.minecraft.oxidized_copper_grate": "جريجي تمباݢ ترأوکسيدا",
  "block.minecraft.oxidized_copper_lantern": "تڠلوڠ تمباݢ ترأوکسيدا",
  "block.minecraft.oxidized_copper_trapdoor": "ڤينتو کولوڠ تمباݢ ترأوکسيدا",
  "block.minecraft.oxidized_cut_copper": "تمباݢ ترڤوتوڠ ترأوکسيدا",
  "block.minecraft.oxidized_cut_copper_slab": "ڤاڤق تمباݢ ترڤوتوڠ ترأوکسيدا",
  "block.minecraft.oxidized_cut_copper_stairs": "تڠݢ تمباݢ ترڤوتوڠ ترأوکسيدا",
  "block.minecraft.oxidized_lightning_rod": "ڤڠالير کيلت ترأوکسيدا",
  "block.minecraft.packed_ice": "اٴيس ڤادت",
  "block.minecraft.packed_mud": "لومڤور ڤادت",
  "block.minecraft.pale_hanging_moss": "لوموت ڤنجالر کمسي",
  "block.minecraft.pale_moss_block": "بلوک لوموت کمسي",
  "block.minecraft.pale_moss_carpet": "ليتوڤن لوموت کمسي",
  "block.minecraft.pale_oak_button": "بوتڠ اوک کمسي",
  "block.minecraft.pale_oak_door": "ڤينتو اوک کمسي",
  "block.minecraft.pale_oak_fence": "ڤاݢر اوک کمسي",
  "block.minecraft.pale_oak_fence_gate": "ڤينتو ڤاݢر اوک کمسي",
  "block.minecraft.pale_oak_hanging_sign": "ڤاڤن تندا برݢنتوڠ اوک کمسي",
  "block.minecraft.pale_oak_leaves": "داٴون اوک کمسي",
  "block.minecraft.pale_oak_log": "کايو بالق اوک کمسي",
  "block.minecraft.pale_oak_planks": "ڤاڤن کايو اوک کمسي",
  "block.minecraft.pale_oak_pressure_plate": "ڤلت تکنن اوک کمسي",
  "block.minecraft.pale_oak_sapling": "انق ڤوکوق اوک کمسي",
  "block.minecraft.pale_oak_shelf": "رق اوک کمسي",
  "block.minecraft.pale_oak_sign": "ڤاڤن تندا اوک کمسي",
  "block.minecraft.pale_oak_slab": "ڤاڤق اوک کمسي",
  "block.minecraft.pale_oak_stairs": "تڠݢ اوک کمسي",
  "block.minecraft.pale_oak_trapdoor": "ڤينتو کولوڠ اوک کمسي",
  "block.minecraft.pale_oak_wall_hanging_sign": "ڤاڤن تندا برݢنتوڠ دينديڠ اوک کمسي",
  "block.minecraft.pale_oak_wall_sign": "ڤاڤن تندا دينديڠ اوک کمسي",
  "block.minecraft.pale_oak_wood": "کايو اوک کمسي",
  "block.minecraft.pearlescent_froglight": "لمڤو کاتق کموتياراٴن",
  "block.minecraft.peony": "ڤيوني",
  "block.minecraft.petrified_oak_slab": "ڤاڤق اوک ممباتو",
  "block.minecraft.piglin_head": "کڤالا ڤيݢلين",
  "block.minecraft.piglin_wall_head": "کڤالا دينديڠ ڤيݢلين",
  "block.minecraft.pink_banner": "ڤنجي ميره جمبو",
  "block.minecraft.pink_bed": "کاتيل ميره جمبو",
  "block.minecraft.pink_candle": "ديان ميره جمبو",
  "block.minecraft.pink_candle_cake": "کيک برديان ميره جمبو",
  "block.minecraft.pink_carpet": "ڤرماٴيداني ميره جمبو",
  "block.minecraft.pink_concrete": "کونکريت ميره جمبو",
  "block.minecraft.pink_concrete_powder": "سربوق کونکريت ميره جمبو",
  "block.minecraft.pink_glazed_terracotta": "تيراکوتا ليچاو ميره جمبو",
  "block.minecraft.pink_petals": "کلوڤق ميره جمبو",
  "block.minecraft.pink_shulker_box": "کوتق شلکر ميره جمبو",
  "block.minecraft.pink_stained_glass": "کاچ برورنا ميره جمبو",
  "block.minecraft.pink_stained_glass_pane": "انق کاچ برورنا ميره جمبو",
  "block.minecraft.pink_terracotta": "تيراکوتا ميره جمبو",
  "block.minecraft.pink_tulip": "توليڤ ميره جمبو",
  "block.minecraft.pink_wool": "بولو ميره جمبو",
  "block.minecraft.piston": "اومبوه",
  "block.minecraft.piston_head": "کڤالا اومبوه",
  "block.minecraft.pitcher_crop": "تانمن ڤريوق کرا",
  "block.minecraft.pitcher_plant": "ڤريوق کرا",
  "block.minecraft.player_head": "کڤالا ڤماٴين",
  "block.minecraft.player_head.named": "کڤالا %s",
  "block.minecraft.player_wall_head": "کڤالا دينديڠ ڤماٴين",
  "block.minecraft.podzol": "ڤودزول",
  "block.minecraft.pointed_dripstone": "باتو تيتيس رونچيڠ",
  "block.minecraft.polished_andesite": "اندسيت دݢيلڤ",
  "block.minecraft.polished_andesite_slab": "ڤاڤق اندسيت دݢيلڤ",
  "block.minecraft.polished_andesite_stairs": "تڠݢ اندسيت دݢيلڤ",
  "block.minecraft.polished_basalt": "باسل‌ت دݢيلڤ",
  "block.minecraft.polished_blackstone": "باتو هيتم دݢيلڤ",
  "block.minecraft.polished_blackstone_brick_slab": "ڤاڤق بات باتو هيتم دݢيلڤ",
  "block.minecraft.polished_blackstone_brick_stairs": "تڠݢ بات باتو هيتم دݢيلڤ",
  "block.minecraft.polished_blackstone_brick_wall": "تيمبوق بات باتو هيتم دݢيلڤ",
  "block.minecraft.polished_blackstone_bricks": "بات باتو هيتم دݢيلڤ",
  "block.minecraft.polished_blackstone_button": "بوتڠ باتو هيتم دݢيلڤ",
  "block.minecraft.polished_blackstone_pressure_plate": "ڤلت تکنن باتو هيتم دݢيلڤ",
  "block.minecraft.polished_blackstone_slab": "ڤاڤق باتو هيتم دݢيلڤ",
  "block.minecraft.polished_blackstone_stairs": "تڠݢ باتو هيتم دݢيلڤ",
  "block.minecraft.polished_blackstone_wall": "تيمبوق باتو هيتم دݢيلڤ",
  "block.minecraft.polished_deepslate": "باتو لوه دݢيلڤ",
  "block.minecraft.polished_deepslate_slab": "ڤاڤق باتو لوه دݢيلڤ",
  "block.minecraft.polished_deepslate_stairs": "تڠݢ باتو لوه دݢيلڤ",
  "block.minecraft.polished_deepslate_wall": "تيمبوق باتو لوه دݢيلڤ",
  "block.minecraft.polished_diorite": "ديوريت دݢيلڤ",
  "block.minecraft.polished_diorite_slab": "ڤاڤق ديوريت دݢيلڤ",
  "block.minecraft.polished_diorite_stairs": "تڠݢ ديوريت دݢيلڤ",
  "block.minecraft.polished_granite": "ݢرانيت دݢيلڤ",
  "block.minecraft.polished_granite_slab": "ڤاڤق ݢرانيت دݢيلڤ",
  "block.minecraft.polished_granite_stairs": "تڠݢ ݢرانيت دݢيلڤ",
  "block.minecraft.polished_tuff": "توف دݢيلڤ",
  "block.minecraft.polished_tuff_slab": "ڤاڤق توف دݢيلڤ",
  "block.minecraft.polished_tuff_stairs": "تڠݢ توف دݢيلڤ",
  "block.minecraft.polished_tuff_wall": "تيمبوق توف دݢيلڤ",
  "block.minecraft.poppy": "ڤوڤي",
  "block.minecraft.potatoes": "کنتڠ",
  "block.minecraft.potted_acacia_sapling": "انق ڤوکوق اکاسيا برڤاسو",
  "block.minecraft.potted_allium": "اليوم برڤاسو",
  "block.minecraft.potted_azalea_bush": "ازاليا برڤاسو",
  "block.minecraft.potted_azure_bluet": "ايزور بلوٴيت برڤاسو",
  "block.minecraft.potted_bamboo": "بولوه برڤاسو",
  "block.minecraft.potted_birch_sapling": "انق ڤوکوق برچ برڤاسو",
  "block.minecraft.potted_blue_orchid": "اورکيد بيرو برڤاسو",
  "block.minecraft.potted_brown_mushroom": "چنداون ڤيرڠ برڤاسو",
  "block.minecraft.potted_cactus": "ککتوس برڤاسو",
  "block.minecraft.potted_cherry_sapling": "انق ڤوکوق ساکورا برڤاسو",
  "block.minecraft.potted_closed_eyeblossom": "ڤوسڤا مات ترتوتوڤ برڤاسو",
  "block.minecraft.potted_cornflower": "کورنفلاور برڤاسو",
  "block.minecraft.potted_crimson_fungus": "کولت کيرميزي برڤاسو",
  "block.minecraft.potted_crimson_roots": "اکر کيرميزي برڤاسو",
  "block.minecraft.potted_dandelion": "بوڠا ڤليمن برڤاسو",
  "block.minecraft.potted_dark_oak_sapling": "انق ڤوکوق اوک ݢلڤ برڤاسو",
  "block.minecraft.potted_dead_bush": "سمق ماتي برڤاسو",
  "block.minecraft.potted_fern": "ڤاکو ڤاکيس برڤاسو",
  "block.minecraft.potted_flowering_azalea_bush": "ازاليا برمکر برڤاسو",
  "block.minecraft.potted_golden_dandelion": "بوڠا ڤليمن امس برڤاسو",
  "block.minecraft.potted_jungle_sapling": "انق ڤوکوق ريمبا برڤاسو",
  "block.minecraft.potted_lily_of_the_valley": "باکوڠ لمبه برڤاسو",
  "block.minecraft.potted_mangrove_propagule": "ڤروڤاݢول باکاو برڤاسو",
  "block.minecraft.potted_oak_sapling": "انق ڤوکوق اوک برڤاسو",
  "block.minecraft.potted_open_eyeblossom": "ڤوسڤا مات تربوک برڤاسو",
  "block.minecraft.potted_orange_tulip": "توليڤ جيڠݢ برڤاسو",
  "block.minecraft.potted_oxeye_daisy": "داٴيسي اوکساي برڤاسو",
  "block.minecraft.potted_pale_oak_sapling": "انق ڤوکوق اوک کمسي برڤاسو",
  "block.minecraft.potted_pink_tulip": "توليڤ ميره جمبو برڤاسو",
  "block.minecraft.potted_poppy": "ڤوڤي برڤاسو",
  "block.minecraft.potted_red_mushroom": "چنداون ميره برڤاسو",
  "block.minecraft.potted_red_tulip": "توليڤ ميره برڤاسو",
  "block.minecraft.potted_spruce_sapling": "انق ڤوکوق چمارا برڤاسو",
  "block.minecraft.potted_torchflower": "بوڠا کنتن برڤاسو",
  "block.minecraft.potted_warped_fungus": "کولت ݢيلا برڤاسو",
  "block.minecraft.potted_warped_roots": "اکر ݢيلا برڤاسو",
  "block.minecraft.potted_white_tulip": "توليڤ ڤوتيه برڤاسو",
  "block.minecraft.potted_wither_rose": "ماور ويذر برڤاسو",
  "block.minecraft.powder_snow": "سلجي سربوق",
  "block.minecraft.powder_snow_cauldron": "کاوه برايسي سلجي سربوق",
  "block.minecraft.powered_rail": "لندسن برکواس",
  "block.minecraft.prismarine": "ڤريسمارين",
  "block.minecraft.prismarine_brick_slab": "ڤاڤق بات ڤريسمارين",
  "block.minecraft.prismarine_brick_stairs": "تڠݢ بات ڤريسمارين",
  "block.minecraft.prismarine_bricks": "بات ڤريسمارين",
  "block.minecraft.prismarine_slab": "ڤاڤق ڤريسمارين",
  "block.minecraft.prismarine_stairs": "تڠݢ ڤريسمارين",
  "block.minecraft.prismarine_wall": "تيمبوق ڤريسمارين",
  "block.minecraft.pumpkin": "لابو",
  "block.minecraft.pumpkin_stem": "باتڠ لابو",
  "block.minecraft.purple_banner": "ڤنجي اوڠو",
  "block.minecraft.purple_bed": "کاتيل اوڠو",
  "block.minecraft.purple_candle": "ديان اوڠو",
  "block.minecraft.purple_candle_cake": "کيک برديان اوڠو",
  "block.minecraft.purple_carpet": "ڤرماٴيداني اوڠو",
  "block.minecraft.purple_concrete": "کونکريت اوڠو",
  "block.minecraft.purple_concrete_powder": "سربوق کونکريت اوڠو",
  "block.minecraft.purple_glazed_terracotta": "تيراکوتا ليچاو اوڠو",
  "block.minecraft.purple_shulker_box": "کوتق شلکر اوڠو",
  "block.minecraft.purple_stained_glass": "کاچ برورنا اوڠو",
  "block.minecraft.purple_stained_glass_pane": "انق کاچ برورنا اوڠو",
  "block.minecraft.purple_terracotta": "تيراکوتا اوڠو",
  "block.minecraft.purple_wool": "بولو اوڠو",
  "block.minecraft.purpur_block": "بلوک ڤرڤر",
  "block.minecraft.purpur_pillar": "توڠݢق ڤرڤر",
  "block.minecraft.purpur_slab": "ڤاڤق ڤرڤر",
  "block.minecraft.purpur_stairs": "تڠݢ ڤرڤر",
  "block.minecraft.quartz_block": "بلوک کوارزا",
  "block.minecraft.quartz_bricks": "بات کوارزا",
  "block.minecraft.quartz_pillar": "توڠݢق کوارزا",
  "block.minecraft.quartz_slab": "ڤاڤق کوارزا",
  "block.minecraft.quartz_stairs": "تڠݢ کوارزا",
  "block.minecraft.rail": "لندسن",
  "block.minecraft.raw_copper_block": "بلوک تمباݢ منته",
  "block.minecraft.raw_gold_block": "بلوک امس منته",
  "block.minecraft.raw_iron_block": "بلوک بسي منته",
  "block.minecraft.red_banner": "ڤنجي ميره",
  "block.minecraft.red_bed": "کاتيل ميره",
  "block.minecraft.red_candle": "ديان ميره",
  "block.minecraft.red_candle_cake": "کيک برديان ميره",
  "block.minecraft.red_carpet": "ڤرماٴيداني ميره",
  "block.minecraft.red_concrete": "کونکريت ميره",
  "block.minecraft.red_concrete_powder": "سربوق کونکريت ميره",
  "block.minecraft.red_glazed_terracotta": "تيراکوتا ليچاو ميره",
  "block.minecraft.red_mushroom": "چنداون ميره",
  "block.minecraft.red_mushroom_block": "بلوک چنداون ميره",
  "block.minecraft.red_nether_brick_slab": "ڤاڤق بات نيذر ميره",
  "block.minecraft.red_nether_brick_stairs": "تڠݢ بات نيذر ميره",
  "block.minecraft.red_nether_brick_wall": "تيمبوق بات نيذر ميره",
  "block.minecraft.red_nether_bricks": "بات ميره نيذر",
  "block.minecraft.red_sand": "ڤاسير ميره",
  "block.minecraft.red_sandstone": "باتو ڤاسير ميره",
  "block.minecraft.red_sandstone_slab": "ڤاڤق باتو ڤاسير ميره",
  "block.minecraft.red_sandstone_stairs": "تڠݢ باتو ڤاسير ميره",
  "block.minecraft.red_sandstone_wall": "تيمبوق باتو ڤاسير ميره",
  "block.minecraft.red_shulker_box": "کوتق شلکر ميره",
  "block.minecraft.red_stained_glass": "کاچ برورنا ميره",
  "block.minecraft.red_stained_glass_pane": "انق کاچ برورنا ميره",
  "block.minecraft.red_terracotta": "تيراکوتا ميره",
  "block.minecraft.red_tulip": "توليڤ ميره",
  "block.minecraft.red_wool": "بولو ميره",
  "block.minecraft.redstone_block": "بلوک ريدستون",
  "block.minecraft.redstone_lamp": "لمڤو ريدستون",
  "block.minecraft.redstone_ore": "بيجيه ريدستون",
  "block.minecraft.redstone_torch": "اوبور ريدستون",
  "block.minecraft.redstone_wall_torch": "اوبور دينديڠ ريدستون",
  "block.minecraft.redstone_wire": "واير ريدستون",
  "block.minecraft.reinforced_deepslate": "باتو لوه برتتولڠ",
  "block.minecraft.repeater": "ڤڠولڠ ريدستون",
  "block.minecraft.repeating_command_block": "بلوک ڤرينته براولڠ",
  "block.minecraft.resin_block": "بلوک دامر",
  "block.minecraft.resin_brick_slab": "ڤاڤق بات دامر",
  "block.minecraft.resin_brick_stairs": "تڠݢ بات دامر",
  "block.minecraft.resin_brick_wall": "تيمبوق بات دامر",
  "block.minecraft.resin_bricks": "بات دامر",
  "block.minecraft.resin_clump": "کتولن دامر",
  "block.minecraft.respawn_anchor": "ڤنمبت ڤنجلماٴن",
  "block.minecraft.rooted_dirt": "تانه براکر",
  "block.minecraft.rose_bush": "ڤوهون ماور",
  "block.minecraft.sand": "ڤاسير",
  "block.minecraft.sandstone": "باتو ڤاسير",
  "block.minecraft.sandstone_slab": "ڤاڤق باتو ڤاسير",
  "block.minecraft.sandstone_stairs": "تڠݢ باتو ڤاسير",
  "block.minecraft.sandstone_wall": "تيمبوق باتو ڤاسير",
  "block.minecraft.scaffolding": "ڤرانچه",
  "block.minecraft.sculk": "سکل‌ک",
  "block.minecraft.sculk_catalyst": "مڠکين سکل‌ک",
  "block.minecraft.sculk_sensor": "ڤندريا سکل‌ک",
  "block.minecraft.sculk_shrieker": "ڤنرياق سکل‌ک",
  "block.minecraft.sculk_vein": "اورت سکل‌ک",
  "block.minecraft.sea_lantern": "تڠلوڠ لاٴوت",
  "block.minecraft.sea_pickle": "جروق لاٴوت",
  "block.minecraft.seagrass": "رومڤوت لاٴوت",
  "block.minecraft.set_spawn": "تمڤت جلما سمولا دتتڤکن",
  "block.minecraft.short_dry_grass": "رومڤوت کريڠ ڤينديق",
  "block.minecraft.short_grass": "رومڤوت ڤينديق",
  "block.minecraft.shroomlight": "لمڤو چنداون",
  "block.minecraft.shulker_box": "کوتق شلکر",
  "block.minecraft.skeleton_skull": "تڠکورق کرڠک",
  "block.minecraft.skeleton_wall_skull": "تڠکورق دينديڠ کرڠک",
  "block.minecraft.slime_block": "بلوک لندير",
  "block.minecraft.small_amethyst_bud": "تونس باتو کچوبوڠ کچيل",
  "block.minecraft.small_dripleaf": "داٴون تيتيس کچيل",
  "block.minecraft.smithing_table": "ڤرتوکڠن بسي",
  "block.minecraft.smoker": "ڤڽالاي",
  "block.minecraft.smooth_basalt": "بسل‌ت ليچين",
  "block.minecraft.smooth_quartz": "بلوک کوارزا ليچين",
  "block.minecraft.smooth_quartz_slab": "ڤاڤق کوارزا ليچين",
  "block.minecraft.smooth_quartz_stairs": "تڠݢ کوارزا ليچين",
  "block.minecraft.smooth_red_sandstone": "باتو ڤاسير ميره ليچين",
  "block.minecraft.smooth_red_sandstone_slab": "ڤاڤق باتو ڤاسير ميره ليچين",
  "block.minecraft.smooth_red_sandstone_stairs": "تڠݢ باتو ڤاسير ميره ليچين",
  "block.minecraft.smooth_sandstone": "باتو ڤاسير ليچين",
  "block.minecraft.smooth_sandstone_slab": "ڤاڤق باتو ڤاسير ليچين",
  "block.minecraft.smooth_sandstone_stairs": "تڠݢ باتو ڤاسير ليچين",
  "block.minecraft.smooth_stone": "باتو ليچين",
  "block.minecraft.smooth_stone_slab": "ڤاڤق باتو ليچين",
  "block.minecraft.sniffer_egg": "تلور ڤڠهيدو",
  "block.minecraft.snow": "ثلجي",
  "block.minecraft.snow_block": "بلوک ثلجي",
  "block.minecraft.soul_campfire": "اوڠݢون اڤي روح",
  "block.minecraft.soul_fire": "اڤي روح",
  "block.minecraft.soul_lantern": "تڠلوڠ روح",
  "block.minecraft.soul_sand": "ڤاسير روح",
  "block.minecraft.soul_soil": "تانه روح",
  "block.minecraft.soul_torch": "اوبور روح",
  "block.minecraft.soul_wall_torch": "اوبور دينديڠ روح",
  "block.minecraft.spawn.not_valid": "اندا تيدق مموڽاٴي کاتيل اتاو ڤنمبت ڤنجلماٴين يڠ دچس اتاو کاتيل ترسبوت ترهالڠ",
  "block.minecraft.spawner": "ڤنجلما رقساس",
  "block.minecraft.spawner.desc1": "اينترکسي دڠن تلور ڤنجلماٴن:",
  "block.minecraft.spawner.desc2": "تتڤکن جنيس مخلوق",
  "block.minecraft.sponge": "سڤن",
  "block.minecraft.spore_blossom": "بوڠا سڤورا",
  "block.minecraft.spruce_button": "بوتڠ چمارا",
  "block.minecraft.spruce_door": "ڤينتو کايو چمارا",
  "block.minecraft.spruce_fence": "ڤاݢر چمارا",
  "block.minecraft.spruce_fence_gate": "ڤينتو ڤاݢر چمارا",
  "block.minecraft.spruce_hanging_sign": "ڤاڤن تندا برݢنتوڠ چمارا",
  "block.minecraft.spruce_leaves": "داٴون چمارا",
  "block.minecraft.spruce_log": "کايو بالق چمارا",
  "block.minecraft.spruce_planks": "ڤاڤن کايو چمارا",
  "block.minecraft.spruce_pressure_plate": "ڤلت تکنن چمارا",
  "block.minecraft.spruce_sapling": "انق ڤوکوق چمارا",
  "block.minecraft.spruce_shelf": "رق چمارا",
  "block.minecraft.spruce_sign": "ڤاڤن تندا چمارا",
  "block.minecraft.spruce_slab": "ڤاڤق چمارا",
  "block.minecraft.spruce_stairs": "تڠݢ چمارا",
  "block.minecraft.spruce_trapdoor": "ڤينتو کولوڠ چمارا",
  "block.minecraft.spruce_wall_hanging_sign": "ڤاڤن تندا دينديڠ برݢنتوڠ چمارا",
  "block.minecraft.spruce_wall_sign": "ڤاڤن تندا دينديڠ چمارا",
  "block.minecraft.spruce_wood": "کايو چمارا",
  "block.minecraft.sticky_piston": "اومبوه ملکيت",
  "block.minecraft.stone": "باتو",
  "block.minecraft.stone_brick_slab": "ڤاڤق باتو بات",
  "block.minecraft.stone_brick_stairs": "تڠݢ باتو بات",
  "block.minecraft.stone_brick_wall": "تيمبوق بات باتو",
  "block.minecraft.stone_bricks": "بات باتو",
  "block.minecraft.stone_button": "بوتڠ باتو",
  "block.minecraft.stone_pressure_plate": "ڤلت تکنن باتو",
  "block.minecraft.stone_slab": "ڤاڤق باتو",
  "block.minecraft.stone_stairs": "تڠݢ باتو",
  "block.minecraft.stonecutter": "ڤموتوڠ باتو",
  "block.minecraft.stripped_acacia_log": "کايو بالق اکاسيا ترکوڤس کوليت",
  "block.minecraft.stripped_acacia_wood": "کايو اکاسيا ترکوڤس کوليت",
  "block.minecraft.stripped_bamboo_block": "بلوک بولوه ترکوڤس کوليت",
  "block.minecraft.stripped_birch_log": "کايو بالق برچ ترکوڤس کوليت",
  "block.minecraft.stripped_birch_wood": "کايو برچ ترکوڤس کوليت",
  "block.minecraft.stripped_cherry_log": "کايو بالق ساکورا تىرکوڤس کوليت",
  "block.minecraft.stripped_cherry_wood": "کايو ساکورا ترکوڤس کوليت",
  "block.minecraft.stripped_crimson_hyphae": "هيفا کيرميزي دکوڤس کوليت",
  "block.minecraft.stripped_crimson_stem": "باتڠ کيرميزي ترکوڤس کوليت",
  "block.minecraft.stripped_dark_oak_log": "کايو بالق اوک ݢلڤ ترکوڤس کوليت",
  "block.minecraft.stripped_dark_oak_wood": "کايو اوک ݢلڤ ترکوڤس کوليت",
  "block.minecraft.stripped_jungle_log": "کايو بالق ريمبا ترکوڤس کوليت",
  "block.minecraft.stripped_jungle_wood": "کايو ريمبا ترکوڤس کوليت",
  "block.minecraft.stripped_mangrove_log": "کايو بالق باکاو ترکوڤس کوليت",
  "block.minecraft.stripped_mangrove_wood": "کايو باکاو ترکوڤس کوليت",
  "block.minecraft.stripped_oak_log": "کايو بالق اوک ترکوڤس کوليت",
  "block.minecraft.stripped_oak_wood": "کايو اوک ترکوڤس کوليت",
  "block.minecraft.stripped_pale_oak_log": "کايو بالق اوک کمسي ترکوڤس کوليت",
  "block.minecraft.stripped_pale_oak_wood": "کايو اوک کمسي ترکوڤس کوليت",
  "block.minecraft.stripped_spruce_log": "کايو بالق چمارا ترکوڤس کوليت",
  "block.minecraft.stripped_spruce_wood": "کايو چمارا ترکوڤس کوليت",
  "block.minecraft.stripped_warped_hyphae": "هيفا ترلديڠ دکوڤس کوليت",
  "block.minecraft.stripped_warped_stem": "باتڠ ݢيلا ترکوڤس کوليت",
  "block.minecraft.structure_block": "بلوک ستروکتور",
  "block.minecraft.structure_void": "ستروکتور ککوسوڠن",
  "block.minecraft.sugar_cane": "تبو",
  "block.minecraft.sunflower": "بوڠا ماتاهاري",
  "block.minecraft.suspicious_gravel": "باتو کليکير منچوريݢاکن",
  "block.minecraft.suspicious_sand": "ڤاسير منچوريݢاکن",
  "block.minecraft.sweet_berry_bush": "ڤوهون بيري مانيس",
  "block.minecraft.tall_dry_grass": "رومڤوت کريڠ ڤنجڠ",
  "block.minecraft.tall_grass": "رومڤوت ڤنجڠ",
  "block.minecraft.tall_seagrass": "رومڤوت لاٴوت تيڠݢي",
  "block.minecraft.target": "ساسرن",
  "block.minecraft.terracotta": "تيراکوتا",
  "block.minecraft.test_block": "بلوک اوجين",
  "block.minecraft.test_instance_block": "بلوک تيک اوجين",
  "block.minecraft.tinted_glass": "چرمين ݢلڤ",
  "block.minecraft.tnt": "تي.عين.تي.",
  "block.minecraft.tnt.disabled": "لتوڤن تي.عين.تي. دڽهداياکن",
  "block.minecraft.torch": "اوبور",
  "block.minecraft.torchflower": "بوڠا کنتن",
  "block.minecraft.torchflower_crop": "تانمن بوڠا کنتن",
  "block.minecraft.trapped_chest": "ڤتي ڤرڠکڤ",
  "block.minecraft.trial_spawner": "ڤنجلما اوجين",
  "block.minecraft.tripwire": "تالي بلانتيق",
  "block.minecraft.tripwire_hook": "ڤڽڠکوق تالي بلانتيق",
  "block.minecraft.tube_coral": "کارڠ تيوب",
  "block.minecraft.tube_coral_block": "بلوک کارڠ تيوب",
  "block.minecraft.tube_coral_fan": "اکر باهر تيوب",
  "block.minecraft.tube_coral_wall_fan": "اکر باهر دينديڠ تيوب",
  "block.minecraft.tuff": "توف",
  "block.minecraft.tuff_brick_slab": "ڤاڤق بات توف",
  "block.minecraft.tuff_brick_stairs": "تڠݢ بات توف",
  "block.minecraft.tuff_brick_wall": "تيمبوق بات توف",
  "block.minecraft.tuff_bricks": "بات توف",
  "block.minecraft.tuff_slab": "ڤاڤق توف",
  "block.minecraft.tuff_stairs": "تڠݢ توف",
  "block.minecraft.tuff_wall": "تيمبوق توف",
  "block.minecraft.turtle_egg": "تلور ڤڽو",
  "block.minecraft.twisting_vines": "ڤنجالر ممولس",
  "block.minecraft.twisting_vines_plant": "ڤوکوق ڤنجالر ممولس",
  "block.minecraft.vault": "ڤتي کبل",
  "block.minecraft.verdant_froglight": "لمڤو کاتق کهيجاوان",
  "block.minecraft.vine": "ڤنجالر",
  "block.minecraft.void_air": "اودارا ککوسوڠن",
  "block.minecraft.wall_torch": "اوبور دينديڠ",
  "block.minecraft.warped_button": "بوتڠ ݢيلا",
  "block.minecraft.warped_door": "ڤينتو ݢيلا",
  "block.minecraft.warped_fence": "ڤاݢر ݢيلا",
  "block.minecraft.warped_fence_gate": "ڤينتو ڤاݢر ݢيلا",
  "block.minecraft.warped_fungus": "کولت ݢيلا",
  "block.minecraft.warped_hanging_sign": "ڤاڤن تندا برݢنتوڠ ݢيلا",
  "block.minecraft.warped_hyphae": "هيفا ترلديڠ",
  "block.minecraft.warped_nylium": "نيليوم ݢيلا",
  "block.minecraft.warped_planks": "ڤاڤن ݢيلا",
  "block.minecraft.warped_pressure_plate": "ڤلت تکنن ݢيلا",
  "block.minecraft.warped_roots": "اکر ݢيلا",
  "block.minecraft.warped_shelf": "رق ݢيلا",
  "block.minecraft.warped_sign": "ڤاڤن تندا ݢيلا",
  "block.minecraft.warped_slab": "ڤاڤق ݢيلا",
  "block.minecraft.warped_stairs": "تڠݢ ݢيلا",
  "block.minecraft.warped_stem": "باتڠ ݢيلا",
  "block.minecraft.warped_trapdoor": "ڤينتو کولوڠ ݢيلا",
  "block.minecraft.warped_wall_hanging_sign": "ڤاڤن تندا دينديڠ برݢنتوڠ ݢيلا",
  "block.minecraft.warped_wall_sign": "ڤاڤن تندا دينديڠ ݢيلا",
  "block.minecraft.warped_wart_block": "بلوک کتوات ݢيلا",
  "block.minecraft.water": "اٴير",
  "block.minecraft.water_cauldron": "کاوه اٴير",
  "block.minecraft.waxed_chiseled_copper": "تمباݢ ترڤاهت برليلين",
  "block.minecraft.waxed_copper_bars": "ڤالڠ تمباݢ برليلين",
  "block.minecraft.waxed_copper_block": "بلوک تمباݢ برليلين",
  "block.minecraft.waxed_copper_bulb": "مينتول تمباݢ برليلين",
  "block.minecraft.waxed_copper_chain": "رنتاي تمباݢ برليلين",
  "block.minecraft.waxed_copper_chest": "ڤتي تمباݢ برليلين",
  "block.minecraft.waxed_copper_door": "ڤينتو تمباݢ برليلين",
  "block.minecraft.waxed_copper_golem_statue": "ڤاتوڠ ݢولم تمباݢ برليلين",
  "block.minecraft.waxed_copper_grate": "جريجي تمباݢ برليلين",
  "block.minecraft.waxed_copper_lantern": "تڠلوڠ تمباݢ برليلين",
  "block.minecraft.waxed_copper_trapdoor": "ڤينتو کولوڠ تمباݢ برليلين",
  "block.minecraft.waxed_cut_copper": "تمباݢ ترڤوتوڠ برليلين",
  "block.minecraft.waxed_cut_copper_slab": "ڤاڤق تمباݢ ترڤوتوڠ برليلين",
  "block.minecraft.waxed_cut_copper_stairs": "تڠݢ تمباݢ ترڤوتوڠ برليلين",
  "block.minecraft.waxed_exposed_chiseled_copper": "تمباݢ ترڤاهت تردده برليلين",
  "block.minecraft.waxed_exposed_copper": "تمباݢ تردده برليلين",
  "block.minecraft.waxed_exposed_copper_bars": "ڤالڠ تمباݢ تردده برليلين",
  "block.minecraft.waxed_exposed_copper_bulb": "مينتول تمباݢ تردده برليلين",
  "block.minecraft.waxed_exposed_copper_chain": "رنتاي تمباݢ تردده برليلين",
  "block.minecraft.waxed_exposed_copper_chest": "ڤتي تمباݢ تردده برليلين",
  "block.minecraft.waxed_exposed_copper_door": "ڤينتو تمباݢ تردده برليلين",
  "block.minecraft.waxed_exposed_copper_golem_statue": "ڤاتوڠ ݢولم تمباݢ تردده برليلين",
  "block.minecraft.waxed_exposed_copper_grate": "جريجي تمباݢ تردده برليلين",
  "block.minecraft.waxed_exposed_copper_lantern": "تڠلوڠ تمباݢ تردده برليلين",
  "block.minecraft.waxed_exposed_copper_trapdoor": "ڤينتو کولوڠ تمباݢ تردده برليلين",
  "block.minecraft.waxed_exposed_cut_copper": "تمباݢ ترڤوتوڠ تردده برليلين",
  "block.minecraft.waxed_exposed_cut_copper_slab": "ڤاڤق تمباݢ ترڤوتوڠ تردده برليلين",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "تمباݢ ترڤوتوڠ تردده برليلين",
  "block.minecraft.waxed_exposed_lightning_rod": "ڤڠالير کيلت تردده برليلين",
  "block.minecraft.waxed_lightning_rod": "ڤڠالير کيلت برليلين",
  "block.minecraft.waxed_oxidized_chiseled_copper": "تمباݢ ترڤاهت ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_copper": "تمباݢ ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_copper_bars": "ڤالڠ تمباݢ ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_copper_bulb": "مينتول تمباݢ ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_copper_chain": "رنتاي تمباݢ ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_copper_chest": "ڤتي تمباݢ ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_copper_door": "ڤينتو تمباݢ ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "ڤاتوڠ ݢولم تمباݢ ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_copper_grate": "جريجي تمباݢ ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_copper_lantern": "تڠلوڠ تمباݢ ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "ڤينتو کولوڠ تمباݢ ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_cut_copper": "تمباݢ ترڤوتوڠ ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "ڤاڤق تمباݢ ترڤوتوڠ ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "تڠݢ تمباݢ ترڤوتوڠ ترأوکسيدا برليلين",
  "block.minecraft.waxed_oxidized_lightning_rod": "ڤڠالير کيلت ترأوکسيدا برليلين",
  "block.minecraft.waxed_weathered_chiseled_copper": "تمباݢ ترڤاهت ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_copper": "تمباݢ ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_copper_bars": "ڤالڠ تمباݢ ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_copper_bulb": "مينتول تمباݢ ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_copper_chain": "رنتاي تمباݢ ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_copper_chest": "ڤتي تمباݢ ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_copper_door": "ڤينتو تمباݢ ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_copper_golem_statue": "ڤاتوڠ ݢولم تمباݢ ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_copper_grate": "جريجي تمباݢ ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_copper_lantern": "تڠلوڠ تمباݢ ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_copper_trapdoor": "ڤينتو کولوڠ تمباݢ ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_cut_copper": "تمباݢ ترڤوتوڠ ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_cut_copper_slab": "ڤاڤق تمباݢ ترڤوتوڠ ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "تڠݢ تمباݢ ترڤوتوڠ ترلولوهاوا برليلين",
  "block.minecraft.waxed_weathered_lightning_rod": "ڤڠالير کيلت ترلولوهاوا برليلين",
  "block.minecraft.weathered_chiseled_copper": "تمباݢ ترڤاهت ترلولوهاوا",
  "block.minecraft.weathered_copper": "تمباݢ ترلولوهاوا",
  "block.minecraft.weathered_copper_bars": "ڤالڠ تمباݢ ترلولوهاوا",
  "block.minecraft.weathered_copper_bulb": "مينتول تمباݢ ترلولوهاوا",
  "block.minecraft.weathered_copper_chain": "رنتاي تمباݢ ترلولوهاوا",
  "block.minecraft.weathered_copper_chest": "ڤتي تمباݢ ترلولوهاوا",
  "block.minecraft.weathered_copper_door": "ڤينتو تمباݢ ترلولوهاوا",
  "block.minecraft.weathered_copper_golem_statue": "ڤاتوڠ ݢولم تمباݢ ترلولوهاوا",
  "block.minecraft.weathered_copper_grate": "جريجي تمباݢ ترلولوهاوا",
  "block.minecraft.weathered_copper_lantern": "تڠلوڠ تمباݢ ترلولوهاوا",
  "block.minecraft.weathered_copper_trapdoor": "ڤينتو کولوڠ تمباݢ ترلولوهاوا",
  "block.minecraft.weathered_cut_copper": "تمباݢ ترڤوتوڠ ترلولوهاوا",
  "block.minecraft.weathered_cut_copper_slab": "ڤاڤق تمباݢ ترڤوتوڠ ترلولوهاوا",
  "block.minecraft.weathered_cut_copper_stairs": "تڠݢ تمباݢ ترڤوتوڠ ترلولوهاوا",
  "block.minecraft.weathered_lightning_rod": "ڤڠالير کيلت ترلولوهاوا",
  "block.minecraft.weeping_vines": "ڤنجالر منجولاي",
  "block.minecraft.weeping_vines_plant": "ڤوکوق ڤنجالر منجولاي",
  "block.minecraft.wet_sponge": "سڤن باسه",
  "block.minecraft.wheat": "تانمن ݢندوم",
  "block.minecraft.white_banner": "ڤنجي ڤوتيه",
  "block.minecraft.white_bed": "کاتيل ڤوتيه",
  "block.minecraft.white_candle": "ديان ڤوتيه",
  "block.minecraft.white_candle_cake": "کيک برديان ڤوتيه",
  "block.minecraft.white_carpet": "ڤرماٴيداني ڤوتيه",
  "block.minecraft.white_concrete": "کونکريت ڤوتيه",
  "block.minecraft.white_concrete_powder": "سربوق کونکريت ڤوتيه",
  "block.minecraft.white_glazed_terracotta": "تيراکوتا ليچاو ڤوتيه",
  "block.minecraft.white_shulker_box": "کوتق شلکر ڤوتيه",
  "block.minecraft.white_stained_glass": "کاچ برورنا ڤوتيه",
  "block.minecraft.white_stained_glass_pane": "انق کاچ برورنا ڤوتيه",
  "block.minecraft.white_terracotta": "تيراکوتا ڤوتيه",
  "block.minecraft.white_tulip": "توليڤ ڤوتيه",
  "block.minecraft.white_wool": "بولو ڤوتيه",
  "block.minecraft.wildflowers": "بوڠا ليار",
  "block.minecraft.wither_rose": "ماور ويذر",
  "block.minecraft.wither_skeleton_skull": "تڠکورق کرڠک ويذر",
  "block.minecraft.wither_skeleton_wall_skull": "تڠکورق دينديڠ کرڠک ويذر",
  "block.minecraft.yellow_banner": "ڤنجي کونيڠ",
  "block.minecraft.yellow_bed": "کاتيل کونيڠ",
  "block.minecraft.yellow_candle": "ديان کونيڠ",
  "block.minecraft.yellow_candle_cake": "کيک برديان کونيڠ",
  "block.minecraft.yellow_carpet": "ڤرماٴيداني کونيڠ",
  "block.minecraft.yellow_concrete": "کونکريت کونيڠ",
  "block.minecraft.yellow_concrete_powder": "سربوق کونکريت کونيڠ",
  "block.minecraft.yellow_glazed_terracotta": "تيراکوتا ليچاو کونيڠ",
  "block.minecraft.yellow_shulker_box": "کوتق شلکر کونيڠ",
  "block.minecraft.yellow_stained_glass": "کاچ برورنا کونيڠ",
  "block.minecraft.yellow_stained_glass_pane": "انق کاچ برورنا کونيڠ",
  "block.minecraft.yellow_terracotta": "تيراکوتا کونيڠ",
  "block.minecraft.yellow_wool": "بولو کونيڠ",
  "block.minecraft.zombie_head": "کڤالا زومبي",
  "block.minecraft.zombie_wall_head": "کڤالا دينديڠ زومبي",
  "item.minecraft.acacia_boat": "سمڤن اکاسيا",
  "item.minecraft.acacia_chest_boat": "سمڤن اکاسيا دڠن ڤتي",
  "item.minecraft.allay_spawn_egg": "تلور ڤنجلماٴن ڤڤاري",
  "item.minecraft.amethyst_shard": "بليڠ باتو کچوبوڠ",
  "item.minecraft.angler_pottery_shard": "بليڠ تمبيکر ڤڠاٴيل",
  "item.minecraft.angler_pottery_sherd": "بليڠ تمبيکر ڤڠاٴيل",
  "item.minecraft.apple": "ايڤل",
  "item.minecraft.archer_pottery_shard": "بليڠ تمبيکر ڤمانه",
  "item.minecraft.archer_pottery_sherd": "بليڠ تمبيکر ڤمانه",
  "item.minecraft.armadillo_scute": "سکوت تڠݢيليڠ",
  "item.minecraft.armadillo_spawn_egg": "تلور ڤنجلماٴن تڠݢيليڠ",
  "item.minecraft.armor_stand": "ڤمڤامير زيره",
  "item.minecraft.arms_up_pottery_shard": "بليڠ تمبيکر اڠکت تاڠن",
  "item.minecraft.arms_up_pottery_sherd": "بليڠ تمبيکر اڠکت تاڠن",
  "item.minecraft.arrow": "انق ڤانه",
  "item.minecraft.axolotl_bucket": "بلدي اکزولوتل",
  "item.minecraft.axolotl_spawn_egg": "تلور ڤنجلماٴن اکزولوتل",
  "item.minecraft.baked_potato": "کنتڠ باکر",
  "item.minecraft.bamboo_chest_raft": "راکيت بولوه دڠن ڤتي",
  "item.minecraft.bamboo_raft": "راکيت بولوه",
  "item.minecraft.bat_spawn_egg": "تلور ڤنجلماٴن کلاور",
  "item.minecraft.bee_spawn_egg": "تلور ڤنجلماٴن لبه",
  "item.minecraft.beef": "داݢيڠ لمبو منته",
  "item.minecraft.beetroot": "اوبي بيت",
  "item.minecraft.beetroot_seeds": "بنيه اوبي بيت",
  "item.minecraft.beetroot_soup": "سوڤ اوبي بيت",
  "item.minecraft.birch_boat": "سمڤن برچ",
  "item.minecraft.birch_chest_boat": "سمڤن برچ دڠن ڤتي",
  "item.minecraft.black_bundle": "ݢوني هيتم",
  "item.minecraft.black_dye": "ڤورنا هيتم",
  "item.minecraft.black_harness": "سيلا هيتم",
  "item.minecraft.blade_pottery_shard": "بليڠ تمبيکر بيله",
  "item.minecraft.blade_pottery_sherd": "بليڠ تمبيکر بيله",
  "item.minecraft.blaze_powder": "سربوق کمامڠ",
  "item.minecraft.blaze_rod": "توڠکت کمامڠ",
  "item.minecraft.blaze_spawn_egg": "تلور ڤنجلماٴن کمامڠ",
  "item.minecraft.blue_bundle": "ݢوني بيرو",
  "item.minecraft.blue_dye": "ڤورنا بيرو",
  "item.minecraft.blue_egg": "تلور بيرو",
  "item.minecraft.blue_harness": "سيلا بيرو",
  "item.minecraft.bogged_spawn_egg": "تلور ڤنجلماٴن لوموتن",
  "item.minecraft.bolt_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "هياسن زيره سيلق",
  "item.minecraft.bone": "تولڠ",
  "item.minecraft.bone_meal": "سربوق تولڠ",
  "item.minecraft.book": "بوکو",
  "item.minecraft.bordure_indented_banner_pattern": "چورق ڤنجي بيڠکاي برݢريݢي",
  "item.minecraft.bow": "بوسور",
  "item.minecraft.bowl": "مڠکوق",
  "item.minecraft.bread": "روتي",
  "item.minecraft.breeze_rod": "توڠکت هاليمبوبو",
  "item.minecraft.breeze_spawn_egg": "تلور ڤنجلماٴن هاليمبوبو",
  "item.minecraft.brewer_pottery_shard": "بليڠ تمبيکر ڤرامو",
  "item.minecraft.brewer_pottery_sherd": "بليڠ تمبيکر ڤرامو",
  "item.minecraft.brewing_stand": "تاڤق ممبرو",
  "item.minecraft.brick": "بات",
  "item.minecraft.brown_bundle": "ݢوني ڤيرڠ",
  "item.minecraft.brown_dye": "ڤورنا ڤيرڠ",
  "item.minecraft.brown_egg": "تلور ڤيرڠ",
  "item.minecraft.brown_harness": "سيلا ڤيرڠ",
  "item.minecraft.brush": "بروس",
  "item.minecraft.bucket": "بلدي",
  "item.minecraft.bundle": "ݢوني",
  "item.minecraft.bundle.empty": "کوسوڠ",
  "item.minecraft.bundle.empty.description": "بوليه ممݢڠ ساتو تيمبونن اٴيتم يڠ برچمڤور",
  "item.minecraft.bundle.full": "ڤنوه",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "بليڠ تمبيکر باکر",
  "item.minecraft.burn_pottery_sherd": "بليڠ تمبيکر باکر",
  "item.minecraft.camel_husk_spawn_egg": "تلور ڤنجلماٴن اونتا رڤوتن",
  "item.minecraft.camel_spawn_egg": "تلور ڤنجلماٴن اونتا",
  "item.minecraft.carrot": "لوبق",
  "item.minecraft.carrot_on_a_stick": "لوبق ڤد کايو",
  "item.minecraft.cat_spawn_egg": "تلور ڤنجلماٴن کوچيڠ",
  "item.minecraft.cauldron": "کاوه",
  "item.minecraft.cave_spider_spawn_egg": "تلور ڤنجلماٴن للابه ݢوا",
  "item.minecraft.chainmail_boots": "بوت رنتاي",
  "item.minecraft.chainmail_chestplate": "زيره دادا رنتاي",
  "item.minecraft.chainmail_helmet": "کتوڤوڠ رنتاي",
  "item.minecraft.chainmail_leggings": "زيره کاکي رنتاي",
  "item.minecraft.charcoal": "ارڠ",
  "item.minecraft.cherry_boat": "سمڤن ساکورا",
  "item.minecraft.cherry_chest_boat": "سمڤن ساکورا دڠن ڤتي",
  "item.minecraft.chest_minecart": "کريتا لومبوڠ دڠن ڤتي",
  "item.minecraft.chicken": "ايم منته",
  "item.minecraft.chicken_spawn_egg": "تلور ڤنجلماٴن ايم",
  "item.minecraft.chorus_fruit": "بواه کوروس",
  "item.minecraft.clay_ball": "ببولا تانه ليات",
  "item.minecraft.clock": "جم",
  "item.minecraft.coal": "ارڠ باتو",
  "item.minecraft.coast_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.coast_armor_trim_smithing_template.new": "هياسن زيره سيسير",
  "item.minecraft.cocoa_beans": "بيجي کوکو",
  "item.minecraft.cod": "کود منته",
  "item.minecraft.cod_bucket": "بلدي ايکن کود",
  "item.minecraft.cod_spawn_egg": "تلور ڤنجلماٴن کود",
  "item.minecraft.command_block_minecart": "کريتا لومبوڠ دڠن بلوک ڤرينته",
  "item.minecraft.compass": "کومڤس",
  "item.minecraft.cooked_beef": "داݢيڠ لمبو",
  "item.minecraft.cooked_chicken": "ايم ماسق",
  "item.minecraft.cooked_cod": "کود ماسق",
  "item.minecraft.cooked_mutton": "داݢيڠ بيري٢ ماسق",
  "item.minecraft.cooked_porkchop": "داݢيڠ خنزير ماسق",
  "item.minecraft.cooked_rabbit": "ارنب ماسق",
  "item.minecraft.cooked_salmon": "سلمون باکر",
  "item.minecraft.cookie": "بيسکوت",
  "item.minecraft.copper_axe": "کاڤق تمباݢ",
  "item.minecraft.copper_boots": "بوت تمباݢ",
  "item.minecraft.copper_chestplate": "زيره دادا تمباݢ",
  "item.minecraft.copper_golem_spawn_egg": "تلور ڤنجلماٴن ݢولم تمباݢ",
  "item.minecraft.copper_helmet": "کتوڤوڠ تمباݢ",
  "item.minecraft.copper_hoe": "چڠکول تمباݢ",
  "item.minecraft.copper_horse_armor": "زيره کودا تمباݢ",
  "item.minecraft.copper_ingot": "جوڠکوڠ تمباݢ",
  "item.minecraft.copper_leggings": "زيره کاکي تمباݢ",
  "item.minecraft.copper_nautilus_armor": "زيره ݢيڠݢيڠ تمباݢ",
  "item.minecraft.copper_nugget": "نوݢت تمباݢ",
  "item.minecraft.copper_pickaxe": "بليوڠ تمباݢ",
  "item.minecraft.copper_shovel": "ڤڽودوق تمباݢ",
  "item.minecraft.copper_spear": "تومبق تمباݢ",
  "item.minecraft.copper_sword": "ڤدڠ تمباݢ",
  "item.minecraft.cow_spawn_egg": "تلور ڤنجلماٴن لمبو",
  "item.minecraft.creaking_spawn_egg": "تلور ڤنجلماٴن دريتن",
  "item.minecraft.creeper_banner_pattern": "چورق ڤنجي",
  "item.minecraft.creeper_banner_pattern.desc": "لامبڠ کريڤر",
  "item.minecraft.creeper_banner_pattern.new": "چورق ڤنجي لامبڠ کريڤر",
  "item.minecraft.creeper_spawn_egg": "تلور ڤنجلماٴن کريڤر",
  "item.minecraft.crossbow": "بوسور سيلڠ",
  "item.minecraft.crossbow.projectile": "ڤلورو:",
  "item.minecraft.crossbow.projectile.multiple": "ڤلورو: %s x %s",
  "item.minecraft.crossbow.projectile.single": "ڤلورو: %s",
  "item.minecraft.cyan_bundle": "ݢوني سيان",
  "item.minecraft.cyan_dye": "ڤورنا سيان",
  "item.minecraft.cyan_harness": "سيلا سيان",
  "item.minecraft.danger_pottery_shard": "بليڠ تمبيکر بهاي",
  "item.minecraft.danger_pottery_sherd": "بليڠ تمبيکر بهاي",
  "item.minecraft.dark_oak_boat": "سمڤن اوک ݢلڤ",
  "item.minecraft.dark_oak_chest_boat": "سمڤن اوک ݢلڤ دڠن ڤتي",
  "item.minecraft.debug_stick": "باتڠ ڤڽهڤڤيجت",
  "item.minecraft.debug_stick.empty": "%s تيدق ممڤوڽاٴي صيفت",
  "item.minecraft.debug_stick.select": "تله مميليه \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" کڤد %s",
  "item.minecraft.diamond": "برليان",
  "item.minecraft.diamond_axe": "کاڤق برليان",
  "item.minecraft.diamond_boots": "بوت برليان",
  "item.minecraft.diamond_chestplate": "زيره دادا برليان",
  "item.minecraft.diamond_helmet": "کتوڤوڠ برليان",
  "item.minecraft.diamond_hoe": "چڠکول برليان",
  "item.minecraft.diamond_horse_armor": "زيره کودا برليان",
  "item.minecraft.diamond_leggings": "زيره کاکي برليان",
  "item.minecraft.diamond_nautilus_armor": "زيره ݢيڠݢيڠ برليان",
  "item.minecraft.diamond_pickaxe": "بليوڠ برليان",
  "item.minecraft.diamond_shovel": "ڤڽودوق برليان",
  "item.minecraft.diamond_spear": "تومبق برليان",
  "item.minecraft.diamond_sword": "ڤدڠ برليان",
  "item.minecraft.disc_fragment_5": "سرڤيهن چکرا",
  "item.minecraft.disc_fragment_5.desc": "چکرا موزيک - 5",
  "item.minecraft.dolphin_spawn_egg": "تلور ڤنجلماٴن دولفين",
  "item.minecraft.donkey_spawn_egg": "تلور ڤنجلماٴن کلداي",
  "item.minecraft.dragon_breath": "نفس ناݢ",
  "item.minecraft.dried_kelp": "کيل‌ڤ کريڠ",
  "item.minecraft.drowned_spawn_egg": "تلور ڤنجلماٴن لمسن",
  "item.minecraft.dune_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.dune_armor_trim_smithing_template.new": "هياسن زيره ݢوموق",
  "item.minecraft.echo_shard": "بليڠ ݢماٴن",
  "item.minecraft.egg": "تلور",
  "item.minecraft.elder_guardian_spawn_egg": "تلور ڤنجلماٴن ڤڠݢاوا ڤنجاݢ",
  "item.minecraft.elytra": "ايليترا",
  "item.minecraft.emerald": "زمرود",
  "item.minecraft.enchanted_book": "بوکو ترسيحير",
  "item.minecraft.enchanted_golden_apple": "ايڤل امس ترسيحير",
  "item.minecraft.end_crystal": "کريستل ٴين‌د",
  "item.minecraft.ender_dragon_spawn_egg": "تلور ڤنجلماٴن ناݢ ٴيندر",
  "item.minecraft.ender_eye": "مات ٴيندر",
  "item.minecraft.ender_pearl": "موتيارا ٴين‌د",
  "item.minecraft.enderman_spawn_egg": "تلور ڤنجلماٴن ٴيندرمن",
  "item.minecraft.endermite_spawn_egg": "تلور ڤنجلماٴن ٴيندرماٴيت",
  "item.minecraft.evoker_spawn_egg": "تلور ڤنجلماٴن ڤاوڠ",
  "item.minecraft.experience_bottle": "بوتول برايسي ڤڽيحيرن",
  "item.minecraft.explorer_pottery_shard": "بليڠ تمبيکر ڤنجلاجه",
  "item.minecraft.explorer_pottery_sherd": "بليڠ تمبيکر ڤنجلاجه",
  "item.minecraft.eye_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.eye_armor_trim_smithing_template.new": "هياسن زيره مات",
  "item.minecraft.feather": "بولو ڤلاڤه",
  "item.minecraft.fermented_spider_eye": "مات لابه٢ دتاڤاي",
  "item.minecraft.field_masoned_banner_pattern": "چورق ڤنجي باتاٴن",
  "item.minecraft.filled_map": "ڤتا",
  "item.minecraft.fire_charge": "ببولا اڤي",
  "item.minecraft.firework_rocket": "روکيت بوڠا اڤي",
  "item.minecraft.firework_rocket.flight": "تيمڤوه ڤنربڠن:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "بينتڠ بوڠا اڤي",
  "item.minecraft.firework_star.black": "هيتم",
  "item.minecraft.firework_star.blue": "بيرو",
  "item.minecraft.firework_star.brown": "ڤيرڠ",
  "item.minecraft.firework_star.custom_color": "ترسواي",
  "item.minecraft.firework_star.cyan": "سيان",
  "item.minecraft.firework_star.fade_to": "ڤودر منجادي",
  "item.minecraft.firework_star.flicker": "سينر",
  "item.minecraft.firework_star.gray": "کلابو",
  "item.minecraft.firework_star.green": "هيجاو",
  "item.minecraft.firework_star.light_blue": "بيرو مودا",
  "item.minecraft.firework_star.light_gray": "کلابو مودا",
  "item.minecraft.firework_star.lime": "ميجاو مودا",
  "item.minecraft.firework_star.magenta": "ماݢينتا",
  "item.minecraft.firework_star.orange": "جيڠݢ",
  "item.minecraft.firework_star.pink": "ميره جمبو",
  "item.minecraft.firework_star.purple": "اوڠو",
  "item.minecraft.firework_star.red": "ميره",
  "item.minecraft.firework_star.shape": "بنتوق تق دکتاهوءي",
  "item.minecraft.firework_star.shape.burst": "ملتوڤ",
  "item.minecraft.firework_star.shape.creeper": "بربنتوق کريڤر",
  "item.minecraft.firework_star.shape.large_ball": "ببولا بسر",
  "item.minecraft.firework_star.shape.small_ball": "ببولا هالوس",
  "item.minecraft.firework_star.shape.star": "بربنتوق بينتڠ",
  "item.minecraft.firework_star.trail": "ججق",
  "item.minecraft.firework_star.white": "ڤوتيه",
  "item.minecraft.firework_star.yellow": "کونيڠ",
  "item.minecraft.fishing_rod": "جورن",
  "item.minecraft.flint": "باتو اڤي",
  "item.minecraft.flint_and_steel": "ڤمتيق اڤي",
  "item.minecraft.flow_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.flow_armor_trim_smithing_template.new": "هياسن زيره اليرن",
  "item.minecraft.flow_banner_pattern": "چورق ڤنجي",
  "item.minecraft.flow_banner_pattern.desc": "اليرن",
  "item.minecraft.flow_banner_pattern.new": "چورق ڤنجي اليرن",
  "item.minecraft.flow_pottery_sherd": "بليڠ تمبيکر اليرن",
  "item.minecraft.flower_banner_pattern": "چورق ڤنجي",
  "item.minecraft.flower_banner_pattern.desc": "لامبڠ بوڠا",
  "item.minecraft.flower_banner_pattern.new": "چورق ڤنجي لامبڠ بوڠا",
  "item.minecraft.flower_pot": "ڤاسو بوڠا",
  "item.minecraft.fox_spawn_egg": "تلور ڤنجلماٴن روبه",
  "item.minecraft.friend_pottery_shard": "بليڠ تمبيکر راکن",
  "item.minecraft.friend_pottery_sherd": "بليڠ تمبيکر راکن",
  "item.minecraft.frog_spawn_egg": "تلور ڤنجلماٴن کاتق",
  "item.minecraft.furnace_minecart": "کريتا لومبوڠ دڠن رلاو",
  "item.minecraft.ghast_spawn_egg": "تلور ڤنجلماٴن ݢس‌ت",
  "item.minecraft.ghast_tear": "اٴير مات ݢس‌ت",
  "item.minecraft.glass_bottle": "بوتول کاچ",
  "item.minecraft.glistering_melon_slice": "ڤوتوڠن تمبيکاي برکيلاوان",
  "item.minecraft.globe_banner_pattern": "چورق ڤنجي",
  "item.minecraft.globe_banner_pattern.desc": "ݢلوب",
  "item.minecraft.globe_banner_pattern.new": "چورق ڤنجي ݢلوب",
  "item.minecraft.glow_berries": "بري برسينر",
  "item.minecraft.glow_ink_sac": "ڤوندي دعوت برسينر",
  "item.minecraft.glow_item_frame": "بيڠکاي اٴيتم برسينر",
  "item.minecraft.glow_squid_spawn_egg": "تلور ڤنجلماٴن سوتوڠ برسينر",
  "item.minecraft.glowstone_dust": "سربوق باتو مڽالا",
  "item.minecraft.goat_horn": "تندوق کمبيڠ",
  "item.minecraft.goat_spawn_egg": "تلور ڤنجلماٴن کمبيڠ",
  "item.minecraft.gold_ingot": "جوڠکوڠ امس",
  "item.minecraft.gold_nugget": "نوݢت امس",
  "item.minecraft.golden_apple": "ايڤل امس",
  "item.minecraft.golden_axe": "کاڤق امس",
  "item.minecraft.golden_boots": "بوت امس",
  "item.minecraft.golden_carrot": "لوبق امس",
  "item.minecraft.golden_chestplate": "زيره دادا امس",
  "item.minecraft.golden_helmet": "کتوڤوڠ امس",
  "item.minecraft.golden_hoe": "چڠکول امس",
  "item.minecraft.golden_horse_armor": "زيره کودا امس",
  "item.minecraft.golden_leggings": "زيره کاکي امس",
  "item.minecraft.golden_nautilus_armor": "زيره ݢيڠݢيڠ امس",
  "item.minecraft.golden_pickaxe": "بليوڠ امس",
  "item.minecraft.golden_shovel": "ڤڽودوق امس",
  "item.minecraft.golden_spear": "تومبق امس",
  "item.minecraft.golden_sword": "ڤدڠ امس",
  "item.minecraft.gray_bundle": "ݢوني کلابو",
  "item.minecraft.gray_dye": "ڤورنا کلابو",
  "item.minecraft.gray_harness": "سيلا کلابو",
  "item.minecraft.green_bundle": "ݢوني هيجاو",
  "item.minecraft.green_dye": "ڤورنا هيجاو",
  "item.minecraft.green_harness": "سيلا هيجاو",
  "item.minecraft.guardian_spawn_egg": "تلور ڤنجلماٴن ڤنجاݢ",
  "item.minecraft.gunpowder": "سربوق لتوڤن",
  "item.minecraft.guster_banner_pattern": "چورق ڤنجي",
  "item.minecraft.guster_banner_pattern.desc": "ڤموسر",
  "item.minecraft.guster_banner_pattern.new": "چورق ڤنجي ڤموسر",
  "item.minecraft.guster_pottery_sherd": "بليڠ تمبيکر ڤموسر",
  "item.minecraft.happy_ghast_spawn_egg": "تلور ڤنجلماٴن ݢس‌ت ݢيرڠ",
  "item.minecraft.harness": "سيلا",
  "item.minecraft.heart_of_the_sea": "جيوا لاٴوت",
  "item.minecraft.heart_pottery_shard": "بليڠ تمبيکر هاتي",
  "item.minecraft.heart_pottery_sherd": "بليڠ تمبيکر هاتي",
  "item.minecraft.heartbreak_pottery_shard": "بليڠ تمبيکر ڤاته",
  "item.minecraft.heartbreak_pottery_sherd": "بليڠ تمبيکر ڤاته",
  "item.minecraft.hoglin_spawn_egg": "تلور ڤنجلماٴن هوݢلين",
  "item.minecraft.honey_bottle": "بوتول مادو",
  "item.minecraft.honeycomb": "ايندوڠ مادو",
  "item.minecraft.hopper_minecart": "کريتا لومبوڠ دڠن چوروڠ تواڠ",
  "item.minecraft.horse_spawn_egg": "تلور ڤنجلماٴن کودا",
  "item.minecraft.host_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.host_armor_trim_smithing_template.new": "هياسن زيره ڤرومه",
  "item.minecraft.howl_pottery_shard": "بليڠ تمبيکر دروان",
  "item.minecraft.howl_pottery_sherd": "بليڠ تمبيکر دروان",
  "item.minecraft.husk_spawn_egg": "تلور ڤنجلماٴن رڤوتن",
  "item.minecraft.ink_sac": "ڤوندي دعوت",
  "item.minecraft.iron_axe": "کاڤق بسي",
  "item.minecraft.iron_boots": "بوت بسي",
  "item.minecraft.iron_chestplate": "زيره دادا بسي",
  "item.minecraft.iron_golem_spawn_egg": "تلور ڤنجلماٴن ݢولم بسي",
  "item.minecraft.iron_helmet": "کتوڤوڠ بسي",
  "item.minecraft.iron_hoe": "چڠکول بسي",
  "item.minecraft.iron_horse_armor": "زيره کودا بسي",
  "item.minecraft.iron_ingot": "جوڠکوڠ بسي",
  "item.minecraft.iron_leggings": "زيره کاکي بسي",
  "item.minecraft.iron_nautilus_armor": "زيره ݢيڠݢيڠ بسي",
  "item.minecraft.iron_nugget": "نوݢت بسي",
  "item.minecraft.iron_pickaxe": "بليوڠ بسي",
  "item.minecraft.iron_shovel": "ڤڽودوق بسي",
  "item.minecraft.iron_spear": "تومبق بسي",
  "item.minecraft.iron_sword": "ڤدڠ بسي",
  "item.minecraft.item_frame": "بيڠکاي اٴيتم",
  "item.minecraft.jungle_boat": "سمڤن ريمبا",
  "item.minecraft.jungle_chest_boat": "سمڤن ريمبا دڠن ڤتي",
  "item.minecraft.knowledge_book": "بوکو علمو",
  "item.minecraft.lapis_lazuli": "لاڤيس لازولي",
  "item.minecraft.lava_bucket": "بلدي لاهر",
  "item.minecraft.lead": "تالي ڤڠيکت",
  "item.minecraft.leather": "کوليت",
  "item.minecraft.leather_boots": "بوت کوليت",
  "item.minecraft.leather_chestplate": "باجو کوليت",
  "item.minecraft.leather_helmet": "توڤي کوليت",
  "item.minecraft.leather_horse_armor": "زيره کودا کوليت",
  "item.minecraft.leather_leggings": "سلوار کوليت",
  "item.minecraft.light_blue_bundle": "ݢوني بيرو مودا",
  "item.minecraft.light_blue_dye": "ڤورنا بيرو مودا",
  "item.minecraft.light_blue_harness": "سيلا بيرو مودا",
  "item.minecraft.light_gray_bundle": "ݢوني کلابو مودا",
  "item.minecraft.light_gray_dye": "ڤورنا کلابو مودا",
  "item.minecraft.light_gray_harness": "سيلا کلابو مودا",
  "item.minecraft.lime_bundle": "ݢوني هيجاو مودا",
  "item.minecraft.lime_dye": "ڤورنا هيجاو مودا",
  "item.minecraft.lime_harness": "سيلا هيجاو مودا",
  "item.minecraft.lingering_potion": "ڤوشن برلاروتن",
  "item.minecraft.lingering_potion.effect.awkward": "ڤوشن برلاروتن جڠݢل",
  "item.minecraft.lingering_potion.effect.empty": "ڤوشن برلاروتن يڠ تيدق بوليه دتوکڠ",
  "item.minecraft.lingering_potion.effect.fire_resistance": "ڤوشن برلاروتن ڤڠاليسن اڤي",
  "item.minecraft.lingering_potion.effect.harming": "ڤوشن برلاروتن ڤڽاکيتن",
  "item.minecraft.lingering_potion.effect.healing": "ڤوشن برلاروتن ڤڽمبوهن",
  "item.minecraft.lingering_potion.effect.infested": "ڤوشن برلاروتن ڤڠموتن",
  "item.minecraft.lingering_potion.effect.invisibility": "ڤوشن برلاروتن ڤڠهليمونن",
  "item.minecraft.lingering_potion.effect.leaping": "ڤوشن برلاروتن ڤلومڤتن",
  "item.minecraft.lingering_potion.effect.levitation": "ڤوشن برلاروتن ڤڠاڤوڠن",
  "item.minecraft.lingering_potion.effect.luck": "ڤوشن برلاروتن برنصيب",
  "item.minecraft.lingering_potion.effect.mundane": "ڤوشن برلاروتن بياسا",
  "item.minecraft.lingering_potion.effect.night_vision": "ڤوشن برلاروتن ڤڠليهتن مالم",
  "item.minecraft.lingering_potion.effect.oozing": "ڤوشن برلاروتن ڤليليهن",
  "item.minecraft.lingering_potion.effect.poison": "ڤوشن برلاروتن کراچونن",
  "item.minecraft.lingering_potion.effect.regeneration": "ڤوشن برلاروتن ڤموليهن",
  "item.minecraft.lingering_potion.effect.slow_falling": "ڤوشن برلاروتن کجاتوهن لمبت",
  "item.minecraft.lingering_potion.effect.slowness": "کلمبتن",
  "item.minecraft.lingering_potion.effect.strength": "ڤوشن برلاروتن کقواتن",
  "item.minecraft.lingering_potion.effect.swiftness": "ڤوشن برلاروتن کلاجوان",
  "item.minecraft.lingering_potion.effect.thick": "ڤوشن برلاروتن تبل",
  "item.minecraft.lingering_potion.effect.turtle_master": "ڤوشن برلاروتن جوروڤڽو",
  "item.minecraft.lingering_potion.effect.water": "بوتول ڤوشن برلاروتن",
  "item.minecraft.lingering_potion.effect.water_breathing": "ڤوشن برلاروتن ڤرنفسن اٴير",
  "item.minecraft.lingering_potion.effect.weakness": "ڤوشن برلاروتن کلمهن",
  "item.minecraft.lingering_potion.effect.weaving": "ڤوشن برلاروتن ڤڠاڽمن",
  "item.minecraft.lingering_potion.effect.wind_charged": "ڤوشن برلاروتن ڤموسر اودارا",
  "item.minecraft.llama_spawn_egg": "تلور ڤنجلماٴن لاما",
  "item.minecraft.lodestone_compass": "کومڤس باتو مݢنيت",
  "item.minecraft.mace": "چوقمر",
  "item.minecraft.magenta_bundle": "ݢوني ماݢينتا",
  "item.minecraft.magenta_dye": "ڤورنا ماݢينتا",
  "item.minecraft.magenta_harness": "سيلا ماݢينتا",
  "item.minecraft.magma_cream": "کريم مݢما",
  "item.minecraft.magma_cube_spawn_egg": "تلور ڤنجلماٴن کيوب مݢما",
  "item.minecraft.mangrove_boat": "سمڤن باکاو",
  "item.minecraft.mangrove_chest_boat": "سمڤن باکاو دڠن ڤتي",
  "item.minecraft.map": "ڤتا کوسوڠ",
  "item.minecraft.melon_seeds": "بنيه تمبيکاي",
  "item.minecraft.melon_slice": "هيريسن تمبيکاي",
  "item.minecraft.milk_bucket": "بلدي سوسو",
  "item.minecraft.minecart": "کريتا لومبوڠ",
  "item.minecraft.miner_pottery_shard": "بليڠ تمبيکر ڤلومبوڠ",
  "item.minecraft.miner_pottery_sherd": "بليڠ تمبيکر ڤلومبوڠ",
  "item.minecraft.mojang_banner_pattern": "چورق ڤنجي",
  "item.minecraft.mojang_banner_pattern.desc": "بندا",
  "item.minecraft.mojang_banner_pattern.new": "چورق ڤنجي بندا",
  "item.minecraft.mooshroom_spawn_egg": "تلور ڤنجلماٴن موشروم",
  "item.minecraft.mourner_pottery_shard": "بليڠ تمبيکر راتڤن",
  "item.minecraft.mourner_pottery_sherd": "بليڠ تمبيکر راتڤن",
  "item.minecraft.mule_spawn_egg": "تلور ڤنجلماٴن بغل",
  "item.minecraft.mushroom_stew": "ستو چنداون",
  "item.minecraft.music_disc_11": "چکرا موزيک",
  "item.minecraft.music_disc_11.desc": "11 - C418",
  "item.minecraft.music_disc_13": "چکرا موزيک",
  "item.minecraft.music_disc_13.desc": "13 - C418",
  "item.minecraft.music_disc_5": "چکرا موزيک",
  "item.minecraft.music_disc_5.desc": "ساموئل اوبرج - 5",
  "item.minecraft.music_disc_blocks": "چکرا موزيک",
  "item.minecraft.music_disc_blocks.desc": "blocks - C418",
  "item.minecraft.music_disc_cat": "چکرا موزيک",
  "item.minecraft.music_disc_cat.desc": "cat - C418",
  "item.minecraft.music_disc_chirp": "چکرا موزيک",
  "item.minecraft.music_disc_chirp.desc": "chirp - C418",
  "item.minecraft.music_disc_creator": "چکرا موزيک",
  "item.minecraft.music_disc_creator.desc": "لينا رين - Creator",
  "item.minecraft.music_disc_creator_music_box": "چکرا موزيک",
  "item.minecraft.music_disc_creator_music_box.desc": "لينا رين - Creator (کوتق موزيک)",
  "item.minecraft.music_disc_far": "چکرا موزيک",
  "item.minecraft.music_disc_far.desc": "far - C418",
  "item.minecraft.music_disc_lava_chicken": "چکرا موزيک",
  "item.minecraft.music_disc_lava_chicken.desc": "هايڤر ڤوشن‌س - Lava Chicken",
  "item.minecraft.music_disc_mall": "چکرا موزيک",
  "item.minecraft.music_disc_mall.desc": "mall - C418",
  "item.minecraft.music_disc_mellohi": "چکرا موزيک",
  "item.minecraft.music_disc_mellohi.desc": "mellohi - C418",
  "item.minecraft.music_disc_otherside": "چکرا موزيک",
  "item.minecraft.music_disc_otherside.desc": "لينا رين - otherside",
  "item.minecraft.music_disc_pigstep": "چکرا موزيک",
  "item.minecraft.music_disc_pigstep.desc": "لينا رين - Pigstep",
  "item.minecraft.music_disc_precipice": "چکرا موزيک",
  "item.minecraft.music_disc_precipice.desc": "ايرن چيروف - Precipice",
  "item.minecraft.music_disc_relic": "چکرا موزيک",
  "item.minecraft.music_disc_relic.desc": "ايرن چيروف - Relic",
  "item.minecraft.music_disc_stal": "چکرا موزيک",
  "item.minecraft.music_disc_stal.desc": "stal - C418",
  "item.minecraft.music_disc_strad": "چکرا موزيک",
  "item.minecraft.music_disc_strad.desc": "strad - C418",
  "item.minecraft.music_disc_tears": "چکرا موزيک",
  "item.minecraft.music_disc_tears.desc": "اموس رودي - Tears",
  "item.minecraft.music_disc_wait": "چکرا موزيک",
  "item.minecraft.music_disc_wait.desc": "wait - C418",
  "item.minecraft.music_disc_ward": "چکرا موزيک",
  "item.minecraft.music_disc_ward.desc": "ward - C418",
  "item.minecraft.mutton": "داݢيڠ بيري٢ منته",
  "item.minecraft.name_tag": "تݢ نام",
  "item.minecraft.nautilus_shell": "چڠکرڠ ݢيڠݢيڠ",
  "item.minecraft.nautilus_spawn_egg": "تلور ڤنجلماٴن ݢيڠݢيڠ",
  "item.minecraft.nether_brick": "بات نيذر",
  "item.minecraft.nether_star": "بينتڠ نيذر",
  "item.minecraft.nether_wart": "کتوات نيذر",
  "item.minecraft.netherite_axe": "کاڤق نيذريت",
  "item.minecraft.netherite_boots": "بوت نيذريت",
  "item.minecraft.netherite_chestplate": "زيره دادا نيذريت",
  "item.minecraft.netherite_helmet": "کتوڤوڠ نيذريت",
  "item.minecraft.netherite_hoe": "چڠکول نيذريت",
  "item.minecraft.netherite_horse_armor": "زيره کودا نيذريت",
  "item.minecraft.netherite_ingot": "جوڠکوڠ نيذريت",
  "item.minecraft.netherite_leggings": "زيره کاکي نيذريت",
  "item.minecraft.netherite_nautilus_armor": "زيره ݢيڠݢيڠ نيذريت",
  "item.minecraft.netherite_pickaxe": "بليوڠ نيذريت",
  "item.minecraft.netherite_scrap": "سکرڤ نيذريت",
  "item.minecraft.netherite_shovel": "ڤڽودوق نيذريت",
  "item.minecraft.netherite_spear": "تومبق نيذريت",
  "item.minecraft.netherite_sword": "ڤدڠ نيذريت",
  "item.minecraft.netherite_upgrade_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.netherite_upgrade_smithing_template.new": "ناٴيق طرف نيذريت",
  "item.minecraft.oak_boat": "سمڤن اوک",
  "item.minecraft.oak_chest_boat": "سمڤن اوک دڠن ڤتي",
  "item.minecraft.ocelot_spawn_egg": "تلور ڤنجلماٴن هريماو اوسلوت",
  "item.minecraft.ominous_bottle": "بوتول مڠريکن",
  "item.minecraft.ominous_trial_key": "کونچي اوجين مڠريکن",
  "item.minecraft.orange_bundle": "ݢوني جيڠݢ",
  "item.minecraft.orange_dye": "ڤورنا جيڠݢ",
  "item.minecraft.orange_harness": "سيلا جيڠݢ",
  "item.minecraft.painting": "لوکيسن",
  "item.minecraft.pale_oak_boat": "سمڤن اوک کمسي",
  "item.minecraft.pale_oak_chest_boat": "سمڤن اوک کمسي دڠن ڤتي",
  "item.minecraft.panda_spawn_egg": "تلور ڤنجلماٴن ڤندا",
  "item.minecraft.paper": "کرتس",
  "item.minecraft.parched_spawn_egg": "تلور ڤنجلماٴن کريڠن",
  "item.minecraft.parrot_spawn_egg": "تلور ڤنجلماٴن بوروڠ نوري",
  "item.minecraft.phantom_membrane": "ممبرن خيالن",
  "item.minecraft.phantom_spawn_egg": "تلور ڤنجلماٴن خيالن",
  "item.minecraft.pig_spawn_egg": "تلور ڤنجلماٴن خنزير",
  "item.minecraft.piglin_banner_pattern": "چورق ڤنجي",
  "item.minecraft.piglin_banner_pattern.desc": "مونچوڠ",
  "item.minecraft.piglin_banner_pattern.new": "چورق ڤنجي مونچوڠ",
  "item.minecraft.piglin_brute_spawn_egg": "تلور ڤنجلماٴن ڤيݢلين ݢانس",
  "item.minecraft.piglin_spawn_egg": "تلور ڤنجلماٴن ڤيݢلين",
  "item.minecraft.pillager_spawn_egg": "تلور ڤنجلماٴن ڤنجاره",
  "item.minecraft.pink_bundle": "ݢوني ميره جمبو",
  "item.minecraft.pink_dye": "ڤورنا ميره جمبو",
  "item.minecraft.pink_harness": "سيلا ميره جمبو",
  "item.minecraft.pitcher_plant": "ڤريوق کرا",
  "item.minecraft.pitcher_pod": "لڠݢاي ڤريوق کرا",
  "item.minecraft.plenty_pottery_shard": "بليڠ تمبيکر ککاياٴن",
  "item.minecraft.plenty_pottery_sherd": "بليڠ تمبيکر ککاياٴن",
  "item.minecraft.poisonous_potato": "کنتڠ براچون",
  "item.minecraft.polar_bear_spawn_egg": "تلور ڤنجلماٴن برواڠ قطب",
  "item.minecraft.popped_chorus_fruit": "برتيه بواه کوروس",
  "item.minecraft.porkchop": "داݢيڠ خنزير منته",
  "item.minecraft.potato": "کنتڠ",
  "item.minecraft.potion": "ڤوشن",
  "item.minecraft.potion.effect.awkward": "ڤوشن جڠݢل",
  "item.minecraft.potion.effect.empty": "ڤوشن يڠ تيدق بوليه دتوکڠ",
  "item.minecraft.potion.effect.fire_resistance": "ڤوشن ڤڠاليس اڤي",
  "item.minecraft.potion.effect.harming": "ڤوشن ڤڽاکيتن",
  "item.minecraft.potion.effect.healing": "ڤوشن ڤڽمبوهن",
  "item.minecraft.potion.effect.infested": "ڤوشن ڤڠموتن",
  "item.minecraft.potion.effect.invisibility": "ڤوشن ڤڠهليمونن",
  "item.minecraft.potion.effect.leaping": "ڤوشن ڤلومڤتن",
  "item.minecraft.potion.effect.levitation": "ڤوشن ڤڠاڤوڠن",
  "item.minecraft.potion.effect.luck": "ڤوشن برنصيب",
  "item.minecraft.potion.effect.mundane": "ڤوشن بياسا",
  "item.minecraft.potion.effect.night_vision": "ڤوشن ڤڠليهتن مالم",
  "item.minecraft.potion.effect.oozing": "ڤوشن ڤليليهن",
  "item.minecraft.potion.effect.poison": "ڤوشن کراچونن",
  "item.minecraft.potion.effect.regeneration": "ڤوشن ڤموليهن",
  "item.minecraft.potion.effect.slow_falling": "ڤوشن کجاتوهن لمبت",
  "item.minecraft.potion.effect.slowness": "ڤوشن کلمبتن",
  "item.minecraft.potion.effect.strength": "ڤوشن کقواتن",
  "item.minecraft.potion.effect.swiftness": "ڤوشن کلاجوان",
  "item.minecraft.potion.effect.thick": "ڤوشن تبل",
  "item.minecraft.potion.effect.turtle_master": "ڤوشن جوروڤڽو",
  "item.minecraft.potion.effect.water": "بوتول اٴير",
  "item.minecraft.potion.effect.water_breathing": "ڤوشن ڤرنفسن اٴير",
  "item.minecraft.potion.effect.weakness": "ڤوشن کلمهن",
  "item.minecraft.potion.effect.weaving": "ڤوشن ڤڠاڽمن",
  "item.minecraft.potion.effect.wind_charged": "ڤوشن ڤموسر اودارا",
  "item.minecraft.pottery_shard_archer": "بليڠ تمبيکر ڤمانه",
  "item.minecraft.pottery_shard_arms_up": "بليڠ تمبيکر اڠکت تاڠن",
  "item.minecraft.pottery_shard_prize": "بليڠ تمبيکر هديه",
  "item.minecraft.pottery_shard_skull": "بليڠ تمبيکر تڠکورق",
  "item.minecraft.powder_snow_bucket": "بلدي سلجي سربوق",
  "item.minecraft.prismarine_crystals": "کريستل ڤريسمارين",
  "item.minecraft.prismarine_shard": "بليڠ ڤريسمارين",
  "item.minecraft.prize_pottery_shard": "بليڠ تمبيکر هديه",
  "item.minecraft.prize_pottery_sherd": "بليڠ تمبيکر هديه",
  "item.minecraft.pufferfish": "ايکن بونتل",
  "item.minecraft.pufferfish_bucket": "بلدي ايکن بونتل",
  "item.minecraft.pufferfish_spawn_egg": "تلور ڤنجلماٴن ايکن بونتل",
  "item.minecraft.pumpkin_pie": "ڤي لابو",
  "item.minecraft.pumpkin_seeds": "بنيه لابو",
  "item.minecraft.purple_bundle": "ݢوني اوڠو",
  "item.minecraft.purple_dye": "ڤورنا اوڠو",
  "item.minecraft.purple_harness": "سيلا اوڠو",
  "item.minecraft.quartz": "کوارزا نيذر",
  "item.minecraft.rabbit": "ارنب منته",
  "item.minecraft.rabbit_foot": "کاکي ارنب",
  "item.minecraft.rabbit_hide": "کوليت ارنب",
  "item.minecraft.rabbit_spawn_egg": "تلور ڤنجلماٴن ارنب",
  "item.minecraft.rabbit_stew": "ستو ارنب",
  "item.minecraft.raiser_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "هياسن زيره ڤندوکوڠ",
  "item.minecraft.ravager_spawn_egg": "تلور ڤنجلماٴن ڤموسنه",
  "item.minecraft.raw_copper": "تمباݢ منته",
  "item.minecraft.raw_gold": "امس منته",
  "item.minecraft.raw_iron": "بسي منته",
  "item.minecraft.recovery_compass": "کومڤس ڤموليهن",
  "item.minecraft.red_bundle": "ݢوني ميره",
  "item.minecraft.red_dye": "ڤورنا ميره",
  "item.minecraft.red_harness": "سيلا ميره",
  "item.minecraft.redstone": "سربوق ريدستون",
  "item.minecraft.resin_brick": "بات دامر",
  "item.minecraft.resin_clump": "کتولن دامر",
  "item.minecraft.rib_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.rib_armor_trim_smithing_template.new": "هياسن زيره روسوق",
  "item.minecraft.rotten_flesh": "داݢيڠ رڤوت",
  "item.minecraft.saddle": "ڤلان",
  "item.minecraft.salmon": "سلمون منته",
  "item.minecraft.salmon_bucket": "بلدي سلمون",
  "item.minecraft.salmon_spawn_egg": "تلور ڤنجلماٴن سلمون",
  "item.minecraft.scrape_pottery_sherd": "بليڠ تمبيکر کيکيس",
  "item.minecraft.scute": "سکوت",
  "item.minecraft.sentry_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "هياسن زيره کاول",
  "item.minecraft.shaper_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "هياسن زيره ڤنجلما",
  "item.minecraft.sheaf_pottery_shard": "بليڠ تمبيکر برکس",
  "item.minecraft.sheaf_pottery_sherd": "بليڠ تمبيکر برکس",
  "item.minecraft.shears": "ڤموتوڠ",
  "item.minecraft.sheep_spawn_egg": "تلور ڤنجلماٴن بيري٢",
  "item.minecraft.shelter_pottery_shard": "بليڠ تمبيکر تدوهن",
  "item.minecraft.shelter_pottery_sherd": "بليڠ تمبيکر تدوهن",
  "item.minecraft.shield": "ڤريساي",
  "item.minecraft.shield.black": "ڤريساي هيتم",
  "item.minecraft.shield.blue": "ڤريساي بيرو",
  "item.minecraft.shield.brown": "ڤريساي ڤيرڠ",
  "item.minecraft.shield.cyan": "ڤريساي سيان",
  "item.minecraft.shield.gray": "ڤريساي کلابو",
  "item.minecraft.shield.green": "ڤريساي هيجاو",
  "item.minecraft.shield.light_blue": "ڤريساي بيرو مودا",
  "item.minecraft.shield.light_gray": "ڤريساي کلابو مودا",
  "item.minecraft.shield.lime": "ڤريساي هيجاو مودا",
  "item.minecraft.shield.magenta": "ڤريساي ماݢينتا",
  "item.minecraft.shield.orange": "ڤريساي جيڠݢ",
  "item.minecraft.shield.pink": "ڤريساي ميره جمبو",
  "item.minecraft.shield.purple": "ڤريساي اوڠو",
  "item.minecraft.shield.red": "ڤريساي ميره",
  "item.minecraft.shield.white": "ڤريساي ڤوتيه",
  "item.minecraft.shield.yellow": "ڤريساي کونيڠ",
  "item.minecraft.shulker_shell": "چڠکرڠ شلکر",
  "item.minecraft.shulker_spawn_egg": "تلور ڤنجلماٴن شلکر",
  "item.minecraft.sign": "ڤاڤن تندا",
  "item.minecraft.silence_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.silence_armor_trim_smithing_template.new": "هياسن زيره ديام",
  "item.minecraft.silverfish_spawn_egg": "تلور ڤنجلماٴن ݢݢت",
  "item.minecraft.skeleton_horse_spawn_egg": "تلور ڤنجلماٴن کودا کرڠک",
  "item.minecraft.skeleton_spawn_egg": "تلور ڤنجلماٴن کرڠک",
  "item.minecraft.skull_banner_pattern": "چورق ڤنجي",
  "item.minecraft.skull_banner_pattern.desc": "لامبڠ تڠکورق",
  "item.minecraft.skull_banner_pattern.new": "چورق ڤنجي لامبڠ تڠکورق",
  "item.minecraft.skull_pottery_shard": "بليڠ تمبيکر تڠکورق",
  "item.minecraft.skull_pottery_sherd": "بليڠ تمبيکر تڠکورق",
  "item.minecraft.slime_ball": "ببولا لندير",
  "item.minecraft.slime_spawn_egg": "تلور ڤنجلماٴن للندير",
  "item.minecraft.smithing_template": "تيمڤلت توکڠ بسي",
  "item.minecraft.smithing_template.applies_to": "بوليه دݢوناکن ڤد:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "تمبه جوڠکوڠ اتاو کريستل",
  "item.minecraft.smithing_template.armor_trim.applies_to": "زيره",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "تمبه زيره",
  "item.minecraft.smithing_template.armor_trim.ingredients": "جوڠکوڠ & کريستل",
  "item.minecraft.smithing_template.ingredients": "باهن٢:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "تمبه جوڠکوڠ نيذريت",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "کلڠکڤن برليان",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "تمبه زيره⹁ سنجات اتاو التن برليان",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "جوڠکوڠ نيذريت",
  "item.minecraft.smithing_template.upgrade": "ناٴيق طرف: ",
  "item.minecraft.sniffer_spawn_egg": "تلور ڤنجلماٴن ڤڠهيدو",
  "item.minecraft.snort_pottery_shard": "بليڠ تمبيکر هيدو",
  "item.minecraft.snort_pottery_sherd": "بليڠ تمبيکر هيدو",
  "item.minecraft.snout_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.snout_armor_trim_smithing_template.new": "هياسن زيره مونچوڠ",
  "item.minecraft.snow_golem_spawn_egg": "تلور ڤنجلماٴن ݢولم ثلجي",
  "item.minecraft.snowball": "بولا ثلجي",
  "item.minecraft.spectral_arrow": "انق ڤانه سڤيکترل",
  "item.minecraft.spider_eye": "مات لابه٢",
  "item.minecraft.spider_spawn_egg": "تلور ڤنجلماٴن لابه٢",
  "item.minecraft.spire_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.spire_armor_trim_smithing_template.new": "هياسن زيره چراچق",
  "item.minecraft.splash_potion": "ڤوشن ڤرچيقن",
  "item.minecraft.splash_potion.effect.awkward": "ڤوشن ڤرچيقن جڠݢل",
  "item.minecraft.splash_potion.effect.empty": "ڤوشن ڤرچيقن يڠ تيدق بوليه دتوکڠ",
  "item.minecraft.splash_potion.effect.fire_resistance": "ڤوشن ڤرچيقن ڤڠاليس اڤي",
  "item.minecraft.splash_potion.effect.harming": "ڤوشن ڤرچيقن ڤڽاکيتن",
  "item.minecraft.splash_potion.effect.healing": "ڤوشن ڤرچيقن ڤڽمبوهن",
  "item.minecraft.splash_potion.effect.infested": "ڤوشن ڤرچيقن ڤڠموتن",
  "item.minecraft.splash_potion.effect.invisibility": "ڤوشن ڤرچيقن ڤڠهليمونن",
  "item.minecraft.splash_potion.effect.leaping": "ڤوشن ڤرچيقن ڤلومڤتن",
  "item.minecraft.splash_potion.effect.levitation": "ڤوشن ڤرچيقن ڤڠاڤوڠن",
  "item.minecraft.splash_potion.effect.luck": "ڤوشن ڤرچيقن برنصيب",
  "item.minecraft.splash_potion.effect.mundane": "ڤوشن ڤرچيقن بياسا",
  "item.minecraft.splash_potion.effect.night_vision": "ڤوشن ڤرچيقن ڤڠليهتن مالم",
  "item.minecraft.splash_potion.effect.oozing": "ڤوشن ڤرچيقن ڤليليهن",
  "item.minecraft.splash_potion.effect.poison": "ڤوشن ڤرچيقن کراچونن",
  "item.minecraft.splash_potion.effect.regeneration": "ڤوشن ڤرچيقن ڤموليهن",
  "item.minecraft.splash_potion.effect.slow_falling": "ڤوشن ڤرچيقن کجاتوهن لمبت",
  "item.minecraft.splash_potion.effect.slowness": "ڤوشن ڤرچيقن کلمبتن",
  "item.minecraft.splash_potion.effect.strength": "ڤوشن ڤرچيقن کقواتن",
  "item.minecraft.splash_potion.effect.swiftness": "ڤوشن ڤرچيقن کلاجوان",
  "item.minecraft.splash_potion.effect.thick": "ڤوشن ڤرچيقن تبل",
  "item.minecraft.splash_potion.effect.turtle_master": "ڤوشن ڤرچيقن جوروڤڽو",
  "item.minecraft.splash_potion.effect.water": "بوتول اٴير ڤرچيقن",
  "item.minecraft.splash_potion.effect.water_breathing": "ڤوشن ڤرچيقن ڤرنفسن اٴير",
  "item.minecraft.splash_potion.effect.weakness": "ڤوشن ڤرچيقن کلمهن",
  "item.minecraft.splash_potion.effect.weaving": "ڤوشن ڤرچيقن ڤڠاڽمن",
  "item.minecraft.splash_potion.effect.wind_charged": "ڤوشن ڤرچيقن ڤموسر اودارا",
  "item.minecraft.spruce_boat": "سمڤن چمارا",
  "item.minecraft.spruce_chest_boat": "سمڤن چمارا دڠن ڤتي",
  "item.minecraft.spyglass": "تروڤوڠ کچيل",
  "item.minecraft.squid_spawn_egg": "تلور ڤنجلماٴن سوتوڠ",
  "item.minecraft.stick": "باتڠ کايو",
  "item.minecraft.stone_axe": "کاڤق باتو",
  "item.minecraft.stone_hoe": "چڠکول باتو",
  "item.minecraft.stone_pickaxe": "بليوڠ باتو",
  "item.minecraft.stone_shovel": "ڤڽودوق باتو",
  "item.minecraft.stone_spear": "تومبق باتو",
  "item.minecraft.stone_sword": "ڤدڠ باتو",
  "item.minecraft.stray_spawn_egg": "تلور ڤنجلماٴن ليارن",
  "item.minecraft.strider_spawn_egg": "تلور ڤنجلماٴن ڤرنتس",
  "item.minecraft.string": "تالي",
  "item.minecraft.sugar": "ݢولا",
  "item.minecraft.suspicious_stew": "ستو کسڠسين",
  "item.minecraft.sweet_berries": "بيري مانيس",
  "item.minecraft.tadpole_bucket": "بلدي برودو",
  "item.minecraft.tadpole_spawn_egg": "تلور ڤنجلماٴن برودو",
  "item.minecraft.tide_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.tide_armor_trim_smithing_template.new": "هياسن زيره اروس",
  "item.minecraft.tipped_arrow": "انق ڤانه دساڤو",
  "item.minecraft.tipped_arrow.effect.awkward": "انق ڤانه دساڤو",
  "item.minecraft.tipped_arrow.effect.empty": "انق ڤانه دساڤو يڠ تيدق بوليه دتوکڠ",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "انق ڤانه ڤڠاليس اڤي",
  "item.minecraft.tipped_arrow.effect.harming": "انق ڤانه ڤڽاکيتن",
  "item.minecraft.tipped_arrow.effect.healing": "انق ڤانه ڤڽمبوهن",
  "item.minecraft.tipped_arrow.effect.infested": "انق ڤانه ڤڠموتن",
  "item.minecraft.tipped_arrow.effect.invisibility": "انق ڤانه ڤڠهليمونن",
  "item.minecraft.tipped_arrow.effect.leaping": "انق ڤانه ڤلومڤتن",
  "item.minecraft.tipped_arrow.effect.levitation": "انق ڤانه ڤڠاڤوڠن",
  "item.minecraft.tipped_arrow.effect.luck": "انق ڤانه برنصيب",
  "item.minecraft.tipped_arrow.effect.mundane": "انق ڤانه دساڤو",
  "item.minecraft.tipped_arrow.effect.night_vision": "انق ڤانه ڤڠليهتن مالم",
  "item.minecraft.tipped_arrow.effect.oozing": "انق ڤانه ڤليليهن",
  "item.minecraft.tipped_arrow.effect.poison": "انق ڤانه براچون",
  "item.minecraft.tipped_arrow.effect.regeneration": "انق ڤانه ڤموليهن",
  "item.minecraft.tipped_arrow.effect.slow_falling": "انق ڤانه کجاتوهن لمبت",
  "item.minecraft.tipped_arrow.effect.slowness": "انق ڤانه کلمبتن",
  "item.minecraft.tipped_arrow.effect.strength": "انق ڤانه کقواتن",
  "item.minecraft.tipped_arrow.effect.swiftness": "انق ڤانه کلاجوان",
  "item.minecraft.tipped_arrow.effect.thick": "انق ڤانه دساڤو",
  "item.minecraft.tipped_arrow.effect.turtle_master": "انق ڤانه جوروڤڽو",
  "item.minecraft.tipped_arrow.effect.water": "انق ڤانه ڤرچيقن",
  "item.minecraft.tipped_arrow.effect.water_breathing": "انق ڤانه ڤرنفسن اٴير",
  "item.minecraft.tipped_arrow.effect.weakness": "انق ڤانه کلمهن",
  "item.minecraft.tipped_arrow.effect.weaving": "انق ڤانه ڤڠاڽمن",
  "item.minecraft.tipped_arrow.effect.wind_charged": "انق ڤانه ڤموسر اودارا",
  "item.minecraft.tnt_minecart": "کريتا لومبوڠ دڠن تي.عين.تي.",
  "item.minecraft.torchflower_seeds": "بنيه تڤوس اڤي",
  "item.minecraft.totem_of_undying": "توتم ابادي",
  "item.minecraft.trader_llama_spawn_egg": "تلور ڤنجلماٴن لاما ساوداݢر",
  "item.minecraft.trial_key": "کونچي اوجين",
  "item.minecraft.trident": "تريسولا",
  "item.minecraft.tropical_fish": "ايکن تروڤيکا",
  "item.minecraft.tropical_fish_bucket": "بلدي ايکن تروڤيکا",
  "item.minecraft.tropical_fish_spawn_egg": "تلور ڤنجلماٴن ايکن تروڤيکا",
  "item.minecraft.turtle_helmet": "کاراڤس ڤڽو",
  "item.minecraft.turtle_scute": "سکوت ڤڽو",
  "item.minecraft.turtle_spawn_egg": "تلور ڤنجلماٴن ڤڽو",
  "item.minecraft.vex_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.vex_armor_trim_smithing_template.new": "هياسن زيره ݢڠݢو",
  "item.minecraft.vex_spawn_egg": "تلور ڤنجلماٴن باجڠ",
  "item.minecraft.villager_spawn_egg": "تلور ڤنجلماٴن ڤندودوق کامڤوڠ",
  "item.minecraft.vindicator_spawn_egg": "تلور ڤنجلماٴن ڤمبيلا",
  "item.minecraft.wandering_trader_spawn_egg": "تلور ڤنجلماٴن ساوداݢر برکلان",
  "item.minecraft.ward_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.ward_armor_trim_smithing_template.new": "هياسن زيره جاݢ",
  "item.minecraft.warden_spawn_egg": "تلور ڤنجلماٴن ڤنوڠݢو",
  "item.minecraft.warped_fungus_on_a_stick": "کولت ݢيلا ڤد کايو",
  "item.minecraft.water_bucket": "بلدي اٴير",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "هياسن زيره ڤنروک",
  "item.minecraft.wheat": "ݢندوم",
  "item.minecraft.wheat_seeds": "بنيه ݢندوم",
  "item.minecraft.white_bundle": "ݢوني ڤوتيه",
  "item.minecraft.white_dye": "ڤورنا ڤوتيه",
  "item.minecraft.white_harness": "سيلا ڤوتيه",
  "item.minecraft.wild_armor_trim_smithing_template": "تمڤلت توکڠ بسي",
  "item.minecraft.wild_armor_trim_smithing_template.new": "هياسن زيره ليار",
  "item.minecraft.wind_charge": "ببولا اڠين",
  "item.minecraft.witch_spawn_egg": "تلور ڤنجلماٴن اهلي سيحير",
  "item.minecraft.wither_skeleton_spawn_egg": "تلور ڤنجلماٴن کرڠک ويذر",
  "item.minecraft.wither_spawn_egg": "تلور ڤنجلماٴن ويذر",
  "item.minecraft.wolf_armor": "زيره سريݢالا",
  "item.minecraft.wolf_spawn_egg": "تلور ڤنجلماٴن سريݢالا",
  "item.minecraft.wooden_axe": "کاڤق کايو",
  "item.minecraft.wooden_hoe": "چڠکول کايو",
  "item.minecraft.wooden_pickaxe": "بليوڠ کايو",
  "item.minecraft.wooden_shovel": "ڤڽودوق کايو",
  "item.minecraft.wooden_spear": "تومبق کايو",
  "item.minecraft.wooden_sword": "ڤدڠ کايو",
  "item.minecraft.writable_book": "بوکو دان بولو ڤلاڤه",
  "item.minecraft.written_book": "بوکو برتوليس",
  "item.minecraft.yellow_bundle": "ݢوني کونيڠ",
  "item.minecraft.yellow_dye": "ڤورنا کونيڠ",
  "item.minecraft.yellow_harness": "سيلا کونيڠ",
  "item.minecraft.zoglin_spawn_egg": "تلور ڤنجلماٴن زوݢلين",
  "item.minecraft.zombie_horse_spawn_egg": "تلور ڤنجلماٴن کودا زومبي",
  "item.minecraft.zombie_nautilus_spawn_egg": "تلور ڤنجلماٴن ݢيڠݢيڠ زومبي",
  "item.minecraft.zombie_spawn_egg": "تلور ڤنجلماٴن زومبي",
  "item.minecraft.zombie_villager_spawn_egg": "تلور ڤنجلماٴن زومبي ڤندودوق کامڤوڠ",
  "item.minecraft.zombified_piglin_spawn_egg": "تلور ڤنجلماٴن ڤيݢلين ترزومبي"
}
export const zlm_arab = items; 
